/*! For license information please see main.cd24e800.js.LICENSE.txt */
(() => {
    "use strict";
    var e = {
            730: (e2, n2, t2) => {
                var r2 = t2(43),
                    l2 = t2(853);

                function a2(e3) {
                    for (var n3 = "https://reactjs.org/docs/error-decoder.html?invariant=" + e3, t3 = 1; t3 < arguments.length; t3++) n3 += "&args[]=" + encodeURIComponent(arguments[t3]);
                    return "Minified React error #" + e3 + "; visit " + n3 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
                }
                var o2 = new Set,
                    i2 = {};

                function u2(e3, n3) {
                    s2(e3, n3), s2(e3 + "Capture", n3)
                }

                function s2(e3, n3) {
                    for (i2[e3] = n3, e3 = 0; e3 < n3.length; e3++) o2.add(n3[e3])
                }
                var c2 = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"),
                    d2 = Object.prototype.hasOwnProperty,
                    f = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
                    p = {},
                    h = {};

                function m(e3, n3, t3, r3, l3, a3, o3) {
                    this.acceptsBooleans = n3 === 2 || n3 === 3 || n3 === 4, this.attributeName = r3, this.attributeNamespace = l3, this.mustUseProperty = t3, this.propertyName = e3, this.type = n3, this.sanitizeURL = a3, this.removeEmptyString = o3
                }
                var g = {};
                "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e3) {
                    g[e3] = new m(e3, 0, !1, e3, null, !1, !1)
                }), [
                    ["acceptCharset", "accept-charset"],
                    ["className", "class"],
                    ["htmlFor", "for"],
                    ["httpEquiv", "http-equiv"]
                ].forEach(function(e3) {
                    var n3 = e3[0];
                    g[n3] = new m(n3, 1, !1, e3[1], null, !1, !1)
                }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e3) {
                    g[e3] = new m(e3, 2, !1, e3.toLowerCase(), null, !1, !1)
                }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e3) {
                    g[e3] = new m(e3, 2, !1, e3, null, !1, !1)
                }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e3) {
                    g[e3] = new m(e3, 3, !1, e3.toLowerCase(), null, !1, !1)
                }), ["checked", "multiple", "muted", "selected"].forEach(function(e3) {
                    g[e3] = new m(e3, 3, !0, e3, null, !1, !1)
                }), ["capture", "download"].forEach(function(e3) {
                    g[e3] = new m(e3, 4, !1, e3, null, !1, !1)
                }), ["cols", "rows", "size", "span"].forEach(function(e3) {
                    g[e3] = new m(e3, 6, !1, e3, null, !1, !1)
                }), ["rowSpan", "start"].forEach(function(e3) {
                    g[e3] = new m(e3, 5, !1, e3.toLowerCase(), null, !1, !1)
                });
                var v = /[\-:]([a-z])/g;

                function y(e3) {
                    return e3[1].toUpperCase()
                }

                function b(e3, n3, t3, r3) {
                    var l3 = g.hasOwnProperty(n3) ? g[n3] : null;
                    (l3 !== null ? l3.type !== 0 : r3 || !(2 < n3.length) || n3[0] !== "o" && n3[0] !== "O" || n3[1] !== "n" && n3[1] !== "N") && (function(e4, n4, t4, r4) {
                        if (n4 === null || typeof n4 > "u" || function(e5, n5, t5, r5) {
                                if (t5 !== null && t5.type === 0) return !1;
                                switch (typeof n5) {
                                    case "function":
                                    case "symbol":
                                        return !0;
                                    case "boolean":
                                        return !r5 && (t5 !== null ? !t5.acceptsBooleans : (e5 = e5.toLowerCase().slice(0, 5)) !== "data-" && e5 !== "aria-");
                                    default:
                                        return !1
                                }
                            }(e4, n4, t4, r4)) return !0;
                        if (r4) return !1;
                        if (t4 !== null) switch (t4.type) {
                            case 3:
                                return !n4;
                            case 4:
                                return n4 === !1;
                            case 5:
                                return isNaN(n4);
                            case 6:
                                return isNaN(n4) || 1 > n4
                        }
                        return !1
                    }(n3, t3, l3, r3) && (t3 = null), r3 || l3 === null ? function(e4) {
                        return !!d2.call(h, e4) || !d2.call(p, e4) && (f.test(e4) ? h[e4] = !0 : (p[e4] = !0, !1))
                    }(n3) && (t3 === null ? e3.removeAttribute(n3) : e3.setAttribute(n3, "" + t3)) : l3.mustUseProperty ? e3[l3.propertyName] = t3 === null ? l3.type !== 3 && "" : t3 : (n3 = l3.attributeName, r3 = l3.attributeNamespace, t3 === null ? e3.removeAttribute(n3) : (t3 = (l3 = l3.type) === 3 || l3 === 4 && t3 === !0 ? "" : "" + t3, r3 ? e3.setAttributeNS(r3, n3, t3) : e3.setAttribute(n3, t3))))
                }
                "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e3) {
                    var n3 = e3.replace(v, y);
                    g[n3] = new m(n3, 1, !1, e3, null, !1, !1)
                }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e3) {
                    var n3 = e3.replace(v, y);
                    g[n3] = new m(n3, 1, !1, e3, "http://www.w3.org/1999/xlink", !1, !1)
                }), ["xml:base", "xml:lang", "xml:space"].forEach(function(e3) {
                    var n3 = e3.replace(v, y);
                    g[n3] = new m(n3, 1, !1, e3, "http://www.w3.org/XML/1998/namespace", !1, !1)
                }), ["tabIndex", "crossOrigin"].forEach(function(e3) {
                    g[e3] = new m(e3, 1, !1, e3.toLowerCase(), null, !1, !1)
                }), g.xlinkHref = new m("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(e3) {
                    g[e3] = new m(e3, 1, !1, e3.toLowerCase(), null, !0, !0)
                });
                var w = r2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
                    k = Symbol.for("react.element"),
                    S = Symbol.for("react.portal"),
                    x = Symbol.for("react.fragment"),
                    E = Symbol.for("react.strict_mode"),
                    N = Symbol.for("react.profiler"),
                    C = Symbol.for("react.provider"),
                    _ = Symbol.for("react.context"),
                    z = Symbol.for("react.forward_ref"),
                    P = Symbol.for("react.suspense"),
                    L = Symbol.for("react.suspense_list"),
                    T = Symbol.for("react.memo"),
                    j = Symbol.for("react.lazy");
                Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
                var R = Symbol.for("react.offscreen");
                Symbol.for("react.legacy_hidden"), Symbol.for("react.cache"), Symbol.for("react.tracing_marker");
                var M = Symbol.iterator;

                function I(e3) {
                    return e3 === null || typeof e3 != "object" ? null : typeof(e3 = M && e3[M] || e3["@@iterator"]) == "function" ? e3 : null
                }
                var D, A = Object.assign;

                function F(e3) {
                    if (D === void 0) try {
                        throw Error()
                    } catch (t3) {
                        var n3 = t3.stack.trim().match(/\n( *(at )?)/);
                        D = n3 && n3[1] || ""
                    }
                    return `
` + D + e3
                }
                var O = !1;

                function U(e3, n3) {
                    if (!e3 || O) return "";
                    O = !0;
                    var t3 = Error.prepareStackTrace;
                    Error.prepareStackTrace = void 0;
                    try {
                        if (n3)
                            if (n3 = function() {
                                    throw Error()
                                }, Object.defineProperty(n3.prototype, "props", {
                                    set: function() {
                                        throw Error()
                                    }
                                }), typeof Reflect == "object" && Reflect.construct) {
                                try {
                                    Reflect.construct(n3, [])
                                } catch (s3) {
                                    var r3 = s3
                                }
                                Reflect.construct(e3, [], n3)
                            } else {
                                try {
                                    n3.call()
                                } catch (s3) {
                                    r3 = s3
                                }
                                e3.call(n3.prototype)
                            }
                        else {
                            try {
                                throw Error()
                            } catch (s3) {
                                r3 = s3
                            }
                            e3()
                        }
                    } catch (s3) {
                        if (s3 && r3 && typeof s3.stack == "string") {
                            for (var l3 = s3.stack.split(`
`), a3 = r3.stack.split(`
`), o3 = l3.length - 1, i3 = a3.length - 1; 1 <= o3 && 0 <= i3 && l3[o3] !== a3[i3];) i3--;
                            for (; 1 <= o3 && 0 <= i3; o3--, i3--)
                                if (l3[o3] !== a3[i3]) {
                                    if (o3 !== 1 || i3 !== 1)
                                        do
                                            if (o3--, 0 > --i3 || l3[o3] !== a3[i3]) {
                                                var u3 = `
` + l3[o3].replace(" at new ", " at ");
                                                return e3.displayName && u3.includes("<anonymous>") && (u3 = u3.replace("<anonymous>", e3.displayName)), u3
                                            } while (1 <= o3 && 0 <= i3);
                                    break
                                }
                        }
                    } finally {
                        O = !1, Error.prepareStackTrace = t3
                    }
                    return (e3 = e3 ? e3.displayName || e3.name : "") ? F(e3) : ""
                }

                function B(e3) {
                    switch (e3.tag) {
                        case 5:
                            return F(e3.type);
                        case 16:
                            return F("Lazy");
                        case 13:
                            return F("Suspense");
                        case 19:
                            return F("SuspenseList");
                        case 0:
                        case 2:
                        case 15:
                            return e3 = U(e3.type, !1);
                        case 11:
                            return e3 = U(e3.type.render, !1);
                        case 1:
                            return e3 = U(e3.type, !0);
                        default:
                            return ""
                    }
                }

                function W(e3) {
                    if (e3 == null) return null;
                    if (typeof e3 == "function") return e3.displayName || e3.name || null;
                    if (typeof e3 == "string") return e3;
                    switch (e3) {
                        case x:
                            return "Fragment";
                        case S:
                            return "Portal";
                        case N:
                            return "Profiler";
                        case E:
                            return "StrictMode";
                        case P:
                            return "Suspense";
                        case L:
                            return "SuspenseList"
                    }
                    if (typeof e3 == "object") switch (e3.$$typeof) {
                        case _:
                            return (e3.displayName || "Context") + ".Consumer";
                        case C:
                            return (e3._context.displayName || "Context") + ".Provider";
                        case z:
                            var n3 = e3.render;
                            return (e3 = e3.displayName) || (e3 = (e3 = n3.displayName || n3.name || "") !== "" ? "ForwardRef(" + e3 + ")" : "ForwardRef"), e3;
                        case T:
                            return (n3 = e3.displayName || null) !== null ? n3 : W(e3.type) || "Memo";
                        case j:
                            n3 = e3._payload, e3 = e3._init;
                            try {
                                return W(e3(n3))
                            } catch {}
                    }
                    return null
                }

                function V(e3) {
                    var n3 = e3.type;
                    switch (e3.tag) {
                        case 24:
                            return "Cache";
                        case 9:
                            return (n3.displayName || "Context") + ".Consumer";
                        case 10:
                            return (n3._context.displayName || "Context") + ".Provider";
                        case 18:
                            return "DehydratedFragment";
                        case 11:
                            return e3 = (e3 = n3.render).displayName || e3.name || "", n3.displayName || (e3 !== "" ? "ForwardRef(" + e3 + ")" : "ForwardRef");
                        case 7:
                            return "Fragment";
                        case 5:
                            return n3;
                        case 4:
                            return "Portal";
                        case 3:
                            return "Root";
                        case 6:
                            return "Text";
                        case 16:
                            return W(n3);
                        case 8:
                            return n3 === E ? "StrictMode" : "Mode";
                        case 22:
                            return "Offscreen";
                        case 12:
                            return "Profiler";
                        case 21:
                            return "Scope";
                        case 13:
                            return "Suspense";
                        case 19:
                            return "SuspenseList";
                        case 25:
                            return "TracingMarker";
                        case 1:
                        case 0:
                        case 17:
                        case 2:
                        case 14:
                        case 15:
                            if (typeof n3 == "function") return n3.displayName || n3.name || null;
                            if (typeof n3 == "string") return n3
                    }
                    return null
                }

                function H(e3) {
                    switch (typeof e3) {
                        case "boolean":
                        case "number":
                        case "string":
                        case "undefined":
                        case "object":
                            return e3;
                        default:
                            return ""
                    }
                }

                function Q(e3) {
                    var n3 = e3.type;
                    return (e3 = e3.nodeName) && e3.toLowerCase() === "input" && (n3 === "checkbox" || n3 === "radio")
                }

                function Y(e3) {
                    e3._valueTracker || (e3._valueTracker = function(e4) {
                        var n3 = Q(e4) ? "checked" : "value",
                            t3 = Object.getOwnPropertyDescriptor(e4.constructor.prototype, n3),
                            r3 = "" + e4[n3];
                        if (!e4.hasOwnProperty(n3) && typeof t3 < "u" && typeof t3.get == "function" && typeof t3.set == "function") {
                            var l3 = t3.get,
                                a3 = t3.set;
                            return Object.defineProperty(e4, n3, {
                                configurable: !0,
                                get: function() {
                                    return l3.call(this)
                                },
                                set: function(e5) {
                                    r3 = "" + e5, a3.call(this, e5)
                                }
                            }), Object.defineProperty(e4, n3, {
                                enumerable: t3.enumerable
                            }), {
                                getValue: function() {
                                    return r3
                                },
                                setValue: function(e5) {
                                    r3 = "" + e5
                                },
                                stopTracking: function() {
                                    e4._valueTracker = null, delete e4[n3]
                                }
                            }
                        }
                    }(e3))
                }

                function G(e3) {
                    if (!e3) return !1;
                    var n3 = e3._valueTracker;
                    if (!n3) return !0;
                    var t3 = n3.getValue(),
                        r3 = "";
                    return e3 && (r3 = Q(e3) ? e3.checked ? "true" : "false" : e3.value), (e3 = r3) !== t3 && (n3.setValue(e3), !0)
                }

                function $(e3) {
                    if (typeof(e3 = e3 || (typeof document < "u" ? document : void 0)) > "u") return null;
                    try {
                        return e3.activeElement || e3.body
                    } catch {
                        return e3.body
                    }
                }

                function X(e3, n3) {
                    var t3 = n3.checked;
                    return A({}, n3, {
                        defaultChecked: void 0,
                        defaultValue: void 0,
                        value: void 0,
                        checked: t3 ?? e3._wrapperState.initialChecked
                    })
                }

                function Z(e3, n3) {
                    var t3 = n3.defaultValue == null ? "" : n3.defaultValue,
                        r3 = n3.checked != null ? n3.checked : n3.defaultChecked;
                    t3 = H(n3.value != null ? n3.value : t3), e3._wrapperState = {
                        initialChecked: r3,
                        initialValue: t3,
                        controlled: n3.type === "checkbox" || n3.type === "radio" ? n3.checked != null : n3.value != null
                    }
                }

                function J(e3, n3) {
                    (n3 = n3.checked) != null && b(e3, "checked", n3, !1)
                }

                function q(e3, n3) {
                    J(e3, n3);
                    var t3 = H(n3.value),
                        r3 = n3.type;
                    if (t3 != null) r3 === "number" ? (t3 === 0 && e3.value === "" || e3.value != t3) && (e3.value = "" + t3) : e3.value !== "" + t3 && (e3.value = "" + t3);
                    else if (r3 === "submit" || r3 === "reset") return void e3.removeAttribute("value");
                    n3.hasOwnProperty("value") ? ee(e3, n3.type, t3) : n3.hasOwnProperty("defaultValue") && ee(e3, n3.type, H(n3.defaultValue)), n3.checked == null && n3.defaultChecked != null && (e3.defaultChecked = !!n3.defaultChecked)
                }

                function K(e3, n3, t3) {
                    if (n3.hasOwnProperty("value") || n3.hasOwnProperty("defaultValue")) {
                        var r3 = n3.type;
                        if (!(r3 !== "submit" && r3 !== "reset" || n3.value !== void 0 && n3.value !== null)) return;
                        n3 = "" + e3._wrapperState.initialValue, t3 || n3 === e3.value || (e3.value = n3), e3.defaultValue = n3
                    }(t3 = e3.name) !== "" && (e3.name = ""), e3.defaultChecked = !!e3._wrapperState.initialChecked, t3 !== "" && (e3.name = t3)
                }

                function ee(e3, n3, t3) {
                    n3 === "number" && $(e3.ownerDocument) === e3 || (t3 == null ? e3.defaultValue = "" + e3._wrapperState.initialValue : e3.defaultValue !== "" + t3 && (e3.defaultValue = "" + t3))
                }
                var ne = Array.isArray;

                function te(e3, n3, t3, r3) {
                    if (e3 = e3.options, n3) {
                        n3 = {};
                        for (var l3 = 0; l3 < t3.length; l3++) n3["$" + t3[l3]] = !0;
                        for (t3 = 0; t3 < e3.length; t3++) l3 = n3.hasOwnProperty("$" + e3[t3].value), e3[t3].selected !== l3 && (e3[t3].selected = l3), l3 && r3 && (e3[t3].defaultSelected = !0)
                    } else {
                        for (t3 = "" + H(t3), n3 = null, l3 = 0; l3 < e3.length; l3++) {
                            if (e3[l3].value === t3) return e3[l3].selected = !0, void(r3 && (e3[l3].defaultSelected = !0));
                            n3 !== null || e3[l3].disabled || (n3 = e3[l3])
                        }
                        n3 !== null && (n3.selected = !0)
                    }
                }

                function re(e3, n3) {
                    if (n3.dangerouslySetInnerHTML != null) throw Error(a2(91));
                    return A({}, n3, {
                        value: void 0,
                        defaultValue: void 0,
                        children: "" + e3._wrapperState.initialValue
                    })
                }

                function le(e3, n3) {
                    var t3 = n3.value;
                    if (t3 == null) {
                        if (t3 = n3.children, n3 = n3.defaultValue, t3 != null) {
                            if (n3 != null) throw Error(a2(92));
                            if (ne(t3)) {
                                if (1 < t3.length) throw Error(a2(93));
                                t3 = t3[0]
                            }
                            n3 = t3
                        }
                        n3 == null && (n3 = ""), t3 = n3
                    }
                    e3._wrapperState = {
                        initialValue: H(t3)
                    }
                }

                function ae(e3, n3) {
                    var t3 = H(n3.value),
                        r3 = H(n3.defaultValue);
                    t3 != null && ((t3 = "" + t3) !== e3.value && (e3.value = t3), n3.defaultValue == null && e3.defaultValue !== t3 && (e3.defaultValue = t3)), r3 != null && (e3.defaultValue = "" + r3)
                }

                function oe(e3) {
                    var n3 = e3.textContent;
                    n3 === e3._wrapperState.initialValue && n3 !== "" && n3 !== null && (e3.value = n3)
                }

                function ie(e3) {
                    switch (e3) {
                        case "svg":
                            return "http://www.w3.org/2000/svg";
                        case "math":
                            return "http://www.w3.org/1998/Math/MathML";
                        default:
                            return "http://www.w3.org/1999/xhtml"
                    }
                }

                function ue(e3, n3) {
                    return e3 == null || e3 === "http://www.w3.org/1999/xhtml" ? ie(n3) : e3 === "http://www.w3.org/2000/svg" && n3 === "foreignObject" ? "http://www.w3.org/1999/xhtml" : e3
                }
                var se, ce, de = (ce = function(e3, n3) {
                    if (e3.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e3) e3.innerHTML = n3;
                    else {
                        for ((se = se || document.createElement("div")).innerHTML = "<svg>" + n3.valueOf().toString() + "</svg>", n3 = se.firstChild; e3.firstChild;) e3.removeChild(e3.firstChild);
                        for (; n3.firstChild;) e3.appendChild(n3.firstChild)
                    }
                }, typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(e3, n3, t3, r3) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return ce(e3, n3)
                    })
                } : ce);

                function fe(e3, n3) {
                    if (n3) {
                        var t3 = e3.firstChild;
                        if (t3 && t3 === e3.lastChild && t3.nodeType === 3) return void(t3.nodeValue = n3)
                    }
                    e3.textContent = n3
                }
                var pe = {
                        animationIterationCount: !0,
                        aspectRatio: !0,
                        borderImageOutset: !0,
                        borderImageSlice: !0,
                        borderImageWidth: !0,
                        boxFlex: !0,
                        boxFlexGroup: !0,
                        boxOrdinalGroup: !0,
                        columnCount: !0,
                        columns: !0,
                        flex: !0,
                        flexGrow: !0,
                        flexPositive: !0,
                        flexShrink: !0,
                        flexNegative: !0,
                        flexOrder: !0,
                        gridArea: !0,
                        gridRow: !0,
                        gridRowEnd: !0,
                        gridRowSpan: !0,
                        gridRowStart: !0,
                        gridColumn: !0,
                        gridColumnEnd: !0,
                        gridColumnSpan: !0,
                        gridColumnStart: !0,
                        fontWeight: !0,
                        lineClamp: !0,
                        lineHeight: !0,
                        opacity: !0,
                        order: !0,
                        orphans: !0,
                        tabSize: !0,
                        widows: !0,
                        zIndex: !0,
                        zoom: !0,
                        fillOpacity: !0,
                        floodOpacity: !0,
                        stopOpacity: !0,
                        strokeDasharray: !0,
                        strokeDashoffset: !0,
                        strokeMiterlimit: !0,
                        strokeOpacity: !0,
                        strokeWidth: !0
                    },
                    he = ["Webkit", "ms", "Moz", "O"];

                function me(e3, n3, t3) {
                    return n3 == null || typeof n3 == "boolean" || n3 === "" ? "" : t3 || typeof n3 != "number" || n3 === 0 || pe.hasOwnProperty(e3) && pe[e3] ? ("" + n3).trim() : n3 + "px"
                }

                function ge(e3, n3) {
                    for (var t3 in e3 = e3.style, n3)
                        if (n3.hasOwnProperty(t3)) {
                            var r3 = t3.indexOf("--") === 0,
                                l3 = me(t3, n3[t3], r3);
                            t3 === "float" && (t3 = "cssFloat"), r3 ? e3.setProperty(t3, l3) : e3[t3] = l3
                        }
                }
                Object.keys(pe).forEach(function(e3) {
                    he.forEach(function(n3) {
                        n3 = n3 + e3.charAt(0).toUpperCase() + e3.substring(1), pe[n3] = pe[e3]
                    })
                });
                var ve = A({
                    menuitem: !0
                }, {
                    area: !0,
                    base: !0,
                    br: !0,
                    col: !0,
                    embed: !0,
                    hr: !0,
                    img: !0,
                    input: !0,
                    keygen: !0,
                    link: !0,
                    meta: !0,
                    param: !0,
                    source: !0,
                    track: !0,
                    wbr: !0
                });

                function ye(e3, n3) {
                    if (n3) {
                        if (ve[e3] && (n3.children != null || n3.dangerouslySetInnerHTML != null)) throw Error(a2(137, e3));
                        if (n3.dangerouslySetInnerHTML != null) {
                            if (n3.children != null) throw Error(a2(60));
                            if (typeof n3.dangerouslySetInnerHTML != "object" || !("__html" in n3.dangerouslySetInnerHTML)) throw Error(a2(61))
                        }
                        if (n3.style != null && typeof n3.style != "object") throw Error(a2(62))
                    }
                }

                function be(e3, n3) {
                    if (e3.indexOf("-") === -1) return typeof n3.is == "string";
                    switch (e3) {
                        case "annotation-xml":
                        case "color-profile":
                        case "font-face":
                        case "font-face-src":
                        case "font-face-uri":
                        case "font-face-format":
                        case "font-face-name":
                        case "missing-glyph":
                            return !1;
                        default:
                            return !0
                    }
                }
                var we = null;

                function ke(e3) {
                    return (e3 = e3.target || e3.srcElement || window).correspondingUseElement && (e3 = e3.correspondingUseElement), e3.nodeType === 3 ? e3.parentNode : e3
                }
                var Se = null,
                    xe = null,
                    Ee = null;

                function Ne(e3) {
                    if (e3 = bl(e3)) {
                        if (typeof Se != "function") throw Error(a2(280));
                        var n3 = e3.stateNode;
                        n3 && (n3 = kl(n3), Se(e3.stateNode, e3.type, n3))
                    }
                }

                function Ce(e3) {
                    xe ? Ee ? Ee.push(e3) : Ee = [e3] : xe = e3
                }

                function _e() {
                    if (xe) {
                        var e3 = xe,
                            n3 = Ee;
                        if (Ee = xe = null, Ne(e3), n3)
                            for (e3 = 0; e3 < n3.length; e3++) Ne(n3[e3])
                    }
                }

                function ze(e3, n3) {
                    return e3(n3)
                }

                function Pe() {}
                var Le = !1;

                function Te(e3, n3, t3) {
                    if (Le) return e3(n3, t3);
                    Le = !0;
                    try {
                        return ze(e3, n3, t3)
                    } finally {
                        Le = !1, (xe !== null || Ee !== null) && (Pe(), _e())
                    }
                }

                function je(e3, n3) {
                    var t3 = e3.stateNode;
                    if (t3 === null) return null;
                    var r3 = kl(t3);
                    if (r3 === null) return null;
                    t3 = r3[n3];
                    e: switch (n3) {
                        case "onClick":
                        case "onClickCapture":
                        case "onDoubleClick":
                        case "onDoubleClickCapture":
                        case "onMouseDown":
                        case "onMouseDownCapture":
                        case "onMouseMove":
                        case "onMouseMoveCapture":
                        case "onMouseUp":
                        case "onMouseUpCapture":
                        case "onMouseEnter":
                            (r3 = !r3.disabled) || (r3 = !((e3 = e3.type) === "button" || e3 === "input" || e3 === "select" || e3 === "textarea")), e3 = !r3;
                            break e;
                        default:
                            e3 = !1
                    }
                    if (e3) return null;
                    if (t3 && typeof t3 != "function") throw Error(a2(231, n3, typeof t3));
                    return t3
                }
                var Re = !1;
                if (c2) try {
                    var Me = {};
                    Object.defineProperty(Me, "passive", {
                        get: function() {
                            Re = !0
                        }
                    }), window.addEventListener("test", Me, Me), window.removeEventListener("test", Me, Me)
                } catch {
                    Re = !1
                }

                function Ie(e3, n3, t3, r3, l3, a3, o3, i3, u3) {
                    var s3 = Array.prototype.slice.call(arguments, 3);
                    try {
                        n3.apply(t3, s3)
                    } catch (c3) {
                        this.onError(c3)
                    }
                }
                var De = !1,
                    Ae = null,
                    Fe = !1,
                    Oe = null,
                    Ue = {
                        onError: function(e3) {
                            De = !0, Ae = e3
                        }
                    };

                function Be(e3, n3, t3, r3, l3, a3, o3, i3, u3) {
                    De = !1, Ae = null, Ie.apply(Ue, arguments)
                }

                function We(e3) {
                    var n3 = e3,
                        t3 = e3;
                    if (e3.alternate)
                        for (; n3.return;) n3 = n3.return;
                    else {
                        e3 = n3;
                        do 4098 & (n3 = e3).flags && (t3 = n3.return), e3 = n3.return; while (e3)
                    }
                    return n3.tag === 3 ? t3 : null
                }

                function Ve(e3) {
                    if (e3.tag === 13) {
                        var n3 = e3.memoizedState;
                        if (n3 === null && (e3 = e3.alternate) !== null && (n3 = e3.memoizedState), n3 !== null) return n3.dehydrated
                    }
                    return null
                }

                function He(e3) {
                    if (We(e3) !== e3) throw Error(a2(188))
                }

                function Qe(e3) {
                    return (e3 = function(e4) {
                        var n3 = e4.alternate;
                        if (!n3) {
                            if ((n3 = We(e4)) === null) throw Error(a2(188));
                            return n3 !== e4 ? null : e4
                        }
                        for (var t3 = e4, r3 = n3;;) {
                            var l3 = t3.return;
                            if (l3 === null) break;
                            var o3 = l3.alternate;
                            if (o3 === null) {
                                if ((r3 = l3.return) !== null) {
                                    t3 = r3;
                                    continue
                                }
                                break
                            }
                            if (l3.child === o3.child) {
                                for (o3 = l3.child; o3;) {
                                    if (o3 === t3) return He(l3), e4;
                                    if (o3 === r3) return He(l3), n3;
                                    o3 = o3.sibling
                                }
                                throw Error(a2(188))
                            }
                            if (t3.return !== r3.return) t3 = l3, r3 = o3;
                            else {
                                for (var i3 = !1, u3 = l3.child; u3;) {
                                    if (u3 === t3) {
                                        i3 = !0, t3 = l3, r3 = o3;
                                        break
                                    }
                                    if (u3 === r3) {
                                        i3 = !0, r3 = l3, t3 = o3;
                                        break
                                    }
                                    u3 = u3.sibling
                                }
                                if (!i3) {
                                    for (u3 = o3.child; u3;) {
                                        if (u3 === t3) {
                                            i3 = !0, t3 = o3, r3 = l3;
                                            break
                                        }
                                        if (u3 === r3) {
                                            i3 = !0, r3 = o3, t3 = l3;
                                            break
                                        }
                                        u3 = u3.sibling
                                    }
                                    if (!i3) throw Error(a2(189))
                                }
                            }
                            if (t3.alternate !== r3) throw Error(a2(190))
                        }
                        if (t3.tag !== 3) throw Error(a2(188));
                        return t3.stateNode.current === t3 ? e4 : n3
                    }(e3)) !== null ? Ye(e3) : null
                }

                function Ye(e3) {
                    if (e3.tag === 5 || e3.tag === 6) return e3;
                    for (e3 = e3.child; e3 !== null;) {
                        var n3 = Ye(e3);
                        if (n3 !== null) return n3;
                        e3 = e3.sibling
                    }
                    return null
                }
                var Ge = l2.unstable_scheduleCallback,
                    $e = l2.unstable_cancelCallback,
                    Xe = l2.unstable_shouldYield,
                    Ze = l2.unstable_requestPaint,
                    Je = l2.unstable_now,
                    qe = l2.unstable_getCurrentPriorityLevel,
                    Ke = l2.unstable_ImmediatePriority,
                    en = l2.unstable_UserBlockingPriority,
                    nn = l2.unstable_NormalPriority,
                    tn = l2.unstable_LowPriority,
                    rn = l2.unstable_IdlePriority,
                    ln = null,
                    an = null,
                    on = Math.clz32 ? Math.clz32 : function(e3) {
                        return e3 >>>= 0, e3 === 0 ? 32 : 31 - (un(e3) / sn | 0) | 0
                    },
                    un = Math.log,
                    sn = Math.LN2,
                    cn = 64,
                    dn = 4194304;

                function fn(e3) {
                    switch (e3 & -e3) {
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 4:
                            return 4;
                        case 8:
                            return 8;
                        case 16:
                            return 16;
                        case 32:
                            return 32;
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return 4194240 & e3;
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                        case 67108864:
                            return 130023424 & e3;
                        case 134217728:
                            return 134217728;
                        case 268435456:
                            return 268435456;
                        case 536870912:
                            return 536870912;
                        case 1073741824:
                            return 1073741824;
                        default:
                            return e3
                    }
                }

                function pn(e3, n3) {
                    var t3 = e3.pendingLanes;
                    if (t3 === 0) return 0;
                    var r3 = 0,
                        l3 = e3.suspendedLanes,
                        a3 = e3.pingedLanes,
                        o3 = 268435455 & t3;
                    if (o3 !== 0) {
                        var i3 = o3 & ~l3;
                        i3 !== 0 ? r3 = fn(i3) : (a3 &= o3) !== 0 && (r3 = fn(a3))
                    } else(o3 = t3 & ~l3) !== 0 ? r3 = fn(o3) : a3 !== 0 && (r3 = fn(a3));
                    if (r3 === 0) return 0;
                    if (n3 !== 0 && n3 !== r3 && !(n3 & l3) && ((l3 = r3 & -r3) >= (a3 = n3 & -n3) || l3 === 16 && 4194240 & a3)) return n3;
                    if (4 & r3 && (r3 |= 16 & t3), (n3 = e3.entangledLanes) !== 0)
                        for (e3 = e3.entanglements, n3 &= r3; 0 < n3;) l3 = 1 << (t3 = 31 - on(n3)), r3 |= e3[t3], n3 &= ~l3;
                    return r3
                }

                function hn(e3, n3) {
                    switch (e3) {
                        case 1:
                        case 2:
                        case 4:
                            return n3 + 250;
                        case 8:
                        case 16:
                        case 32:
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                            return n3 + 5e3;
                        default:
                            return -1
                    }
                }

                function mn(e3) {
                    return (e3 = -1073741825 & e3.pendingLanes) !== 0 ? e3 : 1073741824 & e3 ? 1073741824 : 0
                }

                function gn() {
                    var e3 = cn;
                    return !(4194240 & (cn <<= 1)) && (cn = 64), e3
                }

                function vn(e3) {
                    for (var n3 = [], t3 = 0; 31 > t3; t3++) n3.push(e3);
                    return n3
                }

                function yn(e3, n3, t3) {
                    e3.pendingLanes |= n3, n3 !== 536870912 && (e3.suspendedLanes = 0, e3.pingedLanes = 0), (e3 = e3.eventTimes)[n3 = 31 - on(n3)] = t3
                }

                function bn(e3, n3) {
                    var t3 = e3.entangledLanes |= n3;
                    for (e3 = e3.entanglements; t3;) {
                        var r3 = 31 - on(t3),
                            l3 = 1 << r3;
                        l3 & n3 | e3[r3] & n3 && (e3[r3] |= n3), t3 &= ~l3
                    }
                }
                var wn = 0;

                function kn(e3) {
                    return 1 < (e3 &= -e3) ? 4 < e3 ? 268435455 & e3 ? 16 : 536870912 : 4 : 1
                }
                var Sn, xn, En, Nn, Cn, _n = !1,
                    zn = [],
                    Pn = null,
                    Ln = null,
                    Tn = null,
                    jn = new Map,
                    Rn = new Map,
                    Mn = [],
                    In = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

                function Dn(e3, n3) {
                    switch (e3) {
                        case "focusin":
                        case "focusout":
                            Pn = null;
                            break;
                        case "dragenter":
                        case "dragleave":
                            Ln = null;
                            break;
                        case "mouseover":
                        case "mouseout":
                            Tn = null;
                            break;
                        case "pointerover":
                        case "pointerout":
                            jn.delete(n3.pointerId);
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                            Rn.delete(n3.pointerId)
                    }
                }

                function An(e3, n3, t3, r3, l3, a3) {
                    return e3 === null || e3.nativeEvent !== a3 ? (e3 = {
                        blockedOn: n3,
                        domEventName: t3,
                        eventSystemFlags: r3,
                        nativeEvent: a3,
                        targetContainers: [l3]
                    }, n3 !== null && (n3 = bl(n3)) !== null && xn(n3), e3) : (e3.eventSystemFlags |= r3, n3 = e3.targetContainers, l3 !== null && n3.indexOf(l3) === -1 && n3.push(l3), e3)
                }

                function Fn(e3) {
                    var n3 = yl(e3.target);
                    if (n3 !== null) {
                        var t3 = We(n3);
                        if (t3 !== null) {
                            if ((n3 = t3.tag) === 13) {
                                if ((n3 = Ve(t3)) !== null) return e3.blockedOn = n3, void Cn(e3.priority, function() {
                                    En(t3)
                                })
                            } else if (n3 === 3 && t3.stateNode.current.memoizedState.isDehydrated) return void(e3.blockedOn = t3.tag === 3 ? t3.stateNode.containerInfo : null)
                        }
                    }
                    e3.blockedOn = null
                }

                function On(e3) {
                    if (e3.blockedOn !== null) return !1;
                    for (var n3 = e3.targetContainers; 0 < n3.length;) {
                        var t3 = Zn(e3.domEventName, e3.eventSystemFlags, n3[0], e3.nativeEvent);
                        if (t3 !== null) return (n3 = bl(t3)) !== null && xn(n3), e3.blockedOn = t3, !1;
                        var r3 = new(t3 = e3.nativeEvent).constructor(t3.type, t3);
                        we = r3, t3.target.dispatchEvent(r3), we = null, n3.shift()
                    }
                    return !0
                }

                function Un(e3, n3, t3) {
                    On(e3) && t3.delete(n3)
                }

                function Bn() {
                    _n = !1, Pn !== null && On(Pn) && (Pn = null), Ln !== null && On(Ln) && (Ln = null), Tn !== null && On(Tn) && (Tn = null), jn.forEach(Un), Rn.forEach(Un)
                }

                function Wn(e3, n3) {
                    e3.blockedOn === n3 && (e3.blockedOn = null, _n || (_n = !0, l2.unstable_scheduleCallback(l2.unstable_NormalPriority, Bn)))
                }

                function Vn(e3) {
                    function n3(n4) {
                        return Wn(n4, e3)
                    }
                    if (0 < zn.length) {
                        Wn(zn[0], e3);
                        for (var t3 = 1; t3 < zn.length; t3++) {
                            var r3 = zn[t3];
                            r3.blockedOn === e3 && (r3.blockedOn = null)
                        }
                    }
                    for (Pn !== null && Wn(Pn, e3), Ln !== null && Wn(Ln, e3), Tn !== null && Wn(Tn, e3), jn.forEach(n3), Rn.forEach(n3), t3 = 0; t3 < Mn.length; t3++)(r3 = Mn[t3]).blockedOn === e3 && (r3.blockedOn = null);
                    for (; 0 < Mn.length && (t3 = Mn[0]).blockedOn === null;) Fn(t3), t3.blockedOn === null && Mn.shift()
                }
                var Hn = w.ReactCurrentBatchConfig,
                    Qn = !0;

                function Yn(e3, n3, t3, r3) {
                    var l3 = wn,
                        a3 = Hn.transition;
                    Hn.transition = null;
                    try {
                        wn = 1, $n(e3, n3, t3, r3)
                    } finally {
                        wn = l3, Hn.transition = a3
                    }
                }

                function Gn(e3, n3, t3, r3) {
                    var l3 = wn,
                        a3 = Hn.transition;
                    Hn.transition = null;
                    try {
                        wn = 4, $n(e3, n3, t3, r3)
                    } finally {
                        wn = l3, Hn.transition = a3
                    }
                }

                function $n(e3, n3, t3, r3) {
                    if (Qn) {
                        var l3 = Zn(e3, n3, t3, r3);
                        if (l3 === null) Hr(e3, n3, r3, Xn, t3), Dn(e3, r3);
                        else if (function(e4, n4, t4, r4, l4) {
                                switch (n4) {
                                    case "focusin":
                                        return Pn = An(Pn, e4, n4, t4, r4, l4), !0;
                                    case "dragenter":
                                        return Ln = An(Ln, e4, n4, t4, r4, l4), !0;
                                    case "mouseover":
                                        return Tn = An(Tn, e4, n4, t4, r4, l4), !0;
                                    case "pointerover":
                                        var a4 = l4.pointerId;
                                        return jn.set(a4, An(jn.get(a4) || null, e4, n4, t4, r4, l4)), !0;
                                    case "gotpointercapture":
                                        return a4 = l4.pointerId, Rn.set(a4, An(Rn.get(a4) || null, e4, n4, t4, r4, l4)), !0
                                }
                                return !1
                            }(l3, e3, n3, t3, r3)) r3.stopPropagation();
                        else if (Dn(e3, r3), 4 & n3 && -1 < In.indexOf(e3)) {
                            for (; l3 !== null;) {
                                var a3 = bl(l3);
                                if (a3 !== null && Sn(a3), (a3 = Zn(e3, n3, t3, r3)) === null && Hr(e3, n3, r3, Xn, t3), a3 === l3) break;
                                l3 = a3
                            }
                            l3 !== null && r3.stopPropagation()
                        } else Hr(e3, n3, r3, null, t3)
                    }
                }
                var Xn = null;

                function Zn(e3, n3, t3, r3) {
                    if (Xn = null, (e3 = yl(e3 = ke(r3))) !== null)
                        if ((n3 = We(e3)) === null) e3 = null;
                        else if ((t3 = n3.tag) === 13) {
                        if ((e3 = Ve(n3)) !== null) return e3;
                        e3 = null
                    } else if (t3 === 3) {
                        if (n3.stateNode.current.memoizedState.isDehydrated) return n3.tag === 3 ? n3.stateNode.containerInfo : null;
                        e3 = null
                    } else n3 !== e3 && (e3 = null);
                    return Xn = e3, null
                }

                function Jn(e3) {
                    switch (e3) {
                        case "cancel":
                        case "click":
                        case "close":
                        case "contextmenu":
                        case "copy":
                        case "cut":
                        case "auxclick":
                        case "dblclick":
                        case "dragend":
                        case "dragstart":
                        case "drop":
                        case "focusin":
                        case "focusout":
                        case "input":
                        case "invalid":
                        case "keydown":
                        case "keypress":
                        case "keyup":
                        case "mousedown":
                        case "mouseup":
                        case "paste":
                        case "pause":
                        case "play":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointerup":
                        case "ratechange":
                        case "reset":
                        case "resize":
                        case "seeked":
                        case "submit":
                        case "touchcancel":
                        case "touchend":
                        case "touchstart":
                        case "volumechange":
                        case "change":
                        case "selectionchange":
                        case "textInput":
                        case "compositionstart":
                        case "compositionend":
                        case "compositionupdate":
                        case "beforeblur":
                        case "afterblur":
                        case "beforeinput":
                        case "blur":
                        case "fullscreenchange":
                        case "focus":
                        case "hashchange":
                        case "popstate":
                        case "select":
                        case "selectstart":
                            return 1;
                        case "drag":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "mousemove":
                        case "mouseout":
                        case "mouseover":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "scroll":
                        case "toggle":
                        case "touchmove":
                        case "wheel":
                        case "mouseenter":
                        case "mouseleave":
                        case "pointerenter":
                        case "pointerleave":
                            return 4;
                        case "message":
                            switch (qe()) {
                                case Ke:
                                    return 1;
                                case en:
                                    return 4;
                                case nn:
                                case tn:
                                    return 16;
                                case rn:
                                    return 536870912;
                                default:
                                    return 16
                            }
                        default:
                            return 16
                    }
                }
                var qn = null,
                    Kn = null,
                    et = null;

                function nt() {
                    if (et) return et;
                    var e3, n3, t3 = Kn,
                        r3 = t3.length,
                        l3 = "value" in qn ? qn.value : qn.textContent,
                        a3 = l3.length;
                    for (e3 = 0; e3 < r3 && t3[e3] === l3[e3]; e3++);
                    var o3 = r3 - e3;
                    for (n3 = 1; n3 <= o3 && t3[r3 - n3] === l3[a3 - n3]; n3++);
                    return et = l3.slice(e3, 1 < n3 ? 1 - n3 : void 0)
                }

                function tt(e3) {
                    var n3 = e3.keyCode;
                    return "charCode" in e3 ? (e3 = e3.charCode) === 0 && n3 === 13 && (e3 = 13) : e3 = n3, e3 === 10 && (e3 = 13), 32 <= e3 || e3 === 13 ? e3 : 0
                }

                function rt() {
                    return !0
                }

                function lt() {
                    return !1
                }

                function at(e3) {
                    function n3(n4, t3, r3, l3, a3) {
                        for (var o3 in this._reactName = n4, this._targetInst = r3, this.type = t3, this.nativeEvent = l3, this.target = a3, this.currentTarget = null, e3) e3.hasOwnProperty(o3) && (n4 = e3[o3], this[o3] = n4 ? n4(l3) : l3[o3]);
                        return this.isDefaultPrevented = (l3.defaultPrevented != null ? l3.defaultPrevented : l3.returnValue === !1) ? rt : lt, this.isPropagationStopped = lt, this
                    }
                    return A(n3.prototype, {
                        preventDefault: function() {
                            this.defaultPrevented = !0;
                            var e4 = this.nativeEvent;
                            e4 && (e4.preventDefault ? e4.preventDefault() : typeof e4.returnValue != "unknown" && (e4.returnValue = !1), this.isDefaultPrevented = rt)
                        },
                        stopPropagation: function() {
                            var e4 = this.nativeEvent;
                            e4 && (e4.stopPropagation ? e4.stopPropagation() : typeof e4.cancelBubble != "unknown" && (e4.cancelBubble = !0), this.isPropagationStopped = rt)
                        },
                        persist: function() {},
                        isPersistent: rt
                    }), n3
                }
                var ot, it, ut, st = {
                        eventPhase: 0,
                        bubbles: 0,
                        cancelable: 0,
                        timeStamp: function(e3) {
                            return e3.timeStamp || Date.now()
                        },
                        defaultPrevented: 0,
                        isTrusted: 0
                    },
                    ct = at(st),
                    dt = A({}, st, {
                        view: 0,
                        detail: 0
                    }),
                    ft = at(dt),
                    pt = A({}, dt, {
                        screenX: 0,
                        screenY: 0,
                        clientX: 0,
                        clientY: 0,
                        pageX: 0,
                        pageY: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        altKey: 0,
                        metaKey: 0,
                        getModifierState: Nt,
                        button: 0,
                        buttons: 0,
                        relatedTarget: function(e3) {
                            return e3.relatedTarget === void 0 ? e3.fromElement === e3.srcElement ? e3.toElement : e3.fromElement : e3.relatedTarget
                        },
                        movementX: function(e3) {
                            return "movementX" in e3 ? e3.movementX : (e3 !== ut && (ut && e3.type === "mousemove" ? (ot = e3.screenX - ut.screenX, it = e3.screenY - ut.screenY) : it = ot = 0, ut = e3), ot)
                        },
                        movementY: function(e3) {
                            return "movementY" in e3 ? e3.movementY : it
                        }
                    }),
                    ht = at(pt),
                    mt = at(A({}, pt, {
                        dataTransfer: 0
                    })),
                    gt = at(A({}, dt, {
                        relatedTarget: 0
                    })),
                    vt = at(A({}, st, {
                        animationName: 0,
                        elapsedTime: 0,
                        pseudoElement: 0
                    })),
                    yt = A({}, st, {
                        clipboardData: function(e3) {
                            return "clipboardData" in e3 ? e3.clipboardData : window.clipboardData
                        }
                    }),
                    bt = at(yt),
                    wt = at(A({}, st, {
                        data: 0
                    })),
                    kt = {
                        Esc: "Escape",
                        Spacebar: " ",
                        Left: "ArrowLeft",
                        Up: "ArrowUp",
                        Right: "ArrowRight",
                        Down: "ArrowDown",
                        Del: "Delete",
                        Win: "OS",
                        Menu: "ContextMenu",
                        Apps: "ContextMenu",
                        Scroll: "ScrollLock",
                        MozPrintableKey: "Unidentified"
                    },
                    St = {
                        8: "Backspace",
                        9: "Tab",
                        12: "Clear",
                        13: "Enter",
                        16: "Shift",
                        17: "Control",
                        18: "Alt",
                        19: "Pause",
                        20: "CapsLock",
                        27: "Escape",
                        32: " ",
                        33: "PageUp",
                        34: "PageDown",
                        35: "End",
                        36: "Home",
                        37: "ArrowLeft",
                        38: "ArrowUp",
                        39: "ArrowRight",
                        40: "ArrowDown",
                        45: "Insert",
                        46: "Delete",
                        112: "F1",
                        113: "F2",
                        114: "F3",
                        115: "F4",
                        116: "F5",
                        117: "F6",
                        118: "F7",
                        119: "F8",
                        120: "F9",
                        121: "F10",
                        122: "F11",
                        123: "F12",
                        144: "NumLock",
                        145: "ScrollLock",
                        224: "Meta"
                    },
                    xt = {
                        Alt: "altKey",
                        Control: "ctrlKey",
                        Meta: "metaKey",
                        Shift: "shiftKey"
                    };

                function Et(e3) {
                    var n3 = this.nativeEvent;
                    return n3.getModifierState ? n3.getModifierState(e3) : !!(e3 = xt[e3]) && !!n3[e3]
                }

                function Nt() {
                    return Et
                }
                var Ct = A({}, dt, {
                        key: function(e3) {
                            if (e3.key) {
                                var n3 = kt[e3.key] || e3.key;
                                if (n3 !== "Unidentified") return n3
                            }
                            return e3.type === "keypress" ? (e3 = tt(e3)) === 13 ? "Enter" : String.fromCharCode(e3) : e3.type === "keydown" || e3.type === "keyup" ? St[e3.keyCode] || "Unidentified" : ""
                        },
                        code: 0,
                        location: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        altKey: 0,
                        metaKey: 0,
                        repeat: 0,
                        locale: 0,
                        getModifierState: Nt,
                        charCode: function(e3) {
                            return e3.type === "keypress" ? tt(e3) : 0
                        },
                        keyCode: function(e3) {
                            return e3.type === "keydown" || e3.type === "keyup" ? e3.keyCode : 0
                        },
                        which: function(e3) {
                            return e3.type === "keypress" ? tt(e3) : e3.type === "keydown" || e3.type === "keyup" ? e3.keyCode : 0
                        }
                    }),
                    _t = at(Ct),
                    zt = at(A({}, pt, {
                        pointerId: 0,
                        width: 0,
                        height: 0,
                        pressure: 0,
                        tangentialPressure: 0,
                        tiltX: 0,
                        tiltY: 0,
                        twist: 0,
                        pointerType: 0,
                        isPrimary: 0
                    })),
                    Pt = at(A({}, dt, {
                        touches: 0,
                        targetTouches: 0,
                        changedTouches: 0,
                        altKey: 0,
                        metaKey: 0,
                        ctrlKey: 0,
                        shiftKey: 0,
                        getModifierState: Nt
                    })),
                    Lt = at(A({}, st, {
                        propertyName: 0,
                        elapsedTime: 0,
                        pseudoElement: 0
                    })),
                    Tt = A({}, pt, {
                        deltaX: function(e3) {
                            return "deltaX" in e3 ? e3.deltaX : "wheelDeltaX" in e3 ? -e3.wheelDeltaX : 0
                        },
                        deltaY: function(e3) {
                            return "deltaY" in e3 ? e3.deltaY : "wheelDeltaY" in e3 ? -e3.wheelDeltaY : "wheelDelta" in e3 ? -e3.wheelDelta : 0
                        },
                        deltaZ: 0,
                        deltaMode: 0
                    }),
                    jt = at(Tt),
                    Rt = [9, 13, 27, 32],
                    Mt = c2 && "CompositionEvent" in window,
                    It = null;
                c2 && "documentMode" in document && (It = document.documentMode);
                var Dt = c2 && "TextEvent" in window && !It,
                    At = c2 && (!Mt || It && 8 < It && 11 >= It),
                    Ft = " ",
                    Ot = !1;

                function Ut(e3, n3) {
                    switch (e3) {
                        case "keyup":
                            return Rt.indexOf(n3.keyCode) !== -1;
                        case "keydown":
                            return n3.keyCode !== 229;
                        case "keypress":
                        case "mousedown":
                        case "focusout":
                            return !0;
                        default:
                            return !1
                    }
                }

                function Bt(e3) {
                    return typeof(e3 = e3.detail) == "object" && "data" in e3 ? e3.data : null
                }
                var Wt = !1,
                    Vt = {
                        color: !0,
                        date: !0,
                        datetime: !0,
                        "datetime-local": !0,
                        email: !0,
                        month: !0,
                        number: !0,
                        password: !0,
                        range: !0,
                        search: !0,
                        tel: !0,
                        text: !0,
                        time: !0,
                        url: !0,
                        week: !0
                    };

                function Ht(e3) {
                    var n3 = e3 && e3.nodeName && e3.nodeName.toLowerCase();
                    return n3 === "input" ? !!Vt[e3.type] : n3 === "textarea"
                }

                function Qt(e3, n3, t3, r3) {
                    Ce(r3), 0 < (n3 = Yr(n3, "onChange")).length && (t3 = new ct("onChange", "change", null, t3, r3), e3.push({
                        event: t3,
                        listeners: n3
                    }))
                }
                var Yt = null,
                    Gt = null;

                function $t(e3) {
                    Fr(e3, 0)
                }

                function Xt(e3) {
                    if (G(wl(e3))) return e3
                }

                function Zt(e3, n3) {
                    if (e3 === "change") return n3
                }
                var Jt = !1;
                if (c2) {
                    var qt;
                    if (c2) {
                        var Kt = "oninput" in document;
                        if (!Kt) {
                            var er = document.createElement("div");
                            er.setAttribute("oninput", "return;"), Kt = typeof er.oninput == "function"
                        }
                        qt = Kt
                    } else qt = !1;
                    Jt = qt && (!document.documentMode || 9 < document.documentMode)
                }

                function nr() {
                    Yt && (Yt.detachEvent("onpropertychange", tr), Gt = Yt = null)
                }

                function tr(e3) {
                    if (e3.propertyName === "value" && Xt(Gt)) {
                        var n3 = [];
                        Qt(n3, Gt, e3, ke(e3)), Te($t, n3)
                    }
                }

                function rr(e3, n3, t3) {
                    e3 === "focusin" ? (nr(), Gt = t3, (Yt = n3).attachEvent("onpropertychange", tr)) : e3 === "focusout" && nr()
                }

                function lr(e3) {
                    if (e3 === "selectionchange" || e3 === "keyup" || e3 === "keydown") return Xt(Gt)
                }

                function ar(e3, n3) {
                    if (e3 === "click") return Xt(n3)
                }

                function or(e3, n3) {
                    if (e3 === "input" || e3 === "change") return Xt(n3)
                }
                var ir = typeof Object.is == "function" ? Object.is : function(e3, n3) {
                    return e3 === n3 && (e3 !== 0 || 1 / e3 === 1 / n3) || e3 !== e3 && n3 !== n3
                };

                function ur(e3, n3) {
                    if (ir(e3, n3)) return !0;
                    if (typeof e3 != "object" || e3 === null || typeof n3 != "object" || n3 === null) return !1;
                    var t3 = Object.keys(e3),
                        r3 = Object.keys(n3);
                    if (t3.length !== r3.length) return !1;
                    for (r3 = 0; r3 < t3.length; r3++) {
                        var l3 = t3[r3];
                        if (!d2.call(n3, l3) || !ir(e3[l3], n3[l3])) return !1
                    }
                    return !0
                }

                function sr(e3) {
                    for (; e3 && e3.firstChild;) e3 = e3.firstChild;
                    return e3
                }

                function cr(e3, n3) {
                    var t3, r3 = sr(e3);
                    for (e3 = 0; r3;) {
                        if (r3.nodeType === 3) {
                            if (t3 = e3 + r3.textContent.length, e3 <= n3 && t3 >= n3) return {
                                node: r3,
                                offset: n3 - e3
                            };
                            e3 = t3
                        }
                        e: {
                            for (; r3;) {
                                if (r3.nextSibling) {
                                    r3 = r3.nextSibling;
                                    break e
                                }
                                r3 = r3.parentNode
                            }
                            r3 = void 0
                        }
                        r3 = sr(r3)
                    }
                }

                function dr(e3, n3) {
                    return !(!e3 || !n3) && (e3 === n3 || (!e3 || e3.nodeType !== 3) && (n3 && n3.nodeType === 3 ? dr(e3, n3.parentNode) : "contains" in e3 ? e3.contains(n3) : !!e3.compareDocumentPosition && !!(16 & e3.compareDocumentPosition(n3))))
                }

                function fr() {
                    for (var e3 = window, n3 = $(); n3 instanceof e3.HTMLIFrameElement;) {
                        try {
                            var t3 = typeof n3.contentWindow.location.href == "string"
                        } catch {
                            t3 = !1
                        }
                        if (!t3) break;
                        n3 = $((e3 = n3.contentWindow).document)
                    }
                    return n3
                }

                function pr(e3) {
                    var n3 = e3 && e3.nodeName && e3.nodeName.toLowerCase();
                    return n3 && (n3 === "input" && (e3.type === "text" || e3.type === "search" || e3.type === "tel" || e3.type === "url" || e3.type === "password") || n3 === "textarea" || e3.contentEditable === "true")
                }

                function hr(e3) {
                    var n3 = fr(),
                        t3 = e3.focusedElem,
                        r3 = e3.selectionRange;
                    if (n3 !== t3 && t3 && t3.ownerDocument && dr(t3.ownerDocument.documentElement, t3)) {
                        if (r3 !== null && pr(t3)) {
                            if (n3 = r3.start, (e3 = r3.end) === void 0 && (e3 = n3), "selectionStart" in t3) t3.selectionStart = n3, t3.selectionEnd = Math.min(e3, t3.value.length);
                            else if ((e3 = (n3 = t3.ownerDocument || document) && n3.defaultView || window).getSelection) {
                                e3 = e3.getSelection();
                                var l3 = t3.textContent.length,
                                    a3 = Math.min(r3.start, l3);
                                r3 = r3.end === void 0 ? a3 : Math.min(r3.end, l3), !e3.extend && a3 > r3 && (l3 = r3, r3 = a3, a3 = l3), l3 = cr(t3, a3);
                                var o3 = cr(t3, r3);
                                l3 && o3 && (e3.rangeCount !== 1 || e3.anchorNode !== l3.node || e3.anchorOffset !== l3.offset || e3.focusNode !== o3.node || e3.focusOffset !== o3.offset) && ((n3 = n3.createRange()).setStart(l3.node, l3.offset), e3.removeAllRanges(), a3 > r3 ? (e3.addRange(n3), e3.extend(o3.node, o3.offset)) : (n3.setEnd(o3.node, o3.offset), e3.addRange(n3)))
                            }
                        }
                        for (n3 = [], e3 = t3; e3 = e3.parentNode;) e3.nodeType === 1 && n3.push({
                            element: e3,
                            left: e3.scrollLeft,
                            top: e3.scrollTop
                        });
                        for (typeof t3.focus == "function" && t3.focus(), t3 = 0; t3 < n3.length; t3++)(e3 = n3[t3]).element.scrollLeft = e3.left, e3.element.scrollTop = e3.top
                    }
                }
                var mr = c2 && "documentMode" in document && 11 >= document.documentMode,
                    gr = null,
                    vr = null,
                    yr = null,
                    br = !1;

                function wr(e3, n3, t3) {
                    var r3 = t3.window === t3 ? t3.document : t3.nodeType === 9 ? t3 : t3.ownerDocument;
                    br || gr == null || gr !== $(r3) || ("selectionStart" in (r3 = gr) && pr(r3) ? r3 = {
                        start: r3.selectionStart,
                        end: r3.selectionEnd
                    } : r3 = {
                        anchorNode: (r3 = (r3.ownerDocument && r3.ownerDocument.defaultView || window).getSelection()).anchorNode,
                        anchorOffset: r3.anchorOffset,
                        focusNode: r3.focusNode,
                        focusOffset: r3.focusOffset
                    }, yr && ur(yr, r3) || (yr = r3, 0 < (r3 = Yr(vr, "onSelect")).length && (n3 = new ct("onSelect", "select", null, n3, t3), e3.push({
                        event: n3,
                        listeners: r3
                    }), n3.target = gr)))
                }

                function kr(e3, n3) {
                    var t3 = {};
                    return t3[e3.toLowerCase()] = n3.toLowerCase(), t3["Webkit" + e3] = "webkit" + n3, t3["Moz" + e3] = "moz" + n3, t3
                }
                var Sr = {
                        animationend: kr("Animation", "AnimationEnd"),
                        animationiteration: kr("Animation", "AnimationIteration"),
                        animationstart: kr("Animation", "AnimationStart"),
                        transitionend: kr("Transition", "TransitionEnd")
                    },
                    xr = {},
                    Er = {};

                function Nr(e3) {
                    if (xr[e3]) return xr[e3];
                    if (!Sr[e3]) return e3;
                    var n3, t3 = Sr[e3];
                    for (n3 in t3)
                        if (t3.hasOwnProperty(n3) && n3 in Er) return xr[e3] = t3[n3];
                    return e3
                }
                c2 && (Er = document.createElement("div").style, "AnimationEvent" in window || (delete Sr.animationend.animation, delete Sr.animationiteration.animation, delete Sr.animationstart.animation), "TransitionEvent" in window || delete Sr.transitionend.transition);
                var Cr = Nr("animationend"),
                    _r = Nr("animationiteration"),
                    zr = Nr("animationstart"),
                    Pr = Nr("transitionend"),
                    Lr = new Map,
                    Tr = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");

                function jr(e3, n3) {
                    Lr.set(e3, n3), u2(n3, [e3])
                }
                for (var Rr = 0; Rr < Tr.length; Rr++) {
                    var Mr = Tr[Rr];
                    jr(Mr.toLowerCase(), "on" + (Mr[0].toUpperCase() + Mr.slice(1)))
                }
                jr(Cr, "onAnimationEnd"), jr(_r, "onAnimationIteration"), jr(zr, "onAnimationStart"), jr("dblclick", "onDoubleClick"), jr("focusin", "onFocus"), jr("focusout", "onBlur"), jr(Pr, "onTransitionEnd"), s2("onMouseEnter", ["mouseout", "mouseover"]), s2("onMouseLeave", ["mouseout", "mouseover"]), s2("onPointerEnter", ["pointerout", "pointerover"]), s2("onPointerLeave", ["pointerout", "pointerover"]), u2("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), u2("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), u2("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), u2("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), u2("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), u2("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
                var Ir = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
                    Dr = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ir));

                function Ar(e3, n3, t3) {
                    var r3 = e3.type || "unknown-event";
                    e3.currentTarget = t3,
                        function(e4, n4, t4, r4, l3, o3, i3, u3, s3) {
                            if (Be.apply(this, arguments), De) {
                                if (!De) throw Error(a2(198));
                                var c3 = Ae;
                                De = !1, Ae = null, Fe || (Fe = !0, Oe = c3)
                            }
                        }(r3, n3, void 0, e3), e3.currentTarget = null
                }

                function Fr(e3, n3) {
                    n3 = (4 & n3) !== 0;
                    for (var t3 = 0; t3 < e3.length; t3++) {
                        var r3 = e3[t3],
                            l3 = r3.event;
                        r3 = r3.listeners;
                        e: {
                            var a3 = void 0;
                            if (n3)
                                for (var o3 = r3.length - 1; 0 <= o3; o3--) {
                                    var i3 = r3[o3],
                                        u3 = i3.instance,
                                        s3 = i3.currentTarget;
                                    if (i3 = i3.listener, u3 !== a3 && l3.isPropagationStopped()) break e;
                                    Ar(l3, i3, s3), a3 = u3
                                } else
                                    for (o3 = 0; o3 < r3.length; o3++) {
                                        if (u3 = (i3 = r3[o3]).instance, s3 = i3.currentTarget, i3 = i3.listener, u3 !== a3 && l3.isPropagationStopped()) break e;
                                        Ar(l3, i3, s3), a3 = u3
                                    }
                        }
                    }
                    if (Fe) throw e3 = Oe, Fe = !1, Oe = null, e3
                }

                function Or(e3, n3) {
                    var t3 = n3[ml];
                    t3 === void 0 && (t3 = n3[ml] = new Set);
                    var r3 = e3 + "__bubble";
                    t3.has(r3) || (Vr(n3, e3, 2, !1), t3.add(r3))
                }

                function Ur(e3, n3, t3) {
                    var r3 = 0;
                    n3 && (r3 |= 4), Vr(t3, e3, r3, n3)
                }
                var Br = "_reactListening" + Math.random().toString(36).slice(2);

                function Wr(e3) {
                    if (!e3[Br]) {
                        e3[Br] = !0, o2.forEach(function(n4) {
                            n4 !== "selectionchange" && (Dr.has(n4) || Ur(n4, !1, e3), Ur(n4, !0, e3))
                        });
                        var n3 = e3.nodeType === 9 ? e3 : e3.ownerDocument;
                        n3 === null || n3[Br] || (n3[Br] = !0, Ur("selectionchange", !1, n3))
                    }
                }

                function Vr(e3, n3, t3, r3) {
                    switch (Jn(n3)) {
                        case 1:
                            var l3 = Yn;
                            break;
                        case 4:
                            l3 = Gn;
                            break;
                        default:
                            l3 = $n
                    }
                    t3 = l3.bind(null, n3, t3, e3), l3 = void 0, !Re || n3 !== "touchstart" && n3 !== "touchmove" && n3 !== "wheel" || (l3 = !0), r3 ? l3 !== void 0 ? e3.addEventListener(n3, t3, {
                        capture: !0,
                        passive: l3
                    }) : e3.addEventListener(n3, t3, !0) : l3 !== void 0 ? e3.addEventListener(n3, t3, {
                        passive: l3
                    }) : e3.addEventListener(n3, t3, !1)
                }

                function Hr(e3, n3, t3, r3, l3) {
                    var a3 = r3;
                    if (!(1 & n3) && !(2 & n3) && r3 !== null) e: for (;;) {
                        if (r3 === null) return;
                        var o3 = r3.tag;
                        if (o3 === 3 || o3 === 4) {
                            var i3 = r3.stateNode.containerInfo;
                            if (i3 === l3 || i3.nodeType === 8 && i3.parentNode === l3) break;
                            if (o3 === 4)
                                for (o3 = r3.return; o3 !== null;) {
                                    var u3 = o3.tag;
                                    if ((u3 === 3 || u3 === 4) && ((u3 = o3.stateNode.containerInfo) === l3 || u3.nodeType === 8 && u3.parentNode === l3)) return;
                                    o3 = o3.return
                                }
                            for (; i3 !== null;) {
                                if ((o3 = yl(i3)) === null) return;
                                if ((u3 = o3.tag) === 5 || u3 === 6) {
                                    r3 = a3 = o3;
                                    continue e
                                }
                                i3 = i3.parentNode
                            }
                        }
                        r3 = r3.return
                    }
                    Te(function() {
                        var r4 = a3,
                            l4 = ke(t3),
                            o4 = [];
                        e: {
                            var i4 = Lr.get(e3);
                            if (i4 !== void 0) {
                                var u4 = ct,
                                    s3 = e3;
                                switch (e3) {
                                    case "keypress":
                                        if (tt(t3) === 0) break e;
                                    case "keydown":
                                    case "keyup":
                                        u4 = _t;
                                        break;
                                    case "focusin":
                                        s3 = "focus", u4 = gt;
                                        break;
                                    case "focusout":
                                        s3 = "blur", u4 = gt;
                                        break;
                                    case "beforeblur":
                                    case "afterblur":
                                        u4 = gt;
                                        break;
                                    case "click":
                                        if (t3.button === 2) break e;
                                    case "auxclick":
                                    case "dblclick":
                                    case "mousedown":
                                    case "mousemove":
                                    case "mouseup":
                                    case "mouseout":
                                    case "mouseover":
                                    case "contextmenu":
                                        u4 = ht;
                                        break;
                                    case "drag":
                                    case "dragend":
                                    case "dragenter":
                                    case "dragexit":
                                    case "dragleave":
                                    case "dragover":
                                    case "dragstart":
                                    case "drop":
                                        u4 = mt;
                                        break;
                                    case "touchcancel":
                                    case "touchend":
                                    case "touchmove":
                                    case "touchstart":
                                        u4 = Pt;
                                        break;
                                    case Cr:
                                    case _r:
                                    case zr:
                                        u4 = vt;
                                        break;
                                    case Pr:
                                        u4 = Lt;
                                        break;
                                    case "scroll":
                                        u4 = ft;
                                        break;
                                    case "wheel":
                                        u4 = jt;
                                        break;
                                    case "copy":
                                    case "cut":
                                    case "paste":
                                        u4 = bt;
                                        break;
                                    case "gotpointercapture":
                                    case "lostpointercapture":
                                    case "pointercancel":
                                    case "pointerdown":
                                    case "pointermove":
                                    case "pointerout":
                                    case "pointerover":
                                    case "pointerup":
                                        u4 = zt
                                }
                                var c3 = (4 & n3) !== 0,
                                    d3 = !c3 && e3 === "scroll",
                                    f2 = c3 ? i4 !== null ? i4 + "Capture" : null : i4;
                                c3 = [];
                                for (var p2, h2 = r4; h2 !== null;) {
                                    var m2 = (p2 = h2).stateNode;
                                    if (p2.tag === 5 && m2 !== null && (p2 = m2, f2 !== null && (m2 = je(h2, f2)) != null && c3.push(Qr(h2, m2, p2))), d3) break;
                                    h2 = h2.return
                                }
                                0 < c3.length && (i4 = new u4(i4, s3, null, t3, l4), o4.push({
                                    event: i4,
                                    listeners: c3
                                }))
                            }
                        }
                        if (!(7 & n3)) {
                            if (u4 = e3 === "mouseout" || e3 === "pointerout", (!(i4 = e3 === "mouseover" || e3 === "pointerover") || t3 === we || !(s3 = t3.relatedTarget || t3.fromElement) || !yl(s3) && !s3[hl]) && (u4 || i4) && (i4 = l4.window === l4 ? l4 : (i4 = l4.ownerDocument) ? i4.defaultView || i4.parentWindow : window, u4 ? (u4 = r4, (s3 = (s3 = t3.relatedTarget || t3.toElement) ? yl(s3) : null) !== null && (s3 !== (d3 = We(s3)) || s3.tag !== 5 && s3.tag !== 6) && (s3 = null)) : (u4 = null, s3 = r4), u4 !== s3)) {
                                if (c3 = ht, m2 = "onMouseLeave", f2 = "onMouseEnter", h2 = "mouse", e3 !== "pointerout" && e3 !== "pointerover" || (c3 = zt, m2 = "onPointerLeave", f2 = "onPointerEnter", h2 = "pointer"), d3 = u4 == null ? i4 : wl(u4), p2 = s3 == null ? i4 : wl(s3), (i4 = new c3(m2, h2 + "leave", u4, t3, l4)).target = d3, i4.relatedTarget = p2, m2 = null, yl(l4) === r4 && ((c3 = new c3(f2, h2 + "enter", s3, t3, l4)).target = p2, c3.relatedTarget = d3, m2 = c3), d3 = m2, u4 && s3) e: {
                                    for (f2 = s3, h2 = 0, p2 = c3 = u4; p2; p2 = Gr(p2)) h2++;
                                    for (p2 = 0, m2 = f2; m2; m2 = Gr(m2)) p2++;
                                    for (; 0 < h2 - p2;) c3 = Gr(c3),
                                    h2--;
                                    for (; 0 < p2 - h2;) f2 = Gr(f2),
                                    p2--;
                                    for (; h2--;) {
                                        if (c3 === f2 || f2 !== null && c3 === f2.alternate) break e;
                                        c3 = Gr(c3), f2 = Gr(f2)
                                    }
                                    c3 = null
                                }
                                else c3 = null;
                                u4 !== null && $r(o4, i4, u4, c3, !1), s3 !== null && d3 !== null && $r(o4, d3, s3, c3, !0)
                            }
                            if ((u4 = (i4 = r4 ? wl(r4) : window).nodeName && i4.nodeName.toLowerCase()) === "select" || u4 === "input" && i4.type === "file") var g2 = Zt;
                            else if (Ht(i4))
                                if (Jt) g2 = or;
                                else {
                                    g2 = lr;
                                    var v2 = rr
                                }
                            else(u4 = i4.nodeName) && u4.toLowerCase() === "input" && (i4.type === "checkbox" || i4.type === "radio") && (g2 = ar);
                            switch (g2 && (g2 = g2(e3, r4)) ? Qt(o4, g2, t3, l4) : (v2 && v2(e3, i4, r4), e3 === "focusout" && (v2 = i4._wrapperState) && v2.controlled && i4.type === "number" && ee(i4, "number", i4.value)), v2 = r4 ? wl(r4) : window, e3) {
                                case "focusin":
                                    (Ht(v2) || v2.contentEditable === "true") && (gr = v2, vr = r4, yr = null);
                                    break;
                                case "focusout":
                                    yr = vr = gr = null;
                                    break;
                                case "mousedown":
                                    br = !0;
                                    break;
                                case "contextmenu":
                                case "mouseup":
                                case "dragend":
                                    br = !1, wr(o4, t3, l4);
                                    break;
                                case "selectionchange":
                                    if (mr) break;
                                case "keydown":
                                case "keyup":
                                    wr(o4, t3, l4)
                            }
                            var y2;
                            if (Mt) e: {
                                switch (e3) {
                                    case "compositionstart":
                                        var b2 = "onCompositionStart";
                                        break e;
                                    case "compositionend":
                                        b2 = "onCompositionEnd";
                                        break e;
                                    case "compositionupdate":
                                        b2 = "onCompositionUpdate";
                                        break e
                                }
                                b2 = void 0
                            }
                            else Wt ? Ut(e3, t3) && (b2 = "onCompositionEnd") : e3 === "keydown" && t3.keyCode === 229 && (b2 = "onCompositionStart");
                            b2 && (At && t3.locale !== "ko" && (Wt || b2 !== "onCompositionStart" ? b2 === "onCompositionEnd" && Wt && (y2 = nt()) : (Kn = "value" in (qn = l4) ? qn.value : qn.textContent, Wt = !0)), 0 < (v2 = Yr(r4, b2)).length && (b2 = new wt(b2, e3, null, t3, l4), o4.push({
                                event: b2,
                                listeners: v2
                            }), (y2 || (y2 = Bt(t3)) !== null) && (b2.data = y2))), (y2 = Dt ? function(e4, n4) {
                                switch (e4) {
                                    case "compositionend":
                                        return Bt(n4);
                                    case "keypress":
                                        return n4.which !== 32 ? null : (Ot = !0, Ft);
                                    case "textInput":
                                        return (e4 = n4.data) === Ft && Ot ? null : e4;
                                    default:
                                        return null
                                }
                            }(e3, t3) : function(e4, n4) {
                                if (Wt) return e4 === "compositionend" || !Mt && Ut(e4, n4) ? (e4 = nt(), et = Kn = qn = null, Wt = !1, e4) : null;
                                switch (e4) {
                                    case "paste":
                                    default:
                                        return null;
                                    case "keypress":
                                        if (!(n4.ctrlKey || n4.altKey || n4.metaKey) || n4.ctrlKey && n4.altKey) {
                                            if (n4.char && 1 < n4.char.length) return n4.char;
                                            if (n4.which) return String.fromCharCode(n4.which)
                                        }
                                        return null;
                                    case "compositionend":
                                        return At && n4.locale !== "ko" ? null : n4.data
                                }
                            }(e3, t3)) && 0 < (r4 = Yr(r4, "onBeforeInput")).length && (l4 = new wt("onBeforeInput", "beforeinput", null, t3, l4), o4.push({
                                event: l4,
                                listeners: r4
                            }), l4.data = y2)
                        }
                        Fr(o4, n3)
                    })
                }

                function Qr(e3, n3, t3) {
                    return {
                        instance: e3,
                        listener: n3,
                        currentTarget: t3
                    }
                }

                function Yr(e3, n3) {
                    for (var t3 = n3 + "Capture", r3 = []; e3 !== null;) {
                        var l3 = e3,
                            a3 = l3.stateNode;
                        l3.tag === 5 && a3 !== null && (l3 = a3, (a3 = je(e3, t3)) != null && r3.unshift(Qr(e3, a3, l3)), (a3 = je(e3, n3)) != null && r3.push(Qr(e3, a3, l3))), e3 = e3.return
                    }
                    return r3
                }

                function Gr(e3) {
                    if (e3 === null) return null;
                    do e3 = e3.return; while (e3 && e3.tag !== 5);
                    return e3 || null
                }

                function $r(e3, n3, t3, r3, l3) {
                    for (var a3 = n3._reactName, o3 = []; t3 !== null && t3 !== r3;) {
                        var i3 = t3,
                            u3 = i3.alternate,
                            s3 = i3.stateNode;
                        if (u3 !== null && u3 === r3) break;
                        i3.tag === 5 && s3 !== null && (i3 = s3, l3 ? (u3 = je(t3, a3)) != null && o3.unshift(Qr(t3, u3, i3)) : l3 || (u3 = je(t3, a3)) != null && o3.push(Qr(t3, u3, i3))), t3 = t3.return
                    }
                    o3.length !== 0 && e3.push({
                        event: n3,
                        listeners: o3
                    })
                }
                var Xr = /\r\n?/g,
                    Zr = /\u0000|\uFFFD/g;

                function Jr(e3) {
                    return (typeof e3 == "string" ? e3 : "" + e3).replace(Xr, `
`).replace(Zr, "")
                }

                function qr(e3, n3, t3) {
                    if (n3 = Jr(n3), Jr(e3) !== n3 && t3) throw Error(a2(425))
                }

                function Kr() {}
                var el = null,
                    nl = null;

                function tl(e3, n3) {
                    return e3 === "textarea" || e3 === "noscript" || typeof n3.children == "string" || typeof n3.children == "number" || typeof n3.dangerouslySetInnerHTML == "object" && n3.dangerouslySetInnerHTML !== null && n3.dangerouslySetInnerHTML.__html != null
                }
                var rl = typeof setTimeout == "function" ? setTimeout : void 0,
                    ll = typeof clearTimeout == "function" ? clearTimeout : void 0,
                    al = typeof Promise == "function" ? Promise : void 0,
                    ol = typeof queueMicrotask == "function" ? queueMicrotask : typeof al < "u" ? function(e3) {
                        return al.resolve(null).then(e3).catch(il)
                    } : rl;

                function il(e3) {
                    setTimeout(function() {
                        throw e3
                    })
                }

                function ul(e3, n3) {
                    var t3 = n3,
                        r3 = 0;
                    do {
                        var l3 = t3.nextSibling;
                        if (e3.removeChild(t3), l3 && l3.nodeType === 8)
                            if ((t3 = l3.data) === "/$") {
                                if (r3 === 0) return e3.removeChild(l3), void Vn(n3);
                                r3--
                            } else t3 !== "$" && t3 !== "$?" && t3 !== "$!" || r3++;
                        t3 = l3
                    } while (t3);
                    Vn(n3)
                }

                function sl(e3) {
                    for (; e3 != null; e3 = e3.nextSibling) {
                        var n3 = e3.nodeType;
                        if (n3 === 1 || n3 === 3) break;
                        if (n3 === 8) {
                            if ((n3 = e3.data) === "$" || n3 === "$!" || n3 === "$?") break;
                            if (n3 === "/$") return null
                        }
                    }
                    return e3
                }

                function cl(e3) {
                    e3 = e3.previousSibling;
                    for (var n3 = 0; e3;) {
                        if (e3.nodeType === 8) {
                            var t3 = e3.data;
                            if (t3 === "$" || t3 === "$!" || t3 === "$?") {
                                if (n3 === 0) return e3;
                                n3--
                            } else t3 === "/$" && n3++
                        }
                        e3 = e3.previousSibling
                    }
                    return null
                }
                var dl = Math.random().toString(36).slice(2),
                    fl = "__reactFiber$" + dl,
                    pl = "__reactProps$" + dl,
                    hl = "__reactContainer$" + dl,
                    ml = "__reactEvents$" + dl,
                    gl = "__reactListeners$" + dl,
                    vl = "__reactHandles$" + dl;

                function yl(e3) {
                    var n3 = e3[fl];
                    if (n3) return n3;
                    for (var t3 = e3.parentNode; t3;) {
                        if (n3 = t3[hl] || t3[fl]) {
                            if (t3 = n3.alternate, n3.child !== null || t3 !== null && t3.child !== null)
                                for (e3 = cl(e3); e3 !== null;) {
                                    if (t3 = e3[fl]) return t3;
                                    e3 = cl(e3)
                                }
                            return n3
                        }
                        t3 = (e3 = t3).parentNode
                    }
                    return null
                }

                function bl(e3) {
                    return !(e3 = e3[fl] || e3[hl]) || e3.tag !== 5 && e3.tag !== 6 && e3.tag !== 13 && e3.tag !== 3 ? null : e3
                }

                function wl(e3) {
                    if (e3.tag === 5 || e3.tag === 6) return e3.stateNode;
                    throw Error(a2(33))
                }

                function kl(e3) {
                    return e3[pl] || null
                }
                var Sl = [],
                    xl = -1;

                function El(e3) {
                    return {
                        current: e3
                    }
                }

                function Nl(e3) {
                    0 > xl || (e3.current = Sl[xl], Sl[xl] = null, xl--)
                }

                function Cl(e3, n3) {
                    xl++, Sl[xl] = e3.current, e3.current = n3
                }
                var _l = {},
                    zl = El(_l),
                    Pl = El(!1),
                    Ll = _l;

                function Tl(e3, n3) {
                    var t3 = e3.type.contextTypes;
                    if (!t3) return _l;
                    var r3 = e3.stateNode;
                    if (r3 && r3.__reactInternalMemoizedUnmaskedChildContext === n3) return r3.__reactInternalMemoizedMaskedChildContext;
                    var l3, a3 = {};
                    for (l3 in t3) a3[l3] = n3[l3];
                    return r3 && ((e3 = e3.stateNode).__reactInternalMemoizedUnmaskedChildContext = n3, e3.__reactInternalMemoizedMaskedChildContext = a3), a3
                }

                function jl(e3) {
                    return (e3 = e3.childContextTypes) !== null && e3 !== void 0
                }

                function Rl() {
                    Nl(Pl), Nl(zl)
                }

                function Ml(e3, n3, t3) {
                    if (zl.current !== _l) throw Error(a2(168));
                    Cl(zl, n3), Cl(Pl, t3)
                }

                function Il(e3, n3, t3) {
                    var r3 = e3.stateNode;
                    if (n3 = n3.childContextTypes, typeof r3.getChildContext != "function") return t3;
                    for (var l3 in r3 = r3.getChildContext())
                        if (!(l3 in n3)) throw Error(a2(108, V(e3) || "Unknown", l3));
                    return A({}, t3, r3)
                }

                function Dl(e3) {
                    return e3 = (e3 = e3.stateNode) && e3.__reactInternalMemoizedMergedChildContext || _l, Ll = zl.current, Cl(zl, e3), Cl(Pl, Pl.current), !0
                }

                function Al(e3, n3, t3) {
                    var r3 = e3.stateNode;
                    if (!r3) throw Error(a2(169));
                    t3 ? (e3 = Il(e3, n3, Ll), r3.__reactInternalMemoizedMergedChildContext = e3, Nl(Pl), Nl(zl), Cl(zl, e3)) : Nl(Pl), Cl(Pl, t3)
                }
                var Fl = null,
                    Ol = !1,
                    Ul = !1;

                function Bl(e3) {
                    Fl === null ? Fl = [e3] : Fl.push(e3)
                }

                function Wl() {
                    if (!Ul && Fl !== null) {
                        Ul = !0;
                        var e3 = 0,
                            n3 = wn;
                        try {
                            var t3 = Fl;
                            for (wn = 1; e3 < t3.length; e3++) {
                                var r3 = t3[e3];
                                do r3 = r3(!0); while (r3 !== null)
                            }
                            Fl = null, Ol = !1
                        } catch (l3) {
                            throw Fl !== null && (Fl = Fl.slice(e3 + 1)), Ge(Ke, Wl), l3
                        } finally {
                            wn = n3, Ul = !1
                        }
                    }
                    return null
                }
                var Vl = [],
                    Hl = 0,
                    Ql = null,
                    Yl = 0,
                    Gl = [],
                    $l = 0,
                    Xl = null,
                    Zl = 1,
                    Jl = "";

                function ql(e3, n3) {
                    Vl[Hl++] = Yl, Vl[Hl++] = Ql, Ql = e3, Yl = n3
                }

                function Kl(e3, n3, t3) {
                    Gl[$l++] = Zl, Gl[$l++] = Jl, Gl[$l++] = Xl, Xl = e3;
                    var r3 = Zl;
                    e3 = Jl;
                    var l3 = 32 - on(r3) - 1;
                    r3 &= ~(1 << l3), t3 += 1;
                    var a3 = 32 - on(n3) + l3;
                    if (30 < a3) {
                        var o3 = l3 - l3 % 5;
                        a3 = (r3 & (1 << o3) - 1).toString(32), r3 >>= o3, l3 -= o3, Zl = 1 << 32 - on(n3) + l3 | t3 << l3 | r3, Jl = a3 + e3
                    } else Zl = 1 << a3 | t3 << l3 | r3, Jl = e3
                }

                function ea(e3) {
                    e3.return !== null && (ql(e3, 1), Kl(e3, 1, 0))
                }

                function na(e3) {
                    for (; e3 === Ql;) Ql = Vl[--Hl], Vl[Hl] = null, Yl = Vl[--Hl], Vl[Hl] = null;
                    for (; e3 === Xl;) Xl = Gl[--$l], Gl[$l] = null, Jl = Gl[--$l], Gl[$l] = null, Zl = Gl[--$l], Gl[$l] = null
                }
                var ta = null,
                    ra = null,
                    la = !1,
                    aa = null;

                function oa(e3, n3) {
                    var t3 = Ts(5, null, null, 0);
                    t3.elementType = "DELETED", t3.stateNode = n3, t3.return = e3, (n3 = e3.deletions) === null ? (e3.deletions = [t3], e3.flags |= 16) : n3.push(t3)
                }

                function ia(e3, n3) {
                    switch (e3.tag) {
                        case 5:
                            var t3 = e3.type;
                            return (n3 = n3.nodeType !== 1 || t3.toLowerCase() !== n3.nodeName.toLowerCase() ? null : n3) !== null && (e3.stateNode = n3, ta = e3, ra = sl(n3.firstChild), !0);
                        case 6:
                            return (n3 = e3.pendingProps === "" || n3.nodeType !== 3 ? null : n3) !== null && (e3.stateNode = n3, ta = e3, ra = null, !0);
                        case 13:
                            return (n3 = n3.nodeType !== 8 ? null : n3) !== null && (t3 = Xl !== null ? {
                                id: Zl,
                                overflow: Jl
                            } : null, e3.memoizedState = {
                                dehydrated: n3,
                                treeContext: t3,
                                retryLane: 1073741824
                            }, (t3 = Ts(18, null, null, 0)).stateNode = n3, t3.return = e3, e3.child = t3, ta = e3, ra = null, !0);
                        default:
                            return !1
                    }
                }

                function ua(e3) {
                    return (1 & e3.mode) !== 0 && (128 & e3.flags) === 0
                }

                function sa(e3) {
                    if (la) {
                        var n3 = ra;
                        if (n3) {
                            var t3 = n3;
                            if (!ia(e3, n3)) {
                                if (ua(e3)) throw Error(a2(418));
                                n3 = sl(t3.nextSibling);
                                var r3 = ta;
                                n3 && ia(e3, n3) ? oa(r3, t3) : (e3.flags = -4097 & e3.flags | 2, la = !1, ta = e3)
                            }
                        } else {
                            if (ua(e3)) throw Error(a2(418));
                            e3.flags = -4097 & e3.flags | 2, la = !1, ta = e3
                        }
                    }
                }

                function ca(e3) {
                    for (e3 = e3.return; e3 !== null && e3.tag !== 5 && e3.tag !== 3 && e3.tag !== 13;) e3 = e3.return;
                    ta = e3
                }

                function da(e3) {
                    if (e3 !== ta) return !1;
                    if (!la) return ca(e3), la = !0, !1;
                    var n3;
                    if ((n3 = e3.tag !== 3) && !(n3 = e3.tag !== 5) && (n3 = (n3 = e3.type) !== "head" && n3 !== "body" && !tl(e3.type, e3.memoizedProps)), n3 && (n3 = ra)) {
                        if (ua(e3)) throw fa(), Error(a2(418));
                        for (; n3;) oa(e3, n3), n3 = sl(n3.nextSibling)
                    }
                    if (ca(e3), e3.tag === 13) {
                        if (!(e3 = (e3 = e3.memoizedState) !== null ? e3.dehydrated : null)) throw Error(a2(317));
                        e: {
                            for (e3 = e3.nextSibling, n3 = 0; e3;) {
                                if (e3.nodeType === 8) {
                                    var t3 = e3.data;
                                    if (t3 === "/$") {
                                        if (n3 === 0) {
                                            ra = sl(e3.nextSibling);
                                            break e
                                        }
                                        n3--
                                    } else t3 !== "$" && t3 !== "$!" && t3 !== "$?" || n3++
                                }
                                e3 = e3.nextSibling
                            }
                            ra = null
                        }
                    } else ra = ta ? sl(e3.stateNode.nextSibling) : null;
                    return !0
                }

                function fa() {
                    for (var e3 = ra; e3;) e3 = sl(e3.nextSibling)
                }

                function pa() {
                    ra = ta = null, la = !1
                }

                function ha(e3) {
                    aa === null ? aa = [e3] : aa.push(e3)
                }
                var ma = w.ReactCurrentBatchConfig;

                function ga(e3, n3, t3) {
                    if ((e3 = t3.ref) !== null && typeof e3 != "function" && typeof e3 != "object") {
                        if (t3._owner) {
                            if (t3 = t3._owner) {
                                if (t3.tag !== 1) throw Error(a2(309));
                                var r3 = t3.stateNode
                            }
                            if (!r3) throw Error(a2(147, e3));
                            var l3 = r3,
                                o3 = "" + e3;
                            return n3 !== null && n3.ref !== null && typeof n3.ref == "function" && n3.ref._stringRef === o3 ? n3.ref : (n3 = function(e4) {
                                var n4 = l3.refs;
                                e4 === null ? delete n4[o3] : n4[o3] = e4
                            }, n3._stringRef = o3, n3)
                        }
                        if (typeof e3 != "string") throw Error(a2(284));
                        if (!t3._owner) throw Error(a2(290, e3))
                    }
                    return e3
                }

                function va(e3, n3) {
                    throw e3 = Object.prototype.toString.call(n3), Error(a2(31, e3 === "[object Object]" ? "object with keys {" + Object.keys(n3).join(", ") + "}" : e3))
                }

                function ya(e3) {
                    return (0, e3._init)(e3._payload)
                }

                function ba(e3) {
                    function n3(n4, t4) {
                        if (e3) {
                            var r4 = n4.deletions;
                            r4 === null ? (n4.deletions = [t4], n4.flags |= 16) : r4.push(t4)
                        }
                    }

                    function t3(t4, r4) {
                        if (!e3) return null;
                        for (; r4 !== null;) n3(t4, r4), r4 = r4.sibling;
                        return null
                    }

                    function r3(e4, n4) {
                        for (e4 = new Map; n4 !== null;) n4.key !== null ? e4.set(n4.key, n4) : e4.set(n4.index, n4), n4 = n4.sibling;
                        return e4
                    }

                    function l3(e4, n4) {
                        return (e4 = Rs(e4, n4)).index = 0, e4.sibling = null, e4
                    }

                    function o3(n4, t4, r4) {
                        return n4.index = r4, e3 ? (r4 = n4.alternate) !== null ? (r4 = r4.index) < t4 ? (n4.flags |= 2, t4) : r4 : (n4.flags |= 2, t4) : (n4.flags |= 1048576, t4)
                    }

                    function i3(n4) {
                        return e3 && n4.alternate === null && (n4.flags |= 2), n4
                    }

                    function u3(e4, n4, t4, r4) {
                        return n4 === null || n4.tag !== 6 ? ((n4 = As(t4, e4.mode, r4)).return = e4, n4) : ((n4 = l3(n4, t4)).return = e4, n4)
                    }

                    function s3(e4, n4, t4, r4) {
                        var a3 = t4.type;
                        return a3 === x ? d3(e4, n4, t4.props.children, r4, t4.key) : n4 !== null && (n4.elementType === a3 || typeof a3 == "object" && a3 !== null && a3.$$typeof === j && ya(a3) === n4.type) ? ((r4 = l3(n4, t4.props)).ref = ga(e4, n4, t4), r4.return = e4, r4) : ((r4 = Ms(t4.type, t4.key, t4.props, null, e4.mode, r4)).ref = ga(e4, n4, t4), r4.return = e4, r4)
                    }

                    function c3(e4, n4, t4, r4) {
                        return n4 === null || n4.tag !== 4 || n4.stateNode.containerInfo !== t4.containerInfo || n4.stateNode.implementation !== t4.implementation ? ((n4 = Fs(t4, e4.mode, r4)).return = e4, n4) : ((n4 = l3(n4, t4.children || [])).return = e4, n4)
                    }

                    function d3(e4, n4, t4, r4, a3) {
                        return n4 === null || n4.tag !== 7 ? ((n4 = Is(t4, e4.mode, r4, a3)).return = e4, n4) : ((n4 = l3(n4, t4)).return = e4, n4)
                    }

                    function f2(e4, n4, t4) {
                        if (typeof n4 == "string" && n4 !== "" || typeof n4 == "number") return (n4 = As("" + n4, e4.mode, t4)).return = e4, n4;
                        if (typeof n4 == "object" && n4 !== null) {
                            switch (n4.$$typeof) {
                                case k:
                                    return (t4 = Ms(n4.type, n4.key, n4.props, null, e4.mode, t4)).ref = ga(e4, null, n4), t4.return = e4, t4;
                                case S:
                                    return (n4 = Fs(n4, e4.mode, t4)).return = e4, n4;
                                case j:
                                    return f2(e4, (0, n4._init)(n4._payload), t4)
                            }
                            if (ne(n4) || I(n4)) return (n4 = Is(n4, e4.mode, t4, null)).return = e4, n4;
                            va(e4, n4)
                        }
                        return null
                    }

                    function p2(e4, n4, t4, r4) {
                        var l4 = n4 !== null ? n4.key : null;
                        if (typeof t4 == "string" && t4 !== "" || typeof t4 == "number") return l4 !== null ? null : u3(e4, n4, "" + t4, r4);
                        if (typeof t4 == "object" && t4 !== null) {
                            switch (t4.$$typeof) {
                                case k:
                                    return t4.key === l4 ? s3(e4, n4, t4, r4) : null;
                                case S:
                                    return t4.key === l4 ? c3(e4, n4, t4, r4) : null;
                                case j:
                                    return p2(e4, n4, (l4 = t4._init)(t4._payload), r4)
                            }
                            if (ne(t4) || I(t4)) return l4 !== null ? null : d3(e4, n4, t4, r4, null);
                            va(e4, t4)
                        }
                        return null
                    }

                    function h2(e4, n4, t4, r4, l4) {
                        if (typeof r4 == "string" && r4 !== "" || typeof r4 == "number") return u3(n4, e4 = e4.get(t4) || null, "" + r4, l4);
                        if (typeof r4 == "object" && r4 !== null) {
                            switch (r4.$$typeof) {
                                case k:
                                    return s3(n4, e4 = e4.get(r4.key === null ? t4 : r4.key) || null, r4, l4);
                                case S:
                                    return c3(n4, e4 = e4.get(r4.key === null ? t4 : r4.key) || null, r4, l4);
                                case j:
                                    return h2(e4, n4, t4, (0, r4._init)(r4._payload), l4)
                            }
                            if (ne(r4) || I(r4)) return d3(n4, e4 = e4.get(t4) || null, r4, l4, null);
                            va(n4, r4)
                        }
                        return null
                    }

                    function m2(l4, a3, i4, u4) {
                        for (var s4 = null, c4 = null, d4 = a3, m3 = a3 = 0, g3 = null; d4 !== null && m3 < i4.length; m3++) {
                            d4.index > m3 ? (g3 = d4, d4 = null) : g3 = d4.sibling;
                            var v2 = p2(l4, d4, i4[m3], u4);
                            if (v2 === null) {
                                d4 === null && (d4 = g3);
                                break
                            }
                            e3 && d4 && v2.alternate === null && n3(l4, d4), a3 = o3(v2, a3, m3), c4 === null ? s4 = v2 : c4.sibling = v2, c4 = v2, d4 = g3
                        }
                        if (m3 === i4.length) return t3(l4, d4), la && ql(l4, m3), s4;
                        if (d4 === null) {
                            for (; m3 < i4.length; m3++)(d4 = f2(l4, i4[m3], u4)) !== null && (a3 = o3(d4, a3, m3), c4 === null ? s4 = d4 : c4.sibling = d4, c4 = d4);
                            return la && ql(l4, m3), s4
                        }
                        for (d4 = r3(l4, d4); m3 < i4.length; m3++)(g3 = h2(d4, l4, m3, i4[m3], u4)) !== null && (e3 && g3.alternate !== null && d4.delete(g3.key === null ? m3 : g3.key), a3 = o3(g3, a3, m3), c4 === null ? s4 = g3 : c4.sibling = g3, c4 = g3);
                        return e3 && d4.forEach(function(e4) {
                            return n3(l4, e4)
                        }), la && ql(l4, m3), s4
                    }

                    function g2(l4, i4, u4, s4) {
                        var c4 = I(u4);
                        if (typeof c4 != "function") throw Error(a2(150));
                        if ((u4 = c4.call(u4)) == null) throw Error(a2(151));
                        for (var d4 = c4 = null, m3 = i4, g3 = i4 = 0, v2 = null, y2 = u4.next(); m3 !== null && !y2.done; g3++, y2 = u4.next()) {
                            m3.index > g3 ? (v2 = m3, m3 = null) : v2 = m3.sibling;
                            var b2 = p2(l4, m3, y2.value, s4);
                            if (b2 === null) {
                                m3 === null && (m3 = v2);
                                break
                            }
                            e3 && m3 && b2.alternate === null && n3(l4, m3), i4 = o3(b2, i4, g3), d4 === null ? c4 = b2 : d4.sibling = b2, d4 = b2, m3 = v2
                        }
                        if (y2.done) return t3(l4, m3), la && ql(l4, g3), c4;
                        if (m3 === null) {
                            for (; !y2.done; g3++, y2 = u4.next())(y2 = f2(l4, y2.value, s4)) !== null && (i4 = o3(y2, i4, g3), d4 === null ? c4 = y2 : d4.sibling = y2, d4 = y2);
                            return la && ql(l4, g3), c4
                        }
                        for (m3 = r3(l4, m3); !y2.done; g3++, y2 = u4.next())(y2 = h2(m3, l4, g3, y2.value, s4)) !== null && (e3 && y2.alternate !== null && m3.delete(y2.key === null ? g3 : y2.key), i4 = o3(y2, i4, g3), d4 === null ? c4 = y2 : d4.sibling = y2, d4 = y2);
                        return e3 && m3.forEach(function(e4) {
                            return n3(l4, e4)
                        }), la && ql(l4, g3), c4
                    }
                    return function e4(r4, a3, o4, u4) {
                        if (typeof o4 == "object" && o4 !== null && o4.type === x && o4.key === null && (o4 = o4.props.children), typeof o4 == "object" && o4 !== null) {
                            switch (o4.$$typeof) {
                                case k:
                                    e: {
                                        for (var s4 = o4.key, c4 = a3; c4 !== null;) {
                                            if (c4.key === s4) {
                                                if ((s4 = o4.type) === x) {
                                                    if (c4.tag === 7) {
                                                        t3(r4, c4.sibling), (a3 = l3(c4, o4.props.children)).return = r4, r4 = a3;
                                                        break e
                                                    }
                                                } else if (c4.elementType === s4 || typeof s4 == "object" && s4 !== null && s4.$$typeof === j && ya(s4) === c4.type) {
                                                    t3(r4, c4.sibling), (a3 = l3(c4, o4.props)).ref = ga(r4, c4, o4), a3.return = r4, r4 = a3;
                                                    break e
                                                }
                                                t3(r4, c4);
                                                break
                                            }
                                            n3(r4, c4), c4 = c4.sibling
                                        }
                                        o4.type === x ? ((a3 = Is(o4.props.children, r4.mode, u4, o4.key)).return = r4, r4 = a3) : ((u4 = Ms(o4.type, o4.key, o4.props, null, r4.mode, u4)).ref = ga(r4, a3, o4), u4.return = r4, r4 = u4)
                                    }
                                    return i3(r4);
                                case S:
                                    e: {
                                        for (c4 = o4.key; a3 !== null;) {
                                            if (a3.key === c4) {
                                                if (a3.tag === 4 && a3.stateNode.containerInfo === o4.containerInfo && a3.stateNode.implementation === o4.implementation) {
                                                    t3(r4, a3.sibling), (a3 = l3(a3, o4.children || [])).return = r4, r4 = a3;
                                                    break e
                                                }
                                                t3(r4, a3);
                                                break
                                            }
                                            n3(r4, a3), a3 = a3.sibling
                                        }(a3 = Fs(o4, r4.mode, u4)).return = r4,
                                        r4 = a3
                                    }
                                    return i3(r4);
                                case j:
                                    return e4(r4, a3, (c4 = o4._init)(o4._payload), u4)
                            }
                            if (ne(o4)) return m2(r4, a3, o4, u4);
                            if (I(o4)) return g2(r4, a3, o4, u4);
                            va(r4, o4)
                        }
                        return typeof o4 == "string" && o4 !== "" || typeof o4 == "number" ? (o4 = "" + o4, a3 !== null && a3.tag === 6 ? (t3(r4, a3.sibling), (a3 = l3(a3, o4)).return = r4, r4 = a3) : (t3(r4, a3), (a3 = As(o4, r4.mode, u4)).return = r4, r4 = a3), i3(r4)) : t3(r4, a3)
                    }
                }
                var wa = ba(!0),
                    ka = ba(!1),
                    Sa = El(null),
                    xa = null,
                    Ea = null,
                    Na = null;

                function Ca() {
                    Na = Ea = xa = null
                }

                function _a(e3) {
                    var n3 = Sa.current;
                    Nl(Sa), e3._currentValue = n3
                }

                function za(e3, n3, t3) {
                    for (; e3 !== null;) {
                        var r3 = e3.alternate;
                        if ((e3.childLanes & n3) !== n3 ? (e3.childLanes |= n3, r3 !== null && (r3.childLanes |= n3)) : r3 !== null && (r3.childLanes & n3) !== n3 && (r3.childLanes |= n3), e3 === t3) break;
                        e3 = e3.return
                    }
                }

                function Pa(e3, n3) {
                    xa = e3, Na = Ea = null, (e3 = e3.dependencies) !== null && e3.firstContext !== null && (e3.lanes & n3 && (bi = !0), e3.firstContext = null)
                }

                function La(e3) {
                    var n3 = e3._currentValue;
                    if (Na !== e3)
                        if (e3 = {
                                context: e3,
                                memoizedValue: n3,
                                next: null
                            }, Ea === null) {
                            if (xa === null) throw Error(a2(308));
                            Ea = e3, xa.dependencies = {
                                lanes: 0,
                                firstContext: e3
                            }
                        } else Ea = Ea.next = e3;
                    return n3
                }
                var Ta = null;

                function ja(e3) {
                    Ta === null ? Ta = [e3] : Ta.push(e3)
                }

                function Ra(e3, n3, t3, r3) {
                    var l3 = n3.interleaved;
                    return l3 === null ? (t3.next = t3, ja(n3)) : (t3.next = l3.next, l3.next = t3), n3.interleaved = t3, Ma(e3, r3)
                }

                function Ma(e3, n3) {
                    e3.lanes |= n3;
                    var t3 = e3.alternate;
                    for (t3 !== null && (t3.lanes |= n3), t3 = e3, e3 = e3.return; e3 !== null;) e3.childLanes |= n3, (t3 = e3.alternate) !== null && (t3.childLanes |= n3), t3 = e3, e3 = e3.return;
                    return t3.tag === 3 ? t3.stateNode : null
                }
                var Ia = !1;

                function Da(e3) {
                    e3.updateQueue = {
                        baseState: e3.memoizedState,
                        firstBaseUpdate: null,
                        lastBaseUpdate: null,
                        shared: {
                            pending: null,
                            interleaved: null,
                            lanes: 0
                        },
                        effects: null
                    }
                }

                function Aa(e3, n3) {
                    e3 = e3.updateQueue, n3.updateQueue === e3 && (n3.updateQueue = {
                        baseState: e3.baseState,
                        firstBaseUpdate: e3.firstBaseUpdate,
                        lastBaseUpdate: e3.lastBaseUpdate,
                        shared: e3.shared,
                        effects: e3.effects
                    })
                }

                function Fa(e3, n3) {
                    return {
                        eventTime: e3,
                        lane: n3,
                        tag: 0,
                        payload: null,
                        callback: null,
                        next: null
                    }
                }

                function Oa(e3, n3, t3) {
                    var r3 = e3.updateQueue;
                    if (r3 === null) return null;
                    if (r3 = r3.shared, (2 & zu) !== 0) {
                        var l3 = r3.pending;
                        return l3 === null ? n3.next = n3 : (n3.next = l3.next, l3.next = n3), r3.pending = n3, Ma(e3, t3)
                    }
                    return (l3 = r3.interleaved) === null ? (n3.next = n3, ja(r3)) : (n3.next = l3.next, l3.next = n3), r3.interleaved = n3, Ma(e3, t3)
                }

                function Ua(e3, n3, t3) {
                    if ((n3 = n3.updateQueue) !== null && (n3 = n3.shared, (4194240 & t3) !== 0)) {
                        var r3 = n3.lanes;
                        t3 |= r3 &= e3.pendingLanes, n3.lanes = t3, bn(e3, t3)
                    }
                }

                function Ba(e3, n3) {
                    var t3 = e3.updateQueue,
                        r3 = e3.alternate;
                    if (r3 !== null && t3 === (r3 = r3.updateQueue)) {
                        var l3 = null,
                            a3 = null;
                        if ((t3 = t3.firstBaseUpdate) !== null) {
                            do {
                                var o3 = {
                                    eventTime: t3.eventTime,
                                    lane: t3.lane,
                                    tag: t3.tag,
                                    payload: t3.payload,
                                    callback: t3.callback,
                                    next: null
                                };
                                a3 === null ? l3 = a3 = o3 : a3 = a3.next = o3, t3 = t3.next
                            } while (t3 !== null);
                            a3 === null ? l3 = a3 = n3 : a3 = a3.next = n3
                        } else l3 = a3 = n3;
                        return t3 = {
                            baseState: r3.baseState,
                            firstBaseUpdate: l3,
                            lastBaseUpdate: a3,
                            shared: r3.shared,
                            effects: r3.effects
                        }, void(e3.updateQueue = t3)
                    }(e3 = t3.lastBaseUpdate) === null ? t3.firstBaseUpdate = n3 : e3.next = n3, t3.lastBaseUpdate = n3
                }

                function Wa(e3, n3, t3, r3) {
                    var l3 = e3.updateQueue;
                    Ia = !1;
                    var a3 = l3.firstBaseUpdate,
                        o3 = l3.lastBaseUpdate,
                        i3 = l3.shared.pending;
                    if (i3 !== null) {
                        l3.shared.pending = null;
                        var u3 = i3,
                            s3 = u3.next;
                        u3.next = null, o3 === null ? a3 = s3 : o3.next = s3, o3 = u3;
                        var c3 = e3.alternate;
                        c3 !== null && (i3 = (c3 = c3.updateQueue).lastBaseUpdate) !== o3 && (i3 === null ? c3.firstBaseUpdate = s3 : i3.next = s3, c3.lastBaseUpdate = u3)
                    }
                    if (a3 !== null) {
                        var d3 = l3.baseState;
                        for (o3 = 0, c3 = s3 = u3 = null, i3 = a3;;) {
                            var f2 = i3.lane,
                                p2 = i3.eventTime;
                            if ((r3 & f2) === f2) {
                                c3 !== null && (c3 = c3.next = {
                                    eventTime: p2,
                                    lane: 0,
                                    tag: i3.tag,
                                    payload: i3.payload,
                                    callback: i3.callback,
                                    next: null
                                });
                                e: {
                                    var h2 = e3,
                                        m2 = i3;
                                    switch (f2 = n3, p2 = t3, m2.tag) {
                                        case 1:
                                            if (typeof(h2 = m2.payload) == "function") {
                                                d3 = h2.call(p2, d3, f2);
                                                break e
                                            }
                                            d3 = h2;
                                            break e;
                                        case 3:
                                            h2.flags = -65537 & h2.flags | 128;
                                        case 0:
                                            if ((f2 = typeof(h2 = m2.payload) == "function" ? h2.call(p2, d3, f2) : h2) === null || f2 === void 0) break e;
                                            d3 = A({}, d3, f2);
                                            break e;
                                        case 2:
                                            Ia = !0
                                    }
                                }
                                i3.callback !== null && i3.lane !== 0 && (e3.flags |= 64, (f2 = l3.effects) === null ? l3.effects = [i3] : f2.push(i3))
                            } else p2 = {
                                eventTime: p2,
                                lane: f2,
                                tag: i3.tag,
                                payload: i3.payload,
                                callback: i3.callback,
                                next: null
                            }, c3 === null ? (s3 = c3 = p2, u3 = d3) : c3 = c3.next = p2, o3 |= f2;
                            if ((i3 = i3.next) === null) {
                                if ((i3 = l3.shared.pending) === null) break;
                                i3 = (f2 = i3).next, f2.next = null, l3.lastBaseUpdate = f2, l3.shared.pending = null
                            }
                        }
                        if (c3 === null && (u3 = d3), l3.baseState = u3, l3.firstBaseUpdate = s3, l3.lastBaseUpdate = c3, (n3 = l3.shared.interleaved) !== null) {
                            l3 = n3;
                            do o3 |= l3.lane, l3 = l3.next; while (l3 !== n3)
                        } else a3 === null && (l3.shared.lanes = 0);
                        Du |= o3, e3.lanes = o3, e3.memoizedState = d3
                    }
                }

                function Va(e3, n3, t3) {
                    if (e3 = n3.effects, n3.effects = null, e3 !== null)
                        for (n3 = 0; n3 < e3.length; n3++) {
                            var r3 = e3[n3],
                                l3 = r3.callback;
                            if (l3 !== null) {
                                if (r3.callback = null, r3 = t3, typeof l3 != "function") throw Error(a2(191, l3));
                                l3.call(r3)
                            }
                        }
                }
                var Ha = {},
                    Qa = El(Ha),
                    Ya = El(Ha),
                    Ga = El(Ha);

                function $a(e3) {
                    if (e3 === Ha) throw Error(a2(174));
                    return e3
                }

                function Xa(e3, n3) {
                    switch (Cl(Ga, n3), Cl(Ya, e3), Cl(Qa, Ha), e3 = n3.nodeType) {
                        case 9:
                        case 11:
                            n3 = (n3 = n3.documentElement) ? n3.namespaceURI : ue(null, "");
                            break;
                        default:
                            n3 = ue(n3 = (e3 = e3 === 8 ? n3.parentNode : n3).namespaceURI || null, e3 = e3.tagName)
                    }
                    Nl(Qa), Cl(Qa, n3)
                }

                function Za() {
                    Nl(Qa), Nl(Ya), Nl(Ga)
                }

                function Ja(e3) {
                    $a(Ga.current);
                    var n3 = $a(Qa.current),
                        t3 = ue(n3, e3.type);
                    n3 !== t3 && (Cl(Ya, e3), Cl(Qa, t3))
                }

                function qa(e3) {
                    Ya.current === e3 && (Nl(Qa), Nl(Ya))
                }
                var Ka = El(0);

                function eo(e3) {
                    for (var n3 = e3; n3 !== null;) {
                        if (n3.tag === 13) {
                            var t3 = n3.memoizedState;
                            if (t3 !== null && ((t3 = t3.dehydrated) === null || t3.data === "$?" || t3.data === "$!")) return n3
                        } else if (n3.tag === 19 && n3.memoizedProps.revealOrder !== void 0) {
                            if (128 & n3.flags) return n3
                        } else if (n3.child !== null) {
                            n3.child.return = n3, n3 = n3.child;
                            continue
                        }
                        if (n3 === e3) break;
                        for (; n3.sibling === null;) {
                            if (n3.return === null || n3.return === e3) return null;
                            n3 = n3.return
                        }
                        n3.sibling.return = n3.return, n3 = n3.sibling
                    }
                    return null
                }
                var no = [];

                function to() {
                    for (var e3 = 0; e3 < no.length; e3++) no[e3]._workInProgressVersionPrimary = null;
                    no.length = 0
                }
                var ro = w.ReactCurrentDispatcher,
                    lo = w.ReactCurrentBatchConfig,
                    ao = 0,
                    oo = null,
                    io = null,
                    uo = null,
                    so = !1,
                    co = !1,
                    fo = 0,
                    po = 0;

                function ho() {
                    throw Error(a2(321))
                }

                function mo(e3, n3) {
                    if (n3 === null) return !1;
                    for (var t3 = 0; t3 < n3.length && t3 < e3.length; t3++)
                        if (!ir(e3[t3], n3[t3])) return !1;
                    return !0
                }

                function go(e3, n3, t3, r3, l3, o3) {
                    if (ao = o3, oo = n3, n3.memoizedState = null, n3.updateQueue = null, n3.lanes = 0, ro.current = e3 === null || e3.memoizedState === null ? Ko : ei, e3 = t3(r3, l3), co) {
                        o3 = 0;
                        do {
                            if (co = !1, fo = 0, 25 <= o3) throw Error(a2(301));
                            o3 += 1, uo = io = null, n3.updateQueue = null, ro.current = ni, e3 = t3(r3, l3)
                        } while (co)
                    }
                    if (ro.current = qo, n3 = io !== null && io.next !== null, ao = 0, uo = io = oo = null, so = !1, n3) throw Error(a2(300));
                    return e3
                }

                function vo() {
                    var e3 = fo !== 0;
                    return fo = 0, e3
                }

                function yo() {
                    var e3 = {
                        memoizedState: null,
                        baseState: null,
                        baseQueue: null,
                        queue: null,
                        next: null
                    };
                    return uo === null ? oo.memoizedState = uo = e3 : uo = uo.next = e3, uo
                }

                function bo() {
                    if (io === null) {
                        var e3 = oo.alternate;
                        e3 = e3 !== null ? e3.memoizedState : null
                    } else e3 = io.next;
                    var n3 = uo === null ? oo.memoizedState : uo.next;
                    if (n3 !== null) uo = n3, io = e3;
                    else {
                        if (e3 === null) throw Error(a2(310));
                        e3 = {
                            memoizedState: (io = e3).memoizedState,
                            baseState: io.baseState,
                            baseQueue: io.baseQueue,
                            queue: io.queue,
                            next: null
                        }, uo === null ? oo.memoizedState = uo = e3 : uo = uo.next = e3
                    }
                    return uo
                }

                function wo(e3, n3) {
                    return typeof n3 == "function" ? n3(e3) : n3
                }

                function ko(e3) {
                    var n3 = bo(),
                        t3 = n3.queue;
                    if (t3 === null) throw Error(a2(311));
                    t3.lastRenderedReducer = e3;
                    var r3 = io,
                        l3 = r3.baseQueue,
                        o3 = t3.pending;
                    if (o3 !== null) {
                        if (l3 !== null) {
                            var i3 = l3.next;
                            l3.next = o3.next, o3.next = i3
                        }
                        r3.baseQueue = l3 = o3, t3.pending = null
                    }
                    if (l3 !== null) {
                        o3 = l3.next, r3 = r3.baseState;
                        var u3 = i3 = null,
                            s3 = null,
                            c3 = o3;
                        do {
                            var d3 = c3.lane;
                            if ((ao & d3) === d3) s3 !== null && (s3 = s3.next = {
                                lane: 0,
                                action: c3.action,
                                hasEagerState: c3.hasEagerState,
                                eagerState: c3.eagerState,
                                next: null
                            }), r3 = c3.hasEagerState ? c3.eagerState : e3(r3, c3.action);
                            else {
                                var f2 = {
                                    lane: d3,
                                    action: c3.action,
                                    hasEagerState: c3.hasEagerState,
                                    eagerState: c3.eagerState,
                                    next: null
                                };
                                s3 === null ? (u3 = s3 = f2, i3 = r3) : s3 = s3.next = f2, oo.lanes |= d3, Du |= d3
                            }
                            c3 = c3.next
                        } while (c3 !== null && c3 !== o3);
                        s3 === null ? i3 = r3 : s3.next = u3, ir(r3, n3.memoizedState) || (bi = !0), n3.memoizedState = r3, n3.baseState = i3, n3.baseQueue = s3, t3.lastRenderedState = r3
                    }
                    if ((e3 = t3.interleaved) !== null) {
                        l3 = e3;
                        do o3 = l3.lane, oo.lanes |= o3, Du |= o3, l3 = l3.next; while (l3 !== e3)
                    } else l3 === null && (t3.lanes = 0);
                    return [n3.memoizedState, t3.dispatch]
                }

                function So(e3) {
                    var n3 = bo(),
                        t3 = n3.queue;
                    if (t3 === null) throw Error(a2(311));
                    t3.lastRenderedReducer = e3;
                    var r3 = t3.dispatch,
                        l3 = t3.pending,
                        o3 = n3.memoizedState;
                    if (l3 !== null) {
                        t3.pending = null;
                        var i3 = l3 = l3.next;
                        do o3 = e3(o3, i3.action), i3 = i3.next; while (i3 !== l3);
                        ir(o3, n3.memoizedState) || (bi = !0), n3.memoizedState = o3, n3.baseQueue === null && (n3.baseState = o3), t3.lastRenderedState = o3
                    }
                    return [o3, r3]
                }

                function xo() {}

                function Eo(e3, n3) {
                    var t3 = oo,
                        r3 = bo(),
                        l3 = n3(),
                        o3 = !ir(r3.memoizedState, l3);
                    if (o3 && (r3.memoizedState = l3, bi = !0), r3 = r3.queue, Do(_o.bind(null, t3, r3, e3), [e3]), r3.getSnapshot !== n3 || o3 || uo !== null && 1 & uo.memoizedState.tag) {
                        if (t3.flags |= 2048, To(9, Co.bind(null, t3, r3, l3, n3), void 0, null), Pu === null) throw Error(a2(349));
                        30 & ao || No(t3, n3, l3)
                    }
                    return l3
                }

                function No(e3, n3, t3) {
                    e3.flags |= 16384, e3 = {
                        getSnapshot: n3,
                        value: t3
                    }, (n3 = oo.updateQueue) === null ? (n3 = {
                        lastEffect: null,
                        stores: null
                    }, oo.updateQueue = n3, n3.stores = [e3]) : (t3 = n3.stores) === null ? n3.stores = [e3] : t3.push(e3)
                }

                function Co(e3, n3, t3, r3) {
                    n3.value = t3, n3.getSnapshot = r3, zo(n3) && Po(e3)
                }

                function _o(e3, n3, t3) {
                    return t3(function() {
                        zo(n3) && Po(e3)
                    })
                }

                function zo(e3) {
                    var n3 = e3.getSnapshot;
                    e3 = e3.value;
                    try {
                        var t3 = n3();
                        return !ir(e3, t3)
                    } catch {
                        return !0
                    }
                }

                function Po(e3) {
                    var n3 = Ma(e3, 1);
                    n3 !== null && ts(n3, e3, 1, -1)
                }

                function Lo(e3) {
                    var n3 = yo();
                    return typeof e3 == "function" && (e3 = e3()), n3.memoizedState = n3.baseState = e3, e3 = {
                        pending: null,
                        interleaved: null,
                        lanes: 0,
                        dispatch: null,
                        lastRenderedReducer: wo,
                        lastRenderedState: e3
                    }, n3.queue = e3, e3 = e3.dispatch = $o.bind(null, oo, e3), [n3.memoizedState, e3]
                }

                function To(e3, n3, t3, r3) {
                    return e3 = {
                        tag: e3,
                        create: n3,
                        destroy: t3,
                        deps: r3,
                        next: null
                    }, (n3 = oo.updateQueue) === null ? (n3 = {
                        lastEffect: null,
                        stores: null
                    }, oo.updateQueue = n3, n3.lastEffect = e3.next = e3) : (t3 = n3.lastEffect) === null ? n3.lastEffect = e3.next = e3 : (r3 = t3.next, t3.next = e3, e3.next = r3, n3.lastEffect = e3), e3
                }

                function jo() {
                    return bo().memoizedState
                }

                function Ro(e3, n3, t3, r3) {
                    var l3 = yo();
                    oo.flags |= e3, l3.memoizedState = To(1 | n3, t3, void 0, r3 === void 0 ? null : r3)
                }

                function Mo(e3, n3, t3, r3) {
                    var l3 = bo();
                    r3 = r3 === void 0 ? null : r3;
                    var a3 = void 0;
                    if (io !== null) {
                        var o3 = io.memoizedState;
                        if (a3 = o3.destroy, r3 !== null && mo(r3, o3.deps)) return void(l3.memoizedState = To(n3, t3, a3, r3))
                    }
                    oo.flags |= e3, l3.memoizedState = To(1 | n3, t3, a3, r3)
                }

                function Io(e3, n3) {
                    return Ro(8390656, 8, e3, n3)
                }

                function Do(e3, n3) {
                    return Mo(2048, 8, e3, n3)
                }

                function Ao(e3, n3) {
                    return Mo(4, 2, e3, n3)
                }

                function Fo(e3, n3) {
                    return Mo(4, 4, e3, n3)
                }

                function Oo(e3, n3) {
                    return typeof n3 == "function" ? (e3 = e3(), n3(e3), function() {
                        n3(null)
                    }) : n3 != null ? (e3 = e3(), n3.current = e3, function() {
                        n3.current = null
                    }) : void 0
                }

                function Uo(e3, n3, t3) {
                    return t3 = t3 != null ? t3.concat([e3]) : null, Mo(4, 4, Oo.bind(null, n3, e3), t3)
                }

                function Bo() {}

                function Wo(e3, n3) {
                    var t3 = bo();
                    n3 = n3 === void 0 ? null : n3;
                    var r3 = t3.memoizedState;
                    return r3 !== null && n3 !== null && mo(n3, r3[1]) ? r3[0] : (t3.memoizedState = [e3, n3], e3)
                }

                function Vo(e3, n3) {
                    var t3 = bo();
                    n3 = n3 === void 0 ? null : n3;
                    var r3 = t3.memoizedState;
                    return r3 !== null && n3 !== null && mo(n3, r3[1]) ? r3[0] : (e3 = e3(), t3.memoizedState = [e3, n3], e3)
                }

                function Ho(e3, n3, t3) {
                    return 21 & ao ? (ir(t3, n3) || (t3 = gn(), oo.lanes |= t3, Du |= t3, e3.baseState = !0), n3) : (e3.baseState && (e3.baseState = !1, bi = !0), e3.memoizedState = t3)
                }

                function Qo(e3, n3) {
                    var t3 = wn;
                    wn = t3 !== 0 && 4 > t3 ? t3 : 4, e3(!0);
                    var r3 = lo.transition;
                    lo.transition = {};
                    try {
                        e3(!1), n3()
                    } finally {
                        wn = t3, lo.transition = r3
                    }
                }

                function Yo() {
                    return bo().memoizedState
                }

                function Go(e3, n3, t3) {
                    var r3 = ns(e3);
                    t3 = {
                        lane: r3,
                        action: t3,
                        hasEagerState: !1,
                        eagerState: null,
                        next: null
                    }, Xo(e3) ? Zo(n3, t3) : (t3 = Ra(e3, n3, t3, r3)) !== null && (ts(t3, e3, r3, es()), Jo(t3, n3, r3))
                }

                function $o(e3, n3, t3) {
                    var r3 = ns(e3),
                        l3 = {
                            lane: r3,
                            action: t3,
                            hasEagerState: !1,
                            eagerState: null,
                            next: null
                        };
                    if (Xo(e3)) Zo(n3, l3);
                    else {
                        var a3 = e3.alternate;
                        if (e3.lanes === 0 && (a3 === null || a3.lanes === 0) && (a3 = n3.lastRenderedReducer) !== null) try {
                            var o3 = n3.lastRenderedState,
                                i3 = a3(o3, t3);
                            if (l3.hasEagerState = !0, l3.eagerState = i3, ir(i3, o3)) {
                                var u3 = n3.interleaved;
                                return u3 === null ? (l3.next = l3, ja(n3)) : (l3.next = u3.next, u3.next = l3), void(n3.interleaved = l3)
                            }
                        } catch {}(t3 = Ra(e3, n3, l3, r3)) !== null && (ts(t3, e3, r3, l3 = es()), Jo(t3, n3, r3))
                    }
                }

                function Xo(e3) {
                    var n3 = e3.alternate;
                    return e3 === oo || n3 !== null && n3 === oo
                }

                function Zo(e3, n3) {
                    co = so = !0;
                    var t3 = e3.pending;
                    t3 === null ? n3.next = n3 : (n3.next = t3.next, t3.next = n3), e3.pending = n3
                }

                function Jo(e3, n3, t3) {
                    if (4194240 & t3) {
                        var r3 = n3.lanes;
                        t3 |= r3 &= e3.pendingLanes, n3.lanes = t3, bn(e3, t3)
                    }
                }
                var qo = {
                        readContext: La,
                        useCallback: ho,
                        useContext: ho,
                        useEffect: ho,
                        useImperativeHandle: ho,
                        useInsertionEffect: ho,
                        useLayoutEffect: ho,
                        useMemo: ho,
                        useReducer: ho,
                        useRef: ho,
                        useState: ho,
                        useDebugValue: ho,
                        useDeferredValue: ho,
                        useTransition: ho,
                        useMutableSource: ho,
                        useSyncExternalStore: ho,
                        useId: ho,
                        unstable_isNewReconciler: !1
                    },
                    Ko = {
                        readContext: La,
                        useCallback: function(e3, n3) {
                            return yo().memoizedState = [e3, n3 === void 0 ? null : n3], e3
                        },
                        useContext: La,
                        useEffect: Io,
                        useImperativeHandle: function(e3, n3, t3) {
                            return t3 = t3 != null ? t3.concat([e3]) : null, Ro(4194308, 4, Oo.bind(null, n3, e3), t3)
                        },
                        useLayoutEffect: function(e3, n3) {
                            return Ro(4194308, 4, e3, n3)
                        },
                        useInsertionEffect: function(e3, n3) {
                            return Ro(4, 2, e3, n3)
                        },
                        useMemo: function(e3, n3) {
                            var t3 = yo();
                            return n3 = n3 === void 0 ? null : n3, e3 = e3(), t3.memoizedState = [e3, n3], e3
                        },
                        useReducer: function(e3, n3, t3) {
                            var r3 = yo();
                            return n3 = t3 !== void 0 ? t3(n3) : n3, r3.memoizedState = r3.baseState = n3, e3 = {
                                pending: null,
                                interleaved: null,
                                lanes: 0,
                                dispatch: null,
                                lastRenderedReducer: e3,
                                lastRenderedState: n3
                            }, r3.queue = e3, e3 = e3.dispatch = Go.bind(null, oo, e3), [r3.memoizedState, e3]
                        },
                        useRef: function(e3) {
                            return e3 = {
                                current: e3
                            }, yo().memoizedState = e3
                        },
                        useState: Lo,
                        useDebugValue: Bo,
                        useDeferredValue: function(e3) {
                            return yo().memoizedState = e3
                        },
                        useTransition: function() {
                            var e3 = Lo(!1),
                                n3 = e3[0];
                            return e3 = Qo.bind(null, e3[1]), yo().memoizedState = e3, [n3, e3]
                        },
                        useMutableSource: function() {},
                        useSyncExternalStore: function(e3, n3, t3) {
                            var r3 = oo,
                                l3 = yo();
                            if (la) {
                                if (t3 === void 0) throw Error(a2(407));
                                t3 = t3()
                            } else {
                                if (t3 = n3(), Pu === null) throw Error(a2(349));
                                30 & ao || No(r3, n3, t3)
                            }
                            l3.memoizedState = t3;
                            var o3 = {
                                value: t3,
                                getSnapshot: n3
                            };
                            return l3.queue = o3, Io(_o.bind(null, r3, o3, e3), [e3]), r3.flags |= 2048, To(9, Co.bind(null, r3, o3, t3, n3), void 0, null), t3
                        },
                        useId: function() {
                            var e3 = yo(),
                                n3 = Pu.identifierPrefix;
                            if (la) {
                                var t3 = Jl;
                                n3 = ":" + n3 + "R" + (t3 = (Zl & ~(1 << 32 - on(Zl) - 1)).toString(32) + t3), 0 < (t3 = fo++) && (n3 += "H" + t3.toString(32)), n3 += ":"
                            } else n3 = ":" + n3 + "r" + (t3 = po++).toString(32) + ":";
                            return e3.memoizedState = n3
                        },
                        unstable_isNewReconciler: !1
                    },
                    ei = {
                        readContext: La,
                        useCallback: Wo,
                        useContext: La,
                        useEffect: Do,
                        useImperativeHandle: Uo,
                        useInsertionEffect: Ao,
                        useLayoutEffect: Fo,
                        useMemo: Vo,
                        useReducer: ko,
                        useRef: jo,
                        useState: function() {
                            return ko(wo)
                        },
                        useDebugValue: Bo,
                        useDeferredValue: function(e3) {
                            return Ho(bo(), io.memoizedState, e3)
                        },
                        useTransition: function() {
                            return [ko(wo)[0], bo().memoizedState]
                        },
                        useMutableSource: xo,
                        useSyncExternalStore: Eo,
                        useId: Yo,
                        unstable_isNewReconciler: !1
                    },
                    ni = {
                        readContext: La,
                        useCallback: Wo,
                        useContext: La,
                        useEffect: Do,
                        useImperativeHandle: Uo,
                        useInsertionEffect: Ao,
                        useLayoutEffect: Fo,
                        useMemo: Vo,
                        useReducer: So,
                        useRef: jo,
                        useState: function() {
                            return So(wo)
                        },
                        useDebugValue: Bo,
                        useDeferredValue: function(e3) {
                            var n3 = bo();
                            return io === null ? n3.memoizedState = e3 : Ho(n3, io.memoizedState, e3)
                        },
                        useTransition: function() {
                            return [So(wo)[0], bo().memoizedState]
                        },
                        useMutableSource: xo,
                        useSyncExternalStore: Eo,
                        useId: Yo,
                        unstable_isNewReconciler: !1
                    };

                function ti(e3, n3) {
                    if (e3 && e3.defaultProps) {
                        for (var t3 in n3 = A({}, n3), e3 = e3.defaultProps) n3[t3] === void 0 && (n3[t3] = e3[t3]);
                        return n3
                    }
                    return n3
                }

                function ri(e3, n3, t3, r3) {
                    t3 = (t3 = t3(r3, n3 = e3.memoizedState)) === null || t3 === void 0 ? n3 : A({}, n3, t3), e3.memoizedState = t3, e3.lanes === 0 && (e3.updateQueue.baseState = t3)
                }
                var li = {
                    isMounted: function(e3) {
                        return !!(e3 = e3._reactInternals) && We(e3) === e3
                    },
                    enqueueSetState: function(e3, n3, t3) {
                        e3 = e3._reactInternals;
                        var r3 = es(),
                            l3 = ns(e3),
                            a3 = Fa(r3, l3);
                        a3.payload = n3, t3 != null && (a3.callback = t3), (n3 = Oa(e3, a3, l3)) !== null && (ts(n3, e3, l3, r3), Ua(n3, e3, l3))
                    },
                    enqueueReplaceState: function(e3, n3, t3) {
                        e3 = e3._reactInternals;
                        var r3 = es(),
                            l3 = ns(e3),
                            a3 = Fa(r3, l3);
                        a3.tag = 1, a3.payload = n3, t3 != null && (a3.callback = t3), (n3 = Oa(e3, a3, l3)) !== null && (ts(n3, e3, l3, r3), Ua(n3, e3, l3))
                    },
                    enqueueForceUpdate: function(e3, n3) {
                        e3 = e3._reactInternals;
                        var t3 = es(),
                            r3 = ns(e3),
                            l3 = Fa(t3, r3);
                        l3.tag = 2, n3 != null && (l3.callback = n3), (n3 = Oa(e3, l3, r3)) !== null && (ts(n3, e3, r3, t3), Ua(n3, e3, r3))
                    }
                };

                function ai(e3, n3, t3, r3, l3, a3, o3) {
                    return typeof(e3 = e3.stateNode).shouldComponentUpdate == "function" ? e3.shouldComponentUpdate(r3, a3, o3) : !n3.prototype || !n3.prototype.isPureReactComponent || !ur(t3, r3) || !ur(l3, a3)
                }

                function oi(e3, n3, t3) {
                    var r3 = !1,
                        l3 = _l,
                        a3 = n3.contextType;
                    return typeof a3 == "object" && a3 !== null ? a3 = La(a3) : (l3 = jl(n3) ? Ll : zl.current, a3 = (r3 = (r3 = n3.contextTypes) !== null && r3 !== void 0) ? Tl(e3, l3) : _l), n3 = new n3(t3, a3), e3.memoizedState = n3.state !== null && n3.state !== void 0 ? n3.state : null, n3.updater = li, e3.stateNode = n3, n3._reactInternals = e3, r3 && ((e3 = e3.stateNode).__reactInternalMemoizedUnmaskedChildContext = l3, e3.__reactInternalMemoizedMaskedChildContext = a3), n3
                }

                function ii(e3, n3, t3, r3) {
                    e3 = n3.state, typeof n3.componentWillReceiveProps == "function" && n3.componentWillReceiveProps(t3, r3), typeof n3.UNSAFE_componentWillReceiveProps == "function" && n3.UNSAFE_componentWillReceiveProps(t3, r3), n3.state !== e3 && li.enqueueReplaceState(n3, n3.state, null)
                }

                function ui(e3, n3, t3, r3) {
                    var l3 = e3.stateNode;
                    l3.props = t3, l3.state = e3.memoizedState, l3.refs = {}, Da(e3);
                    var a3 = n3.contextType;
                    typeof a3 == "object" && a3 !== null ? l3.context = La(a3) : (a3 = jl(n3) ? Ll : zl.current, l3.context = Tl(e3, a3)), l3.state = e3.memoizedState, typeof(a3 = n3.getDerivedStateFromProps) == "function" && (ri(e3, n3, a3, t3), l3.state = e3.memoizedState), typeof n3.getDerivedStateFromProps == "function" || typeof l3.getSnapshotBeforeUpdate == "function" || typeof l3.UNSAFE_componentWillMount != "function" && typeof l3.componentWillMount != "function" || (n3 = l3.state, typeof l3.componentWillMount == "function" && l3.componentWillMount(), typeof l3.UNSAFE_componentWillMount == "function" && l3.UNSAFE_componentWillMount(), n3 !== l3.state && li.enqueueReplaceState(l3, l3.state, null), Wa(e3, t3, l3, r3), l3.state = e3.memoizedState), typeof l3.componentDidMount == "function" && (e3.flags |= 4194308)
                }

                function si(e3, n3) {
                    try {
                        var t3 = "",
                            r3 = n3;
                        do t3 += B(r3), r3 = r3.return; while (r3);
                        var l3 = t3
                    } catch (a3) {
                        l3 = `
Error generating stack: ` + a3.message + `
` + a3.stack
                    }
                    return {
                        value: e3,
                        source: n3,
                        stack: l3,
                        digest: null
                    }
                }

                function ci(e3, n3, t3) {
                    return {
                        value: e3,
                        source: null,
                        stack: t3 ?? null,
                        digest: n3 ?? null
                    }
                }

                function di(e3, n3) {
                    try {
                        console.error(n3.value)
                    } catch (t3) {
                        setTimeout(function() {
                            throw t3
                        })
                    }
                }
                var fi = typeof WeakMap == "function" ? WeakMap : Map;

                function pi(e3, n3, t3) {
                    (t3 = Fa(-1, t3)).tag = 3, t3.payload = {
                        element: null
                    };
                    var r3 = n3.value;
                    return t3.callback = function() {
                        Hu || (Hu = !0, Qu = r3), di(0, n3)
                    }, t3
                }

                function hi(e3, n3, t3) {
                    (t3 = Fa(-1, t3)).tag = 3;
                    var r3 = e3.type.getDerivedStateFromError;
                    if (typeof r3 == "function") {
                        var l3 = n3.value;
                        t3.payload = function() {
                            return r3(l3)
                        }, t3.callback = function() {
                            di(0, n3)
                        }
                    }
                    var a3 = e3.stateNode;
                    return a3 !== null && typeof a3.componentDidCatch == "function" && (t3.callback = function() {
                        di(0, n3), typeof r3 != "function" && (Yu === null ? Yu = new Set([this]) : Yu.add(this));
                        var e4 = n3.stack;
                        this.componentDidCatch(n3.value, {
                            componentStack: e4 !== null ? e4 : ""
                        })
                    }), t3
                }

                function mi(e3, n3, t3) {
                    var r3 = e3.pingCache;
                    if (r3 === null) {
                        r3 = e3.pingCache = new fi;
                        var l3 = new Set;
                        r3.set(n3, l3)
                    } else(l3 = r3.get(n3)) === void 0 && (l3 = new Set, r3.set(n3, l3));
                    l3.has(t3) || (l3.add(t3), e3 = Ns.bind(null, e3, n3, t3), n3.then(e3, e3))
                }

                function gi(e3) {
                    do {
                        var n3;
                        if ((n3 = e3.tag === 13) && (n3 = (n3 = e3.memoizedState) === null || n3.dehydrated !== null), n3) return e3;
                        e3 = e3.return
                    } while (e3 !== null);
                    return null
                }

                function vi(e3, n3, t3, r3, l3) {
                    return 1 & e3.mode ? (e3.flags |= 65536, e3.lanes = l3, e3) : (e3 === n3 ? e3.flags |= 65536 : (e3.flags |= 128, t3.flags |= 131072, t3.flags &= -52805, t3.tag === 1 && (t3.alternate === null ? t3.tag = 17 : ((n3 = Fa(-1, 1)).tag = 2, Oa(t3, n3, 1))), t3.lanes |= 1), e3)
                }
                var yi = w.ReactCurrentOwner,
                    bi = !1;

                function wi(e3, n3, t3, r3) {
                    n3.child = e3 === null ? ka(n3, null, t3, r3) : wa(n3, e3.child, t3, r3)
                }

                function ki(e3, n3, t3, r3, l3) {
                    t3 = t3.render;
                    var a3 = n3.ref;
                    return Pa(n3, l3), r3 = go(e3, n3, t3, r3, a3, l3), t3 = vo(), e3 === null || bi ? (la && t3 && ea(n3), n3.flags |= 1, wi(e3, n3, r3, l3), n3.child) : (n3.updateQueue = e3.updateQueue, n3.flags &= -2053, e3.lanes &= ~l3, Hi(e3, n3, l3))
                }

                function Si(e3, n3, t3, r3, l3) {
                    if (e3 === null) {
                        var a3 = t3.type;
                        return typeof a3 != "function" || js(a3) || a3.defaultProps !== void 0 || t3.compare !== null || t3.defaultProps !== void 0 ? ((e3 = Ms(t3.type, null, r3, n3, n3.mode, l3)).ref = n3.ref, e3.return = n3, n3.child = e3) : (n3.tag = 15, n3.type = a3, xi(e3, n3, a3, r3, l3))
                    }
                    if (a3 = e3.child, (e3.lanes & l3) === 0) {
                        var o3 = a3.memoizedProps;
                        if ((t3 = (t3 = t3.compare) !== null ? t3 : ur)(o3, r3) && e3.ref === n3.ref) return Hi(e3, n3, l3)
                    }
                    return n3.flags |= 1, (e3 = Rs(a3, r3)).ref = n3.ref, e3.return = n3, n3.child = e3
                }

                function xi(e3, n3, t3, r3, l3) {
                    if (e3 !== null) {
                        var a3 = e3.memoizedProps;
                        if (ur(a3, r3) && e3.ref === n3.ref) {
                            if (bi = !1, n3.pendingProps = r3 = a3, (e3.lanes & l3) === 0) return n3.lanes = e3.lanes, Hi(e3, n3, l3);
                            131072 & e3.flags && (bi = !0)
                        }
                    }
                    return Ci(e3, n3, t3, r3, l3)
                }

                function Ei(e3, n3, t3) {
                    var r3 = n3.pendingProps,
                        l3 = r3.children,
                        a3 = e3 !== null ? e3.memoizedState : null;
                    if (r3.mode === "hidden")
                        if (!(1 & n3.mode)) n3.memoizedState = {
                            baseLanes: 0,
                            cachePool: null,
                            transitions: null
                        }, Cl(Ru, ju), ju |= t3;
                        else {
                            if (!(1073741824 & t3)) return e3 = a3 !== null ? a3.baseLanes | t3 : t3, n3.lanes = n3.childLanes = 1073741824, n3.memoizedState = {
                                baseLanes: e3,
                                cachePool: null,
                                transitions: null
                            }, n3.updateQueue = null, Cl(Ru, ju), ju |= e3, null;
                            n3.memoizedState = {
                                baseLanes: 0,
                                cachePool: null,
                                transitions: null
                            }, r3 = a3 !== null ? a3.baseLanes : t3, Cl(Ru, ju), ju |= r3
                        }
                    else a3 !== null ? (r3 = a3.baseLanes | t3, n3.memoizedState = null) : r3 = t3, Cl(Ru, ju), ju |= r3;
                    return wi(e3, n3, l3, t3), n3.child
                }

                function Ni(e3, n3) {
                    var t3 = n3.ref;
                    (e3 === null && t3 !== null || e3 !== null && e3.ref !== t3) && (n3.flags |= 512, n3.flags |= 2097152)
                }

                function Ci(e3, n3, t3, r3, l3) {
                    var a3 = jl(t3) ? Ll : zl.current;
                    return a3 = Tl(n3, a3), Pa(n3, l3), t3 = go(e3, n3, t3, r3, a3, l3), r3 = vo(), e3 === null || bi ? (la && r3 && ea(n3), n3.flags |= 1, wi(e3, n3, t3, l3), n3.child) : (n3.updateQueue = e3.updateQueue, n3.flags &= -2053, e3.lanes &= ~l3, Hi(e3, n3, l3))
                }

                function _i(e3, n3, t3, r3, l3) {
                    if (jl(t3)) {
                        var a3 = !0;
                        Dl(n3)
                    } else a3 = !1;
                    if (Pa(n3, l3), n3.stateNode === null) Vi(e3, n3), oi(n3, t3, r3), ui(n3, t3, r3, l3), r3 = !0;
                    else if (e3 === null) {
                        var o3 = n3.stateNode,
                            i3 = n3.memoizedProps;
                        o3.props = i3;
                        var u3 = o3.context,
                            s3 = t3.contextType;
                        typeof s3 == "object" && s3 !== null ? s3 = La(s3) : s3 = Tl(n3, s3 = jl(t3) ? Ll : zl.current);
                        var c3 = t3.getDerivedStateFromProps,
                            d3 = typeof c3 == "function" || typeof o3.getSnapshotBeforeUpdate == "function";
                        d3 || typeof o3.UNSAFE_componentWillReceiveProps != "function" && typeof o3.componentWillReceiveProps != "function" || (i3 !== r3 || u3 !== s3) && ii(n3, o3, r3, s3), Ia = !1;
                        var f2 = n3.memoizedState;
                        o3.state = f2, Wa(n3, r3, o3, l3), u3 = n3.memoizedState, i3 !== r3 || f2 !== u3 || Pl.current || Ia ? (typeof c3 == "function" && (ri(n3, t3, c3, r3), u3 = n3.memoizedState), (i3 = Ia || ai(n3, t3, i3, r3, f2, u3, s3)) ? (d3 || typeof o3.UNSAFE_componentWillMount != "function" && typeof o3.componentWillMount != "function" || (typeof o3.componentWillMount == "function" && o3.componentWillMount(), typeof o3.UNSAFE_componentWillMount == "function" && o3.UNSAFE_componentWillMount()), typeof o3.componentDidMount == "function" && (n3.flags |= 4194308)) : (typeof o3.componentDidMount == "function" && (n3.flags |= 4194308), n3.memoizedProps = r3, n3.memoizedState = u3), o3.props = r3, o3.state = u3, o3.context = s3, r3 = i3) : (typeof o3.componentDidMount == "function" && (n3.flags |= 4194308), r3 = !1)
                    } else {
                        o3 = n3.stateNode, Aa(e3, n3), i3 = n3.memoizedProps, s3 = n3.type === n3.elementType ? i3 : ti(n3.type, i3), o3.props = s3, d3 = n3.pendingProps, f2 = o3.context, typeof(u3 = t3.contextType) == "object" && u3 !== null ? u3 = La(u3) : u3 = Tl(n3, u3 = jl(t3) ? Ll : zl.current);
                        var p2 = t3.getDerivedStateFromProps;
                        (c3 = typeof p2 == "function" || typeof o3.getSnapshotBeforeUpdate == "function") || typeof o3.UNSAFE_componentWillReceiveProps != "function" && typeof o3.componentWillReceiveProps != "function" || (i3 !== d3 || f2 !== u3) && ii(n3, o3, r3, u3), Ia = !1, f2 = n3.memoizedState, o3.state = f2, Wa(n3, r3, o3, l3);
                        var h2 = n3.memoizedState;
                        i3 !== d3 || f2 !== h2 || Pl.current || Ia ? (typeof p2 == "function" && (ri(n3, t3, p2, r3), h2 = n3.memoizedState), (s3 = Ia || ai(n3, t3, s3, r3, f2, h2, u3) || !1) ? (c3 || typeof o3.UNSAFE_componentWillUpdate != "function" && typeof o3.componentWillUpdate != "function" || (typeof o3.componentWillUpdate == "function" && o3.componentWillUpdate(r3, h2, u3), typeof o3.UNSAFE_componentWillUpdate == "function" && o3.UNSAFE_componentWillUpdate(r3, h2, u3)), typeof o3.componentDidUpdate == "function" && (n3.flags |= 4), typeof o3.getSnapshotBeforeUpdate == "function" && (n3.flags |= 1024)) : (typeof o3.componentDidUpdate != "function" || i3 === e3.memoizedProps && f2 === e3.memoizedState || (n3.flags |= 4), typeof o3.getSnapshotBeforeUpdate != "function" || i3 === e3.memoizedProps && f2 === e3.memoizedState || (n3.flags |= 1024), n3.memoizedProps = r3, n3.memoizedState = h2), o3.props = r3, o3.state = h2, o3.context = u3, r3 = s3) : (typeof o3.componentDidUpdate != "function" || i3 === e3.memoizedProps && f2 === e3.memoizedState || (n3.flags |= 4), typeof o3.getSnapshotBeforeUpdate != "function" || i3 === e3.memoizedProps && f2 === e3.memoizedState || (n3.flags |= 1024), r3 = !1)
                    }
                    return zi(e3, n3, t3, r3, a3, l3)
                }

                function zi(e3, n3, t3, r3, l3, a3) {
                    Ni(e3, n3);
                    var o3 = (128 & n3.flags) !== 0;
                    if (!r3 && !o3) return l3 && Al(n3, t3, !1), Hi(e3, n3, a3);
                    r3 = n3.stateNode, yi.current = n3;
                    var i3 = o3 && typeof t3.getDerivedStateFromError != "function" ? null : r3.render();
                    return n3.flags |= 1, e3 !== null && o3 ? (n3.child = wa(n3, e3.child, null, a3), n3.child = wa(n3, null, i3, a3)) : wi(e3, n3, i3, a3), n3.memoizedState = r3.state, l3 && Al(n3, t3, !0), n3.child
                }

                function Pi(e3) {
                    var n3 = e3.stateNode;
                    n3.pendingContext ? Ml(0, n3.pendingContext, n3.pendingContext !== n3.context) : n3.context && Ml(0, n3.context, !1), Xa(e3, n3.containerInfo)
                }

                function Li(e3, n3, t3, r3, l3) {
                    return pa(), ha(l3), n3.flags |= 256, wi(e3, n3, t3, r3), n3.child
                }
                var Ti, ji, Ri, Mi, Ii = {
                    dehydrated: null,
                    treeContext: null,
                    retryLane: 0
                };

                function Di(e3) {
                    return {
                        baseLanes: e3,
                        cachePool: null,
                        transitions: null
                    }
                }

                function Ai(e3, n3, t3) {
                    var r3, l3 = n3.pendingProps,
                        o3 = Ka.current,
                        i3 = !1,
                        u3 = (128 & n3.flags) !== 0;
                    if ((r3 = u3) || (r3 = (e3 === null || e3.memoizedState !== null) && (2 & o3) !== 0), r3 ? (i3 = !0, n3.flags &= -129) : e3 !== null && e3.memoizedState === null || (o3 |= 1), Cl(Ka, 1 & o3), e3 === null) return sa(n3), (e3 = n3.memoizedState) !== null && (e3 = e3.dehydrated) !== null ? (1 & n3.mode ? e3.data === "$!" ? n3.lanes = 8 : n3.lanes = 1073741824 : n3.lanes = 1, null) : (u3 = l3.children, e3 = l3.fallback, i3 ? (l3 = n3.mode, i3 = n3.child, u3 = {
                        mode: "hidden",
                        children: u3
                    }, !(1 & l3) && i3 !== null ? (i3.childLanes = 0, i3.pendingProps = u3) : i3 = Ds(u3, l3, 0, null), e3 = Is(e3, l3, t3, null), i3.return = n3, e3.return = n3, i3.sibling = e3, n3.child = i3, n3.child.memoizedState = Di(t3), n3.memoizedState = Ii, e3) : Fi(n3, u3));
                    if ((o3 = e3.memoizedState) !== null && (r3 = o3.dehydrated) !== null) return function(e4, n4, t4, r4, l4, o4, i4) {
                        if (t4) return 256 & n4.flags ? (n4.flags &= -257, Oi(e4, n4, i4, r4 = ci(Error(a2(422))))) : n4.memoizedState !== null ? (n4.child = e4.child, n4.flags |= 128, null) : (o4 = r4.fallback, l4 = n4.mode, r4 = Ds({
                            mode: "visible",
                            children: r4.children
                        }, l4, 0, null), (o4 = Is(o4, l4, i4, null)).flags |= 2, r4.return = n4, o4.return = n4, r4.sibling = o4, n4.child = r4, 1 & n4.mode && wa(n4, e4.child, null, i4), n4.child.memoizedState = Di(i4), n4.memoizedState = Ii, o4);
                        if (!(1 & n4.mode)) return Oi(e4, n4, i4, null);
                        if (l4.data === "$!") {
                            if (r4 = l4.nextSibling && l4.nextSibling.dataset) var u4 = r4.dgst;
                            return r4 = u4, Oi(e4, n4, i4, r4 = ci(o4 = Error(a2(419)), r4, void 0))
                        }
                        if (u4 = (i4 & e4.childLanes) !== 0, bi || u4) {
                            if ((r4 = Pu) !== null) {
                                switch (i4 & -i4) {
                                    case 4:
                                        l4 = 2;
                                        break;
                                    case 16:
                                        l4 = 8;
                                        break;
                                    case 64:
                                    case 128:
                                    case 256:
                                    case 512:
                                    case 1024:
                                    case 2048:
                                    case 4096:
                                    case 8192:
                                    case 16384:
                                    case 32768:
                                    case 65536:
                                    case 131072:
                                    case 262144:
                                    case 524288:
                                    case 1048576:
                                    case 2097152:
                                    case 4194304:
                                    case 8388608:
                                    case 16777216:
                                    case 33554432:
                                    case 67108864:
                                        l4 = 32;
                                        break;
                                    case 536870912:
                                        l4 = 268435456;
                                        break;
                                    default:
                                        l4 = 0
                                }(l4 = l4 & (r4.suspendedLanes | i4) ? 0 : l4) !== 0 && l4 !== o4.retryLane && (o4.retryLane = l4, Ma(e4, l4), ts(r4, e4, l4, -1))
                            }
                            return ms(), Oi(e4, n4, i4, r4 = ci(Error(a2(421))))
                        }
                        return l4.data === "$?" ? (n4.flags |= 128, n4.child = e4.child, n4 = _s.bind(null, e4), l4._reactRetry = n4, null) : (e4 = o4.treeContext, ra = sl(l4.nextSibling), ta = n4, la = !0, aa = null, e4 !== null && (Gl[$l++] = Zl, Gl[$l++] = Jl, Gl[$l++] = Xl, Zl = e4.id, Jl = e4.overflow, Xl = n4), n4 = Fi(n4, r4.children), n4.flags |= 4096, n4)
                    }(e3, n3, u3, l3, r3, o3, t3);
                    if (i3) {
                        i3 = l3.fallback, u3 = n3.mode, r3 = (o3 = e3.child).sibling;
                        var s3 = {
                            mode: "hidden",
                            children: l3.children
                        };
                        return !(1 & u3) && n3.child !== o3 ? ((l3 = n3.child).childLanes = 0, l3.pendingProps = s3, n3.deletions = null) : (l3 = Rs(o3, s3)).subtreeFlags = 14680064 & o3.subtreeFlags, r3 !== null ? i3 = Rs(r3, i3) : (i3 = Is(i3, u3, t3, null)).flags |= 2, i3.return = n3, l3.return = n3, l3.sibling = i3, n3.child = l3, l3 = i3, i3 = n3.child, u3 = (u3 = e3.child.memoizedState) === null ? Di(t3) : {
                            baseLanes: u3.baseLanes | t3,
                            cachePool: null,
                            transitions: u3.transitions
                        }, i3.memoizedState = u3, i3.childLanes = e3.childLanes & ~t3, n3.memoizedState = Ii, l3
                    }
                    return e3 = (i3 = e3.child).sibling, l3 = Rs(i3, {
                        mode: "visible",
                        children: l3.children
                    }), !(1 & n3.mode) && (l3.lanes = t3), l3.return = n3, l3.sibling = null, e3 !== null && ((t3 = n3.deletions) === null ? (n3.deletions = [e3], n3.flags |= 16) : t3.push(e3)), n3.child = l3, n3.memoizedState = null, l3
                }

                function Fi(e3, n3) {
                    return (n3 = Ds({
                        mode: "visible",
                        children: n3
                    }, e3.mode, 0, null)).return = e3, e3.child = n3
                }

                function Oi(e3, n3, t3, r3) {
                    return r3 !== null && ha(r3), wa(n3, e3.child, null, t3), (e3 = Fi(n3, n3.pendingProps.children)).flags |= 2, n3.memoizedState = null, e3
                }

                function Ui(e3, n3, t3) {
                    e3.lanes |= n3;
                    var r3 = e3.alternate;
                    r3 !== null && (r3.lanes |= n3), za(e3.return, n3, t3)
                }

                function Bi(e3, n3, t3, r3, l3) {
                    var a3 = e3.memoizedState;
                    a3 === null ? e3.memoizedState = {
                        isBackwards: n3,
                        rendering: null,
                        renderingStartTime: 0,
                        last: r3,
                        tail: t3,
                        tailMode: l3
                    } : (a3.isBackwards = n3, a3.rendering = null, a3.renderingStartTime = 0, a3.last = r3, a3.tail = t3, a3.tailMode = l3)
                }

                function Wi(e3, n3, t3) {
                    var r3 = n3.pendingProps,
                        l3 = r3.revealOrder,
                        a3 = r3.tail;
                    if (wi(e3, n3, r3.children, t3), (2 & (r3 = Ka.current)) !== 0) r3 = 1 & r3 | 2, n3.flags |= 128;
                    else {
                        if (e3 !== null && 128 & e3.flags) e: for (e3 = n3.child; e3 !== null;) {
                            if (e3.tag === 13) e3.memoizedState !== null && Ui(e3, t3, n3);
                            else if (e3.tag === 19) Ui(e3, t3, n3);
                            else if (e3.child !== null) {
                                e3.child.return = e3, e3 = e3.child;
                                continue
                            }
                            if (e3 === n3) break e;
                            for (; e3.sibling === null;) {
                                if (e3.return === null || e3.return === n3) break e;
                                e3 = e3.return
                            }
                            e3.sibling.return = e3.return, e3 = e3.sibling
                        }
                        r3 &= 1
                    }
                    if (Cl(Ka, r3), (1 & n3.mode) === 0) n3.memoizedState = null;
                    else switch (l3) {
                        case "forwards":
                            for (t3 = n3.child, l3 = null; t3 !== null;)(e3 = t3.alternate) !== null && eo(e3) === null && (l3 = t3), t3 = t3.sibling;
                            (t3 = l3) === null ? (l3 = n3.child, n3.child = null) : (l3 = t3.sibling, t3.sibling = null), Bi(n3, !1, l3, t3, a3);
                            break;
                        case "backwards":
                            for (t3 = null, l3 = n3.child, n3.child = null; l3 !== null;) {
                                if ((e3 = l3.alternate) !== null && eo(e3) === null) {
                                    n3.child = l3;
                                    break
                                }
                                e3 = l3.sibling, l3.sibling = t3, t3 = l3, l3 = e3
                            }
                            Bi(n3, !0, t3, null, a3);
                            break;
                        case "together":
                            Bi(n3, !1, null, null, void 0);
                            break;
                        default:
                            n3.memoizedState = null
                    }
                    return n3.child
                }

                function Vi(e3, n3) {
                    !(1 & n3.mode) && e3 !== null && (e3.alternate = null, n3.alternate = null, n3.flags |= 2)
                }

                function Hi(e3, n3, t3) {
                    if (e3 !== null && (n3.dependencies = e3.dependencies), Du |= n3.lanes, (t3 & n3.childLanes) === 0) return null;
                    if (e3 !== null && n3.child !== e3.child) throw Error(a2(153));
                    if (n3.child !== null) {
                        for (t3 = Rs(e3 = n3.child, e3.pendingProps), n3.child = t3, t3.return = n3; e3.sibling !== null;) e3 = e3.sibling, (t3 = t3.sibling = Rs(e3, e3.pendingProps)).return = n3;
                        t3.sibling = null
                    }
                    return n3.child
                }

                function Qi(e3, n3) {
                    if (!la) switch (e3.tailMode) {
                        case "hidden":
                            n3 = e3.tail;
                            for (var t3 = null; n3 !== null;) n3.alternate !== null && (t3 = n3), n3 = n3.sibling;
                            t3 === null ? e3.tail = null : t3.sibling = null;
                            break;
                        case "collapsed":
                            t3 = e3.tail;
                            for (var r3 = null; t3 !== null;) t3.alternate !== null && (r3 = t3), t3 = t3.sibling;
                            r3 === null ? n3 || e3.tail === null ? e3.tail = null : e3.tail.sibling = null : r3.sibling = null
                    }
                }

                function Yi(e3) {
                    var n3 = e3.alternate !== null && e3.alternate.child === e3.child,
                        t3 = 0,
                        r3 = 0;
                    if (n3)
                        for (var l3 = e3.child; l3 !== null;) t3 |= l3.lanes | l3.childLanes, r3 |= 14680064 & l3.subtreeFlags, r3 |= 14680064 & l3.flags, l3.return = e3, l3 = l3.sibling;
                    else
                        for (l3 = e3.child; l3 !== null;) t3 |= l3.lanes | l3.childLanes, r3 |= l3.subtreeFlags, r3 |= l3.flags, l3.return = e3, l3 = l3.sibling;
                    return e3.subtreeFlags |= r3, e3.childLanes = t3, n3
                }

                function Gi(e3, n3, t3) {
                    var r3 = n3.pendingProps;
                    switch (na(n3), n3.tag) {
                        case 2:
                        case 16:
                        case 15:
                        case 0:
                        case 11:
                        case 7:
                        case 8:
                        case 12:
                        case 9:
                        case 14:
                            return Yi(n3), null;
                        case 1:
                        case 17:
                            return jl(n3.type) && Rl(), Yi(n3), null;
                        case 3:
                            return r3 = n3.stateNode, Za(), Nl(Pl), Nl(zl), to(), r3.pendingContext && (r3.context = r3.pendingContext, r3.pendingContext = null), e3 !== null && e3.child !== null || (da(n3) ? n3.flags |= 4 : e3 === null || e3.memoizedState.isDehydrated && !(256 & n3.flags) || (n3.flags |= 1024, aa !== null && (os(aa), aa = null))), ji(e3, n3), Yi(n3), null;
                        case 5:
                            qa(n3);
                            var l3 = $a(Ga.current);
                            if (t3 = n3.type, e3 !== null && n3.stateNode != null) Ri(e3, n3, t3, r3, l3), e3.ref !== n3.ref && (n3.flags |= 512, n3.flags |= 2097152);
                            else {
                                if (!r3) {
                                    if (n3.stateNode === null) throw Error(a2(166));
                                    return Yi(n3), null
                                }
                                if (e3 = $a(Qa.current), da(n3)) {
                                    r3 = n3.stateNode, t3 = n3.type;
                                    var o3 = n3.memoizedProps;
                                    switch (r3[fl] = n3, r3[pl] = o3, e3 = (1 & n3.mode) !== 0, t3) {
                                        case "dialog":
                                            Or("cancel", r3), Or("close", r3);
                                            break;
                                        case "iframe":
                                        case "object":
                                        case "embed":
                                            Or("load", r3);
                                            break;
                                        case "video":
                                        case "audio":
                                            for (l3 = 0; l3 < Ir.length; l3++) Or(Ir[l3], r3);
                                            break;
                                        case "source":
                                            Or("error", r3);
                                            break;
                                        case "img":
                                        case "image":
                                        case "link":
                                            Or("error", r3), Or("load", r3);
                                            break;
                                        case "details":
                                            Or("toggle", r3);
                                            break;
                                        case "input":
                                            Z(r3, o3), Or("invalid", r3);
                                            break;
                                        case "select":
                                            r3._wrapperState = {
                                                wasMultiple: !!o3.multiple
                                            }, Or("invalid", r3);
                                            break;
                                        case "textarea":
                                            le(r3, o3), Or("invalid", r3)
                                    }
                                    for (var u3 in ye(t3, o3), l3 = null, o3)
                                        if (o3.hasOwnProperty(u3)) {
                                            var s3 = o3[u3];
                                            u3 === "children" ? typeof s3 == "string" ? r3.textContent !== s3 && (o3.suppressHydrationWarning !== !0 && qr(r3.textContent, s3, e3), l3 = ["children", s3]) : typeof s3 == "number" && r3.textContent !== "" + s3 && (o3.suppressHydrationWarning !== !0 && qr(r3.textContent, s3, e3), l3 = ["children", "" + s3]) : i2.hasOwnProperty(u3) && s3 != null && u3 === "onScroll" && Or("scroll", r3)
                                        } switch (t3) {
                                        case "input":
                                            Y(r3), K(r3, o3, !0);
                                            break;
                                        case "textarea":
                                            Y(r3), oe(r3);
                                            break;
                                        case "select":
                                        case "option":
                                            break;
                                        default:
                                            typeof o3.onClick == "function" && (r3.onclick = Kr)
                                    }
                                    r3 = l3, n3.updateQueue = r3, r3 !== null && (n3.flags |= 4)
                                } else {
                                    u3 = l3.nodeType === 9 ? l3 : l3.ownerDocument, e3 === "http://www.w3.org/1999/xhtml" && (e3 = ie(t3)), e3 === "http://www.w3.org/1999/xhtml" ? t3 === "script" ? ((e3 = u3.createElement("div")).innerHTML = "<script><\/script>", e3 = e3.removeChild(e3.firstChild)) : typeof r3.is == "string" ? e3 = u3.createElement(t3, {
                                        is: r3.is
                                    }) : (e3 = u3.createElement(t3), t3 === "select" && (u3 = e3, r3.multiple ? u3.multiple = !0 : r3.size && (u3.size = r3.size))) : e3 = u3.createElementNS(e3, t3), e3[fl] = n3, e3[pl] = r3, Ti(e3, n3, !1, !1), n3.stateNode = e3;
                                    e: {
                                        switch (u3 = be(t3, r3), t3) {
                                            case "dialog":
                                                Or("cancel", e3), Or("close", e3), l3 = r3;
                                                break;
                                            case "iframe":
                                            case "object":
                                            case "embed":
                                                Or("load", e3), l3 = r3;
                                                break;
                                            case "video":
                                            case "audio":
                                                for (l3 = 0; l3 < Ir.length; l3++) Or(Ir[l3], e3);
                                                l3 = r3;
                                                break;
                                            case "source":
                                                Or("error", e3), l3 = r3;
                                                break;
                                            case "img":
                                            case "image":
                                            case "link":
                                                Or("error", e3), Or("load", e3), l3 = r3;
                                                break;
                                            case "details":
                                                Or("toggle", e3), l3 = r3;
                                                break;
                                            case "input":
                                                Z(e3, r3), l3 = X(e3, r3), Or("invalid", e3);
                                                break;
                                            case "option":
                                            default:
                                                l3 = r3;
                                                break;
                                            case "select":
                                                e3._wrapperState = {
                                                    wasMultiple: !!r3.multiple
                                                }, l3 = A({}, r3, {
                                                    value: void 0
                                                }), Or("invalid", e3);
                                                break;
                                            case "textarea":
                                                le(e3, r3), l3 = re(e3, r3), Or("invalid", e3)
                                        }
                                        for (o3 in ye(t3, l3), s3 = l3)
                                            if (s3.hasOwnProperty(o3)) {
                                                var c3 = s3[o3];
                                                o3 === "style" ? ge(e3, c3) : o3 === "dangerouslySetInnerHTML" ? (c3 = c3 ? c3.__html : void 0) != null && de(e3, c3) : o3 === "children" ? typeof c3 == "string" ? (t3 !== "textarea" || c3 !== "") && fe(e3, c3) : typeof c3 == "number" && fe(e3, "" + c3) : o3 !== "suppressContentEditableWarning" && o3 !== "suppressHydrationWarning" && o3 !== "autoFocus" && (i2.hasOwnProperty(o3) ? c3 != null && o3 === "onScroll" && Or("scroll", e3) : c3 != null && b(e3, o3, c3, u3))
                                            } switch (t3) {
                                            case "input":
                                                Y(e3), K(e3, r3, !1);
                                                break;
                                            case "textarea":
                                                Y(e3), oe(e3);
                                                break;
                                            case "option":
                                                r3.value != null && e3.setAttribute("value", "" + H(r3.value));
                                                break;
                                            case "select":
                                                e3.multiple = !!r3.multiple, (o3 = r3.value) != null ? te(e3, !!r3.multiple, o3, !1) : r3.defaultValue != null && te(e3, !!r3.multiple, r3.defaultValue, !0);
                                                break;
                                            default:
                                                typeof l3.onClick == "function" && (e3.onclick = Kr)
                                        }
                                        switch (t3) {
                                            case "button":
                                            case "input":
                                            case "select":
                                            case "textarea":
                                                r3 = !!r3.autoFocus;
                                                break e;
                                            case "img":
                                                r3 = !0;
                                                break e;
                                            default:
                                                r3 = !1
                                        }
                                    }
                                    r3 && (n3.flags |= 4)
                                }
                                n3.ref !== null && (n3.flags |= 512, n3.flags |= 2097152)
                            }
                            return Yi(n3), null;
                        case 6:
                            if (e3 && n3.stateNode != null) Mi(e3, n3, e3.memoizedProps, r3);
                            else {
                                if (typeof r3 != "string" && n3.stateNode === null) throw Error(a2(166));
                                if (t3 = $a(Ga.current), $a(Qa.current), da(n3)) {
                                    if (r3 = n3.stateNode, t3 = n3.memoizedProps, r3[fl] = n3, (o3 = r3.nodeValue !== t3) && (e3 = ta) !== null) switch (e3.tag) {
                                        case 3:
                                            qr(r3.nodeValue, t3, (1 & e3.mode) !== 0);
                                            break;
                                        case 5:
                                            e3.memoizedProps.suppressHydrationWarning !== !0 && qr(r3.nodeValue, t3, (1 & e3.mode) !== 0)
                                    }
                                    o3 && (n3.flags |= 4)
                                } else(r3 = (t3.nodeType === 9 ? t3 : t3.ownerDocument).createTextNode(r3))[fl] = n3, n3.stateNode = r3
                            }
                            return Yi(n3), null;
                        case 13:
                            if (Nl(Ka), r3 = n3.memoizedState, e3 === null || e3.memoizedState !== null && e3.memoizedState.dehydrated !== null) {
                                if (la && ra !== null && 1 & n3.mode && !(128 & n3.flags)) fa(), pa(), n3.flags |= 98560, o3 = !1;
                                else if (o3 = da(n3), r3 !== null && r3.dehydrated !== null) {
                                    if (e3 === null) {
                                        if (!o3) throw Error(a2(318));
                                        if (!(o3 = (o3 = n3.memoizedState) !== null ? o3.dehydrated : null)) throw Error(a2(317));
                                        o3[fl] = n3
                                    } else pa(), !(128 & n3.flags) && (n3.memoizedState = null), n3.flags |= 4;
                                    Yi(n3), o3 = !1
                                } else aa !== null && (os(aa), aa = null), o3 = !0;
                                if (!o3) return 65536 & n3.flags ? n3 : null
                            }
                            return 128 & n3.flags ? (n3.lanes = t3, n3) : ((r3 = r3 !== null) != (e3 !== null && e3.memoizedState !== null) && r3 && (n3.child.flags |= 8192, 1 & n3.mode && (e3 === null || 1 & Ka.current ? Mu === 0 && (Mu = 3) : ms())), n3.updateQueue !== null && (n3.flags |= 4), Yi(n3), null);
                        case 4:
                            return Za(), ji(e3, n3), e3 === null && Wr(n3.stateNode.containerInfo), Yi(n3), null;
                        case 10:
                            return _a(n3.type._context), Yi(n3), null;
                        case 19:
                            if (Nl(Ka), (o3 = n3.memoizedState) === null) return Yi(n3), null;
                            if (r3 = (128 & n3.flags) !== 0, (u3 = o3.rendering) === null)
                                if (r3) Qi(o3, !1);
                                else {
                                    if (Mu !== 0 || e3 !== null && 128 & e3.flags)
                                        for (e3 = n3.child; e3 !== null;) {
                                            if ((u3 = eo(e3)) !== null) {
                                                for (n3.flags |= 128, Qi(o3, !1), (r3 = u3.updateQueue) !== null && (n3.updateQueue = r3, n3.flags |= 4), n3.subtreeFlags = 0, r3 = t3, t3 = n3.child; t3 !== null;) e3 = r3, (o3 = t3).flags &= 14680066, (u3 = o3.alternate) === null ? (o3.childLanes = 0, o3.lanes = e3, o3.child = null, o3.subtreeFlags = 0, o3.memoizedProps = null, o3.memoizedState = null, o3.updateQueue = null, o3.dependencies = null, o3.stateNode = null) : (o3.childLanes = u3.childLanes, o3.lanes = u3.lanes, o3.child = u3.child, o3.subtreeFlags = 0, o3.deletions = null, o3.memoizedProps = u3.memoizedProps, o3.memoizedState = u3.memoizedState, o3.updateQueue = u3.updateQueue, o3.type = u3.type, e3 = u3.dependencies, o3.dependencies = e3 === null ? null : {
                                                    lanes: e3.lanes,
                                                    firstContext: e3.firstContext
                                                }), t3 = t3.sibling;
                                                return Cl(Ka, 1 & Ka.current | 2), n3.child
                                            }
                                            e3 = e3.sibling
                                        }
                                    o3.tail !== null && Je() > Wu && (n3.flags |= 128, r3 = !0, Qi(o3, !1), n3.lanes = 4194304)
                                }
                            else {
                                if (!r3)
                                    if ((e3 = eo(u3)) !== null) {
                                        if (n3.flags |= 128, r3 = !0, (t3 = e3.updateQueue) !== null && (n3.updateQueue = t3, n3.flags |= 4), Qi(o3, !0), o3.tail === null && o3.tailMode === "hidden" && !u3.alternate && !la) return Yi(n3), null
                                    } else 2 * Je() - o3.renderingStartTime > Wu && t3 !== 1073741824 && (n3.flags |= 128, r3 = !0, Qi(o3, !1), n3.lanes = 4194304);
                                o3.isBackwards ? (u3.sibling = n3.child, n3.child = u3) : ((t3 = o3.last) !== null ? t3.sibling = u3 : n3.child = u3, o3.last = u3)
                            }
                            return o3.tail !== null ? (n3 = o3.tail, o3.rendering = n3, o3.tail = n3.sibling, o3.renderingStartTime = Je(), n3.sibling = null, t3 = Ka.current, Cl(Ka, r3 ? 1 & t3 | 2 : 1 & t3), n3) : (Yi(n3), null);
                        case 22:
                        case 23:
                            return ds(), r3 = n3.memoizedState !== null, e3 !== null && e3.memoizedState !== null !== r3 && (n3.flags |= 8192), r3 && 1 & n3.mode ? 1073741824 & ju && (Yi(n3), 6 & n3.subtreeFlags && (n3.flags |= 8192)) : Yi(n3), null;
                        case 24:
                        case 25:
                            return null
                    }
                    throw Error(a2(156, n3.tag))
                }

                function $i(e3, n3) {
                    switch (na(n3), n3.tag) {
                        case 1:
                            return jl(n3.type) && Rl(), 65536 & (e3 = n3.flags) ? (n3.flags = -65537 & e3 | 128, n3) : null;
                        case 3:
                            return Za(), Nl(Pl), Nl(zl), to(), 65536 & (e3 = n3.flags) && !(128 & e3) ? (n3.flags = -65537 & e3 | 128, n3) : null;
                        case 5:
                            return qa(n3), null;
                        case 13:
                            if (Nl(Ka), (e3 = n3.memoizedState) !== null && e3.dehydrated !== null) {
                                if (n3.alternate === null) throw Error(a2(340));
                                pa()
                            }
                            return 65536 & (e3 = n3.flags) ? (n3.flags = -65537 & e3 | 128, n3) : null;
                        case 19:
                            return Nl(Ka), null;
                        case 4:
                            return Za(), null;
                        case 10:
                            return _a(n3.type._context), null;
                        case 22:
                        case 23:
                            return ds(), null;
                        default:
                            return null
                    }
                }
                Ti = function(e3, n3) {
                    for (var t3 = n3.child; t3 !== null;) {
                        if (t3.tag === 5 || t3.tag === 6) e3.appendChild(t3.stateNode);
                        else if (t3.tag !== 4 && t3.child !== null) {
                            t3.child.return = t3, t3 = t3.child;
                            continue
                        }
                        if (t3 === n3) break;
                        for (; t3.sibling === null;) {
                            if (t3.return === null || t3.return === n3) return;
                            t3 = t3.return
                        }
                        t3.sibling.return = t3.return, t3 = t3.sibling
                    }
                }, ji = function() {}, Ri = function(e3, n3, t3, r3) {
                    var l3 = e3.memoizedProps;
                    if (l3 !== r3) {
                        e3 = n3.stateNode, $a(Qa.current);
                        var a3, o3 = null;
                        switch (t3) {
                            case "input":
                                l3 = X(e3, l3), r3 = X(e3, r3), o3 = [];
                                break;
                            case "select":
                                l3 = A({}, l3, {
                                    value: void 0
                                }), r3 = A({}, r3, {
                                    value: void 0
                                }), o3 = [];
                                break;
                            case "textarea":
                                l3 = re(e3, l3), r3 = re(e3, r3), o3 = [];
                                break;
                            default:
                                typeof l3.onClick != "function" && typeof r3.onClick == "function" && (e3.onclick = Kr)
                        }
                        for (c3 in ye(t3, r3), t3 = null, l3)
                            if (!r3.hasOwnProperty(c3) && l3.hasOwnProperty(c3) && l3[c3] != null)
                                if (c3 === "style") {
                                    var u3 = l3[c3];
                                    for (a3 in u3) u3.hasOwnProperty(a3) && (t3 || (t3 = {}), t3[a3] = "")
                                } else c3 !== "dangerouslySetInnerHTML" && c3 !== "children" && c3 !== "suppressContentEditableWarning" && c3 !== "suppressHydrationWarning" && c3 !== "autoFocus" && (i2.hasOwnProperty(c3) ? o3 || (o3 = []) : (o3 = o3 || []).push(c3, null));
                        for (c3 in r3) {
                            var s3 = r3[c3];
                            if (u3 = l3?.[c3], r3.hasOwnProperty(c3) && s3 !== u3 && (s3 != null || u3 != null))
                                if (c3 === "style")
                                    if (u3) {
                                        for (a3 in u3) !u3.hasOwnProperty(a3) || s3 && s3.hasOwnProperty(a3) || (t3 || (t3 = {}), t3[a3] = "");
                                        for (a3 in s3) s3.hasOwnProperty(a3) && u3[a3] !== s3[a3] && (t3 || (t3 = {}), t3[a3] = s3[a3])
                                    } else t3 || (o3 || (o3 = []), o3.push(c3, t3)), t3 = s3;
                            else c3 === "dangerouslySetInnerHTML" ? (s3 = s3 ? s3.__html : void 0, u3 = u3 ? u3.__html : void 0, s3 != null && u3 !== s3 && (o3 = o3 || []).push(c3, s3)) : c3 === "children" ? typeof s3 != "string" && typeof s3 != "number" || (o3 = o3 || []).push(c3, "" + s3) : c3 !== "suppressContentEditableWarning" && c3 !== "suppressHydrationWarning" && (i2.hasOwnProperty(c3) ? (s3 != null && c3 === "onScroll" && Or("scroll", e3), o3 || u3 === s3 || (o3 = [])) : (o3 = o3 || []).push(c3, s3))
                        }
                        t3 && (o3 = o3 || []).push("style", t3);
                        var c3 = o3;
                        (n3.updateQueue = c3) && (n3.flags |= 4)
                    }
                }, Mi = function(e3, n3, t3, r3) {
                    t3 !== r3 && (n3.flags |= 4)
                };
                var Xi = !1,
                    Zi = !1,
                    Ji = typeof WeakSet == "function" ? WeakSet : Set,
                    qi = null;

                function Ki(e3, n3) {
                    var t3 = e3.ref;
                    if (t3 !== null)
                        if (typeof t3 == "function") try {
                            t3(null)
                        } catch (r3) {
                            Es(e3, n3, r3)
                        } else t3.current = null
                }

                function eu(e3, n3, t3) {
                    try {
                        t3()
                    } catch (r3) {
                        Es(e3, n3, r3)
                    }
                }
                var nu = !1;

                function tu(e3, n3, t3) {
                    var r3 = n3.updateQueue;
                    if ((r3 = r3 !== null ? r3.lastEffect : null) !== null) {
                        var l3 = r3 = r3.next;
                        do {
                            if ((l3.tag & e3) === e3) {
                                var a3 = l3.destroy;
                                l3.destroy = void 0, a3 !== void 0 && eu(n3, t3, a3)
                            }
                            l3 = l3.next
                        } while (l3 !== r3)
                    }
                }

                function ru(e3, n3) {
                    if ((n3 = (n3 = n3.updateQueue) !== null ? n3.lastEffect : null) !== null) {
                        var t3 = n3 = n3.next;
                        do {
                            if ((t3.tag & e3) === e3) {
                                var r3 = t3.create;
                                t3.destroy = r3()
                            }
                            t3 = t3.next
                        } while (t3 !== n3)
                    }
                }

                function lu(e3) {
                    var n3 = e3.ref;
                    if (n3 !== null) {
                        var t3 = e3.stateNode;
                        e3.tag, e3 = t3, typeof n3 == "function" ? n3(e3) : n3.current = e3
                    }
                }

                function au(e3) {
                    var n3 = e3.alternate;
                    n3 !== null && (e3.alternate = null, au(n3)), e3.child = null, e3.deletions = null, e3.sibling = null, e3.tag === 5 && (n3 = e3.stateNode) !== null && (delete n3[fl], delete n3[pl], delete n3[ml], delete n3[gl], delete n3[vl]), e3.stateNode = null, e3.return = null, e3.dependencies = null, e3.memoizedProps = null, e3.memoizedState = null, e3.pendingProps = null, e3.stateNode = null, e3.updateQueue = null
                }

                function ou(e3) {
                    return e3.tag === 5 || e3.tag === 3 || e3.tag === 4
                }

                function iu(e3) {
                    e: for (;;) {
                        for (; e3.sibling === null;) {
                            if (e3.return === null || ou(e3.return)) return null;
                            e3 = e3.return
                        }
                        for (e3.sibling.return = e3.return, e3 = e3.sibling; e3.tag !== 5 && e3.tag !== 6 && e3.tag !== 18;) {
                            if (2 & e3.flags || e3.child === null || e3.tag === 4) continue e;
                            e3.child.return = e3, e3 = e3.child
                        }
                        if (!(2 & e3.flags)) return e3.stateNode
                    }
                }

                function uu(e3, n3, t3) {
                    var r3 = e3.tag;
                    if (r3 === 5 || r3 === 6) e3 = e3.stateNode, n3 ? t3.nodeType === 8 ? t3.parentNode.insertBefore(e3, n3) : t3.insertBefore(e3, n3) : (t3.nodeType === 8 ? (n3 = t3.parentNode).insertBefore(e3, t3) : (n3 = t3).appendChild(e3), (t3 = t3._reactRootContainer) !== null && t3 !== void 0 || n3.onclick !== null || (n3.onclick = Kr));
                    else if (r3 !== 4 && (e3 = e3.child) !== null)
                        for (uu(e3, n3, t3), e3 = e3.sibling; e3 !== null;) uu(e3, n3, t3), e3 = e3.sibling
                }

                function su(e3, n3, t3) {
                    var r3 = e3.tag;
                    if (r3 === 5 || r3 === 6) e3 = e3.stateNode, n3 ? t3.insertBefore(e3, n3) : t3.appendChild(e3);
                    else if (r3 !== 4 && (e3 = e3.child) !== null)
                        for (su(e3, n3, t3), e3 = e3.sibling; e3 !== null;) su(e3, n3, t3), e3 = e3.sibling
                }
                var cu = null,
                    du = !1;

                function fu(e3, n3, t3) {
                    for (t3 = t3.child; t3 !== null;) pu(e3, n3, t3), t3 = t3.sibling
                }

                function pu(e3, n3, t3) {
                    if (an && typeof an.onCommitFiberUnmount == "function") try {
                        an.onCommitFiberUnmount(ln, t3)
                    } catch {}
                    switch (t3.tag) {
                        case 5:
                            Zi || Ki(t3, n3);
                        case 6:
                            var r3 = cu,
                                l3 = du;
                            cu = null, fu(e3, n3, t3), du = l3, (cu = r3) !== null && (du ? (e3 = cu, t3 = t3.stateNode, e3.nodeType === 8 ? e3.parentNode.removeChild(t3) : e3.removeChild(t3)) : cu.removeChild(t3.stateNode));
                            break;
                        case 18:
                            cu !== null && (du ? (e3 = cu, t3 = t3.stateNode, e3.nodeType === 8 ? ul(e3.parentNode, t3) : e3.nodeType === 1 && ul(e3, t3), Vn(e3)) : ul(cu, t3.stateNode));
                            break;
                        case 4:
                            r3 = cu, l3 = du, cu = t3.stateNode.containerInfo, du = !0, fu(e3, n3, t3), cu = r3, du = l3;
                            break;
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (!Zi && (r3 = t3.updateQueue) !== null && (r3 = r3.lastEffect) !== null) {
                                l3 = r3 = r3.next;
                                do {
                                    var a3 = l3,
                                        o3 = a3.destroy;
                                    a3 = a3.tag, o3 !== void 0 && (2 & a3 || 4 & a3) && eu(t3, n3, o3), l3 = l3.next
                                } while (l3 !== r3)
                            }
                            fu(e3, n3, t3);
                            break;
                        case 1:
                            if (!Zi && (Ki(t3, n3), typeof(r3 = t3.stateNode).componentWillUnmount == "function")) try {
                                r3.props = t3.memoizedProps, r3.state = t3.memoizedState, r3.componentWillUnmount()
                            } catch (i3) {
                                Es(t3, n3, i3)
                            }
                            fu(e3, n3, t3);
                            break;
                        case 21:
                            fu(e3, n3, t3);
                            break;
                        case 22:
                            1 & t3.mode ? (Zi = (r3 = Zi) || t3.memoizedState !== null, fu(e3, n3, t3), Zi = r3) : fu(e3, n3, t3);
                            break;
                        default:
                            fu(e3, n3, t3)
                    }
                }

                function hu(e3) {
                    var n3 = e3.updateQueue;
                    if (n3 !== null) {
                        e3.updateQueue = null;
                        var t3 = e3.stateNode;
                        t3 === null && (t3 = e3.stateNode = new Ji), n3.forEach(function(n4) {
                            var r3 = zs.bind(null, e3, n4);
                            t3.has(n4) || (t3.add(n4), n4.then(r3, r3))
                        })
                    }
                }

                function mu(e3, n3) {
                    var t3 = n3.deletions;
                    if (t3 !== null)
                        for (var r3 = 0; r3 < t3.length; r3++) {
                            var l3 = t3[r3];
                            try {
                                var o3 = e3,
                                    i3 = n3,
                                    u3 = i3;
                                e: for (; u3 !== null;) {
                                    switch (u3.tag) {
                                        case 5:
                                            cu = u3.stateNode, du = !1;
                                            break e;
                                        case 3:
                                        case 4:
                                            cu = u3.stateNode.containerInfo, du = !0;
                                            break e
                                    }
                                    u3 = u3.return
                                }
                                if (cu === null) throw Error(a2(160));
                                pu(o3, i3, l3), cu = null, du = !1;
                                var s3 = l3.alternate;
                                s3 !== null && (s3.return = null), l3.return = null
                            } catch (c3) {
                                Es(l3, n3, c3)
                            }
                        }
                    if (12854 & n3.subtreeFlags)
                        for (n3 = n3.child; n3 !== null;) gu(n3, e3), n3 = n3.sibling
                }

                function gu(e3, n3) {
                    var t3 = e3.alternate,
                        r3 = e3.flags;
                    switch (e3.tag) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                            if (mu(n3, e3), vu(e3), 4 & r3) {
                                try {
                                    tu(3, e3, e3.return), ru(3, e3)
                                } catch (g2) {
                                    Es(e3, e3.return, g2)
                                }
                                try {
                                    tu(5, e3, e3.return)
                                } catch (g2) {
                                    Es(e3, e3.return, g2)
                                }
                            }
                            break;
                        case 1:
                            mu(n3, e3), vu(e3), 512 & r3 && t3 !== null && Ki(t3, t3.return);
                            break;
                        case 5:
                            if (mu(n3, e3), vu(e3), 512 & r3 && t3 !== null && Ki(t3, t3.return), 32 & e3.flags) {
                                var l3 = e3.stateNode;
                                try {
                                    fe(l3, "")
                                } catch (g2) {
                                    Es(e3, e3.return, g2)
                                }
                            }
                            if (4 & r3 && (l3 = e3.stateNode) != null) {
                                var o3 = e3.memoizedProps,
                                    i3 = t3 !== null ? t3.memoizedProps : o3,
                                    u3 = e3.type,
                                    s3 = e3.updateQueue;
                                if (e3.updateQueue = null, s3 !== null) try {
                                    u3 === "input" && o3.type === "radio" && o3.name != null && J(l3, o3), be(u3, i3);
                                    var c3 = be(u3, o3);
                                    for (i3 = 0; i3 < s3.length; i3 += 2) {
                                        var d3 = s3[i3],
                                            f2 = s3[i3 + 1];
                                        d3 === "style" ? ge(l3, f2) : d3 === "dangerouslySetInnerHTML" ? de(l3, f2) : d3 === "children" ? fe(l3, f2) : b(l3, d3, f2, c3)
                                    }
                                    switch (u3) {
                                        case "input":
                                            q(l3, o3);
                                            break;
                                        case "textarea":
                                            ae(l3, o3);
                                            break;
                                        case "select":
                                            var p2 = l3._wrapperState.wasMultiple;
                                            l3._wrapperState.wasMultiple = !!o3.multiple;
                                            var h2 = o3.value;
                                            h2 != null ? te(l3, !!o3.multiple, h2, !1) : p2 !== !!o3.multiple && (o3.defaultValue != null ? te(l3, !!o3.multiple, o3.defaultValue, !0) : te(l3, !!o3.multiple, o3.multiple ? [] : "", !1))
                                    }
                                    l3[pl] = o3
                                } catch (g2) {
                                    Es(e3, e3.return, g2)
                                }
                            }
                            break;
                        case 6:
                            if (mu(n3, e3), vu(e3), 4 & r3) {
                                if (e3.stateNode === null) throw Error(a2(162));
                                l3 = e3.stateNode, o3 = e3.memoizedProps;
                                try {
                                    l3.nodeValue = o3
                                } catch (g2) {
                                    Es(e3, e3.return, g2)
                                }
                            }
                            break;
                        case 3:
                            if (mu(n3, e3), vu(e3), 4 & r3 && t3 !== null && t3.memoizedState.isDehydrated) try {
                                Vn(n3.containerInfo)
                            } catch (g2) {
                                Es(e3, e3.return, g2)
                            }
                            break;
                        case 4:
                        default:
                            mu(n3, e3), vu(e3);
                            break;
                        case 13:
                            mu(n3, e3), vu(e3), 8192 & (l3 = e3.child).flags && (o3 = l3.memoizedState !== null, l3.stateNode.isHidden = o3, !o3 || l3.alternate !== null && l3.alternate.memoizedState !== null || (Bu = Je())), 4 & r3 && hu(e3);
                            break;
                        case 22:
                            if (d3 = t3 !== null && t3.memoizedState !== null, 1 & e3.mode ? (Zi = (c3 = Zi) || d3, mu(n3, e3), Zi = c3) : mu(n3, e3), vu(e3), 8192 & r3) {
                                if (c3 = e3.memoizedState !== null, (e3.stateNode.isHidden = c3) && !d3 && (1 & e3.mode) !== 0)
                                    for (qi = e3, d3 = e3.child; d3 !== null;) {
                                        for (f2 = qi = d3; qi !== null;) {
                                            switch (h2 = (p2 = qi).child, p2.tag) {
                                                case 0:
                                                case 11:
                                                case 14:
                                                case 15:
                                                    tu(4, p2, p2.return);
                                                    break;
                                                case 1:
                                                    Ki(p2, p2.return);
                                                    var m2 = p2.stateNode;
                                                    if (typeof m2.componentWillUnmount == "function") {
                                                        r3 = p2, t3 = p2.return;
                                                        try {
                                                            n3 = r3, m2.props = n3.memoizedProps, m2.state = n3.memoizedState, m2.componentWillUnmount()
                                                        } catch (g2) {
                                                            Es(r3, t3, g2)
                                                        }
                                                    }
                                                    break;
                                                case 5:
                                                    Ki(p2, p2.return);
                                                    break;
                                                case 22:
                                                    if (p2.memoizedState !== null) {
                                                        ku(f2);
                                                        continue
                                                    }
                                            }
                                            h2 !== null ? (h2.return = p2, qi = h2) : ku(f2)
                                        }
                                        d3 = d3.sibling
                                    }
                                e: for (d3 = null, f2 = e3;;) {
                                    if (f2.tag === 5) {
                                        if (d3 === null) {
                                            d3 = f2;
                                            try {
                                                l3 = f2.stateNode, c3 ? typeof(o3 = l3.style).setProperty == "function" ? o3.setProperty("display", "none", "important") : o3.display = "none" : (u3 = f2.stateNode, i3 = (s3 = f2.memoizedProps.style) !== void 0 && s3 !== null && s3.hasOwnProperty("display") ? s3.display : null, u3.style.display = me("display", i3))
                                            } catch (g2) {
                                                Es(e3, e3.return, g2)
                                            }
                                        }
                                    } else if (f2.tag === 6) {
                                        if (d3 === null) try {
                                            f2.stateNode.nodeValue = c3 ? "" : f2.memoizedProps
                                        } catch (g2) {
                                            Es(e3, e3.return, g2)
                                        }
                                    } else if ((f2.tag !== 22 && f2.tag !== 23 || f2.memoizedState === null || f2 === e3) && f2.child !== null) {
                                        f2.child.return = f2, f2 = f2.child;
                                        continue
                                    }
                                    if (f2 === e3) break e;
                                    for (; f2.sibling === null;) {
                                        if (f2.return === null || f2.return === e3) break e;
                                        d3 === f2 && (d3 = null), f2 = f2.return
                                    }
                                    d3 === f2 && (d3 = null), f2.sibling.return = f2.return, f2 = f2.sibling
                                }
                            }
                            break;
                        case 19:
                            mu(n3, e3), vu(e3), 4 & r3 && hu(e3);
                        case 21:
                    }
                }

                function vu(e3) {
                    var n3 = e3.flags;
                    if (2 & n3) {
                        try {
                            e: {
                                for (var t3 = e3.return; t3 !== null;) {
                                    if (ou(t3)) {
                                        var r3 = t3;
                                        break e
                                    }
                                    t3 = t3.return
                                }
                                throw Error(a2(160))
                            }
                            switch (r3.tag) {
                                case 5:
                                    var l3 = r3.stateNode;
                                    32 & r3.flags && (fe(l3, ""), r3.flags &= -33), su(e3, iu(e3), l3);
                                    break;
                                case 3:
                                case 4:
                                    var o3 = r3.stateNode.containerInfo;
                                    uu(e3, iu(e3), o3);
                                    break;
                                default:
                                    throw Error(a2(161))
                            }
                        }
                        catch (i3) {
                            Es(e3, e3.return, i3)
                        }
                        e3.flags &= -3
                    }
                    4096 & n3 && (e3.flags &= -4097)
                }

                function yu(e3, n3, t3) {
                    qi = e3, bu(e3, n3, t3)
                }

                function bu(e3, n3, t3) {
                    for (var r3 = (1 & e3.mode) !== 0; qi !== null;) {
                        var l3 = qi,
                            a3 = l3.child;
                        if (l3.tag === 22 && r3) {
                            var o3 = l3.memoizedState !== null || Xi;
                            if (!o3) {
                                var i3 = l3.alternate,
                                    u3 = i3 !== null && i3.memoizedState !== null || Zi;
                                i3 = Xi;
                                var s3 = Zi;
                                if (Xi = o3, (Zi = u3) && !s3)
                                    for (qi = l3; qi !== null;) u3 = (o3 = qi).child, o3.tag === 22 && o3.memoizedState !== null ? Su(l3) : u3 !== null ? (u3.return = o3, qi = u3) : Su(l3);
                                for (; a3 !== null;) qi = a3, bu(a3, n3, t3), a3 = a3.sibling;
                                qi = l3, Xi = i3, Zi = s3
                            }
                            wu(e3)
                        } else 8772 & l3.subtreeFlags && a3 !== null ? (a3.return = l3, qi = a3) : wu(e3)
                    }
                }

                function wu(e3) {
                    for (; qi !== null;) {
                        var n3 = qi;
                        if (8772 & n3.flags) {
                            var t3 = n3.alternate;
                            try {
                                if (8772 & n3.flags) switch (n3.tag) {
                                    case 0:
                                    case 11:
                                    case 15:
                                        Zi || ru(5, n3);
                                        break;
                                    case 1:
                                        var r3 = n3.stateNode;
                                        if (4 & n3.flags && !Zi)
                                            if (t3 === null) r3.componentDidMount();
                                            else {
                                                var l3 = n3.elementType === n3.type ? t3.memoizedProps : ti(n3.type, t3.memoizedProps);
                                                r3.componentDidUpdate(l3, t3.memoizedState, r3.__reactInternalSnapshotBeforeUpdate)
                                            } var o3 = n3.updateQueue;
                                        o3 !== null && Va(n3, o3, r3);
                                        break;
                                    case 3:
                                        var i3 = n3.updateQueue;
                                        if (i3 !== null) {
                                            if (t3 = null, n3.child !== null) switch (n3.child.tag) {
                                                case 5:
                                                case 1:
                                                    t3 = n3.child.stateNode
                                            }
                                            Va(n3, i3, t3)
                                        }
                                        break;
                                    case 5:
                                        var u3 = n3.stateNode;
                                        if (t3 === null && 4 & n3.flags) {
                                            t3 = u3;
                                            var s3 = n3.memoizedProps;
                                            switch (n3.type) {
                                                case "button":
                                                case "input":
                                                case "select":
                                                case "textarea":
                                                    s3.autoFocus && t3.focus();
                                                    break;
                                                case "img":
                                                    s3.src && (t3.src = s3.src)
                                            }
                                        }
                                        break;
                                    case 6:
                                    case 4:
                                    case 12:
                                    case 19:
                                    case 17:
                                    case 21:
                                    case 22:
                                    case 23:
                                    case 25:
                                        break;
                                    case 13:
                                        if (n3.memoizedState === null) {
                                            var c3 = n3.alternate;
                                            if (c3 !== null) {
                                                var d3 = c3.memoizedState;
                                                if (d3 !== null) {
                                                    var f2 = d3.dehydrated;
                                                    f2 !== null && Vn(f2)
                                                }
                                            }
                                        }
                                        break;
                                    default:
                                        throw Error(a2(163))
                                }
                                Zi || 512 & n3.flags && lu(n3)
                            } catch (p2) {
                                Es(n3, n3.return, p2)
                            }
                        }
                        if (n3 === e3) {
                            qi = null;
                            break
                        }
                        if ((t3 = n3.sibling) !== null) {
                            t3.return = n3.return, qi = t3;
                            break
                        }
                        qi = n3.return
                    }
                }

                function ku(e3) {
                    for (; qi !== null;) {
                        var n3 = qi;
                        if (n3 === e3) {
                            qi = null;
                            break
                        }
                        var t3 = n3.sibling;
                        if (t3 !== null) {
                            t3.return = n3.return, qi = t3;
                            break
                        }
                        qi = n3.return
                    }
                }

                function Su(e3) {
                    for (; qi !== null;) {
                        var n3 = qi;
                        try {
                            switch (n3.tag) {
                                case 0:
                                case 11:
                                case 15:
                                    var t3 = n3.return;
                                    try {
                                        ru(4, n3)
                                    } catch (u3) {
                                        Es(n3, t3, u3)
                                    }
                                    break;
                                case 1:
                                    var r3 = n3.stateNode;
                                    if (typeof r3.componentDidMount == "function") {
                                        var l3 = n3.return;
                                        try {
                                            r3.componentDidMount()
                                        } catch (u3) {
                                            Es(n3, l3, u3)
                                        }
                                    }
                                    var a3 = n3.return;
                                    try {
                                        lu(n3)
                                    } catch (u3) {
                                        Es(n3, a3, u3)
                                    }
                                    break;
                                case 5:
                                    var o3 = n3.return;
                                    try {
                                        lu(n3)
                                    } catch (u3) {
                                        Es(n3, o3, u3)
                                    }
                            }
                        } catch (u3) {
                            Es(n3, n3.return, u3)
                        }
                        if (n3 === e3) {
                            qi = null;
                            break
                        }
                        var i3 = n3.sibling;
                        if (i3 !== null) {
                            i3.return = n3.return, qi = i3;
                            break
                        }
                        qi = n3.return
                    }
                }
                var xu, Eu = Math.ceil,
                    Nu = w.ReactCurrentDispatcher,
                    Cu = w.ReactCurrentOwner,
                    _u = w.ReactCurrentBatchConfig,
                    zu = 0,
                    Pu = null,
                    Lu = null,
                    Tu = 0,
                    ju = 0,
                    Ru = El(0),
                    Mu = 0,
                    Iu = null,
                    Du = 0,
                    Au = 0,
                    Fu = 0,
                    Ou = null,
                    Uu = null,
                    Bu = 0,
                    Wu = 1 / 0,
                    Vu = null,
                    Hu = !1,
                    Qu = null,
                    Yu = null,
                    Gu = !1,
                    $u = null,
                    Xu = 0,
                    Zu = 0,
                    Ju = null,
                    qu = -1,
                    Ku = 0;

                function es() {
                    return 6 & zu ? Je() : qu !== -1 ? qu : qu = Je()
                }

                function ns(e3) {
                    return 1 & e3.mode ? 2 & zu && Tu !== 0 ? Tu & -Tu : ma.transition !== null ? (Ku === 0 && (Ku = gn()), Ku) : (e3 = wn) !== 0 ? e3 : e3 = (e3 = window.event) === void 0 ? 16 : Jn(e3.type) : 1
                }

                function ts(e3, n3, t3, r3) {
                    if (50 < Zu) throw Zu = 0, Ju = null, Error(a2(185));
                    yn(e3, t3, r3), 2 & zu && e3 === Pu || (e3 === Pu && (!(2 & zu) && (Au |= t3), Mu === 4 && is(e3, Tu)), rs(e3, r3), t3 === 1 && zu === 0 && !(1 & n3.mode) && (Wu = Je() + 500, Ol && Wl()))
                }

                function rs(e3, n3) {
                    var t3 = e3.callbackNode;
                    (function(e4, n4) {
                        for (var t4 = e4.suspendedLanes, r4 = e4.pingedLanes, l3 = e4.expirationTimes, a3 = e4.pendingLanes; 0 < a3;) {
                            var o3 = 31 - on(a3),
                                i3 = 1 << o3,
                                u3 = l3[o3];
                            u3 === -1 ? i3 & t4 && !(i3 & r4) || (l3[o3] = hn(i3, n4)) : u3 <= n4 && (e4.expiredLanes |= i3), a3 &= ~i3
                        }
                    })(e3, n3);
                    var r3 = pn(e3, e3 === Pu ? Tu : 0);
                    if (r3 === 0) t3 !== null && $e(t3), e3.callbackNode = null, e3.callbackPriority = 0;
                    else if (n3 = r3 & -r3, e3.callbackPriority !== n3) {
                        if (t3 != null && $e(t3), n3 === 1) e3.tag === 0 ? function(e4) {
                            Ol = !0, Bl(e4)
                        }(us.bind(null, e3)) : Bl(us.bind(null, e3)), ol(function() {
                            !(6 & zu) && Wl()
                        }), t3 = null;
                        else {
                            switch (kn(r3)) {
                                case 1:
                                    t3 = Ke;
                                    break;
                                case 4:
                                    t3 = en;
                                    break;
                                case 16:
                                default:
                                    t3 = nn;
                                    break;
                                case 536870912:
                                    t3 = rn
                            }
                            t3 = Ps(t3, ls.bind(null, e3))
                        }
                        e3.callbackPriority = n3, e3.callbackNode = t3
                    }
                }

                function ls(e3, n3) {
                    if (qu = -1, Ku = 0, (6 & zu) !== 0) throw Error(a2(327));
                    var t3 = e3.callbackNode;
                    if (Ss() && e3.callbackNode !== t3) return null;
                    var r3 = pn(e3, e3 === Pu ? Tu : 0);
                    if (r3 === 0) return null;
                    if (30 & r3 || r3 & e3.expiredLanes || n3) n3 = gs(e3, r3);
                    else {
                        n3 = r3;
                        var l3 = zu;
                        zu |= 2;
                        var o3 = hs();
                        for (Pu === e3 && Tu === n3 || (Vu = null, Wu = Je() + 500, fs(e3, n3));;) try {
                            ys();
                            break
                        } catch (u3) {
                            ps(e3, u3)
                        }
                        Ca(), Nu.current = o3, zu = l3, Lu !== null ? n3 = 0 : (Pu = null, Tu = 0, n3 = Mu)
                    }
                    if (n3 !== 0) {
                        if (n3 === 2 && (l3 = mn(e3)) !== 0 && (r3 = l3, n3 = as(e3, l3)), n3 === 1) throw t3 = Iu, fs(e3, 0), is(e3, r3), rs(e3, Je()), t3;
                        if (n3 === 6) is(e3, r3);
                        else {
                            if (l3 = e3.current.alternate, (30 & r3) === 0 && ! function(e4) {
                                    for (var n4 = e4;;) {
                                        if (16384 & n4.flags) {
                                            var t4 = n4.updateQueue;
                                            if (t4 !== null && (t4 = t4.stores) !== null)
                                                for (var r4 = 0; r4 < t4.length; r4++) {
                                                    var l4 = t4[r4],
                                                        a3 = l4.getSnapshot;
                                                    l4 = l4.value;
                                                    try {
                                                        if (!ir(a3(), l4)) return !1
                                                    } catch {
                                                        return !1
                                                    }
                                                }
                                        }
                                        if (t4 = n4.child, 16384 & n4.subtreeFlags && t4 !== null) t4.return = n4, n4 = t4;
                                        else {
                                            if (n4 === e4) break;
                                            for (; n4.sibling === null;) {
                                                if (n4.return === null || n4.return === e4) return !0;
                                                n4 = n4.return
                                            }
                                            n4.sibling.return = n4.return, n4 = n4.sibling
                                        }
                                    }
                                    return !0
                                }(l3) && ((n3 = gs(e3, r3)) === 2 && (o3 = mn(e3)) !== 0 && (r3 = o3, n3 = as(e3, o3)), n3 === 1)) throw t3 = Iu, fs(e3, 0), is(e3, r3), rs(e3, Je()), t3;
                            switch (e3.finishedWork = l3, e3.finishedLanes = r3, n3) {
                                case 0:
                                case 1:
                                    throw Error(a2(345));
                                case 2:
                                case 5:
                                    ks(e3, Uu, Vu);
                                    break;
                                case 3:
                                    if (is(e3, r3), (130023424 & r3) === r3 && 10 < (n3 = Bu + 500 - Je())) {
                                        if (pn(e3, 0) !== 0) break;
                                        if (((l3 = e3.suspendedLanes) & r3) !== r3) {
                                            es(), e3.pingedLanes |= e3.suspendedLanes & l3;
                                            break
                                        }
                                        e3.timeoutHandle = rl(ks.bind(null, e3, Uu, Vu), n3);
                                        break
                                    }
                                    ks(e3, Uu, Vu);
                                    break;
                                case 4:
                                    if (is(e3, r3), (4194240 & r3) === r3) break;
                                    for (n3 = e3.eventTimes, l3 = -1; 0 < r3;) {
                                        var i3 = 31 - on(r3);
                                        o3 = 1 << i3, (i3 = n3[i3]) > l3 && (l3 = i3), r3 &= ~o3
                                    }
                                    if (r3 = l3, 10 < (r3 = (120 > (r3 = Je() - r3) ? 120 : 480 > r3 ? 480 : 1080 > r3 ? 1080 : 1920 > r3 ? 1920 : 3e3 > r3 ? 3e3 : 4320 > r3 ? 4320 : 1960 * Eu(r3 / 1960)) - r3)) {
                                        e3.timeoutHandle = rl(ks.bind(null, e3, Uu, Vu), r3);
                                        break
                                    }
                                    ks(e3, Uu, Vu);
                                    break;
                                default:
                                    throw Error(a2(329))
                            }
                        }
                    }
                    return rs(e3, Je()), e3.callbackNode === t3 ? ls.bind(null, e3) : null
                }

                function as(e3, n3) {
                    var t3 = Ou;
                    return e3.current.memoizedState.isDehydrated && (fs(e3, n3).flags |= 256), (e3 = gs(e3, n3)) !== 2 && (n3 = Uu, Uu = t3, n3 !== null && os(n3)), e3
                }

                function os(e3) {
                    Uu === null ? Uu = e3 : Uu.push.apply(Uu, e3)
                }

                function is(e3, n3) {
                    for (n3 &= ~Fu, n3 &= ~Au, e3.suspendedLanes |= n3, e3.pingedLanes &= ~n3, e3 = e3.expirationTimes; 0 < n3;) {
                        var t3 = 31 - on(n3),
                            r3 = 1 << t3;
                        e3[t3] = -1, n3 &= ~r3
                    }
                }

                function us(e3) {
                    if (6 & zu) throw Error(a2(327));
                    Ss();
                    var n3 = pn(e3, 0);
                    if (!(1 & n3)) return rs(e3, Je()), null;
                    var t3 = gs(e3, n3);
                    if (e3.tag !== 0 && t3 === 2) {
                        var r3 = mn(e3);
                        r3 !== 0 && (n3 = r3, t3 = as(e3, r3))
                    }
                    if (t3 === 1) throw t3 = Iu, fs(e3, 0), is(e3, n3), rs(e3, Je()), t3;
                    if (t3 === 6) throw Error(a2(345));
                    return e3.finishedWork = e3.current.alternate, e3.finishedLanes = n3, ks(e3, Uu, Vu), rs(e3, Je()), null
                }

                function ss(e3, n3) {
                    var t3 = zu;
                    zu |= 1;
                    try {
                        return e3(n3)
                    } finally {
                        (zu = t3) === 0 && (Wu = Je() + 500, Ol && Wl())
                    }
                }

                function cs(e3) {
                    $u !== null && $u.tag === 0 && !(6 & zu) && Ss();
                    var n3 = zu;
                    zu |= 1;
                    var t3 = _u.transition,
                        r3 = wn;
                    try {
                        if (_u.transition = null, wn = 1, e3) return e3()
                    } finally {
                        wn = r3, _u.transition = t3, !(6 & (zu = n3)) && Wl()
                    }
                }

                function ds() {
                    ju = Ru.current, Nl(Ru)
                }

                function fs(e3, n3) {
                    e3.finishedWork = null, e3.finishedLanes = 0;
                    var t3 = e3.timeoutHandle;
                    if (t3 !== -1 && (e3.timeoutHandle = -1, ll(t3)), Lu !== null)
                        for (t3 = Lu.return; t3 !== null;) {
                            var r3 = t3;
                            switch (na(r3), r3.tag) {
                                case 1:
                                    (r3 = r3.type.childContextTypes) !== null && r3 !== void 0 && Rl();
                                    break;
                                case 3:
                                    Za(), Nl(Pl), Nl(zl), to();
                                    break;
                                case 5:
                                    qa(r3);
                                    break;
                                case 4:
                                    Za();
                                    break;
                                case 13:
                                case 19:
                                    Nl(Ka);
                                    break;
                                case 10:
                                    _a(r3.type._context);
                                    break;
                                case 22:
                                case 23:
                                    ds()
                            }
                            t3 = t3.return
                        }
                    if (Pu = e3, Lu = e3 = Rs(e3.current, null), Tu = ju = n3, Mu = 0, Iu = null, Fu = Au = Du = 0, Uu = Ou = null, Ta !== null) {
                        for (n3 = 0; n3 < Ta.length; n3++)
                            if ((r3 = (t3 = Ta[n3]).interleaved) !== null) {
                                t3.interleaved = null;
                                var l3 = r3.next,
                                    a3 = t3.pending;
                                if (a3 !== null) {
                                    var o3 = a3.next;
                                    a3.next = l3, r3.next = o3
                                }
                                t3.pending = r3
                            } Ta = null
                    }
                    return e3
                }

                function ps(e3, n3) {
                    for (;;) {
                        var t3 = Lu;
                        try {
                            if (Ca(), ro.current = qo, so) {
                                for (var r3 = oo.memoizedState; r3 !== null;) {
                                    var l3 = r3.queue;
                                    l3 !== null && (l3.pending = null), r3 = r3.next
                                }
                                so = !1
                            }
                            if (ao = 0, uo = io = oo = null, co = !1, fo = 0, Cu.current = null, t3 === null || t3.return === null) {
                                Mu = 1, Iu = n3, Lu = null;
                                break
                            }
                            e: {
                                var o3 = e3,
                                    i3 = t3.return,
                                    u3 = t3,
                                    s3 = n3;
                                if (n3 = Tu, u3.flags |= 32768, s3 !== null && typeof s3 == "object" && typeof s3.then == "function") {
                                    var c3 = s3,
                                        d3 = u3,
                                        f2 = d3.tag;
                                    if (!(1 & d3.mode) && (f2 === 0 || f2 === 11 || f2 === 15)) {
                                        var p2 = d3.alternate;
                                        p2 ? (d3.updateQueue = p2.updateQueue, d3.memoizedState = p2.memoizedState, d3.lanes = p2.lanes) : (d3.updateQueue = null, d3.memoizedState = null)
                                    }
                                    var h2 = gi(i3);
                                    if (h2 !== null) {
                                        h2.flags &= -257, vi(h2, i3, u3, 0, n3), 1 & h2.mode && mi(o3, c3, n3), s3 = c3;
                                        var m2 = (n3 = h2).updateQueue;
                                        if (m2 === null) {
                                            var g2 = new Set;
                                            g2.add(s3), n3.updateQueue = g2
                                        } else m2.add(s3);
                                        break e
                                    }
                                    if (!(1 & n3)) {
                                        mi(o3, c3, n3), ms();
                                        break e
                                    }
                                    s3 = Error(a2(426))
                                } else if (la && 1 & u3.mode) {
                                    var v2 = gi(i3);
                                    if (v2 !== null) {
                                        !(65536 & v2.flags) && (v2.flags |= 256), vi(v2, i3, u3, 0, n3), ha(si(s3, u3));
                                        break e
                                    }
                                }
                                o3 = s3 = si(s3, u3),
                                Mu !== 4 && (Mu = 2),
                                Ou === null ? Ou = [o3] : Ou.push(o3),
                                o3 = i3;do {
                                    switch (o3.tag) {
                                        case 3:
                                            o3.flags |= 65536, n3 &= -n3, o3.lanes |= n3, Ba(o3, pi(0, s3, n3));
                                            break e;
                                        case 1:
                                            u3 = s3;
                                            var y2 = o3.type,
                                                b2 = o3.stateNode;
                                            if (!(128 & o3.flags) && (typeof y2.getDerivedStateFromError == "function" || b2 !== null && typeof b2.componentDidCatch == "function" && (Yu === null || !Yu.has(b2)))) {
                                                o3.flags |= 65536, n3 &= -n3, o3.lanes |= n3, Ba(o3, hi(o3, u3, n3));
                                                break e
                                            }
                                    }
                                    o3 = o3.return
                                } while (o3 !== null)
                            }
                            ws(t3)
                        } catch (w2) {
                            n3 = w2, Lu === t3 && t3 !== null && (Lu = t3 = t3.return);
                            continue
                        }
                        break
                    }
                }

                function hs() {
                    var e3 = Nu.current;
                    return Nu.current = qo, e3 === null ? qo : e3
                }

                function ms() {
                    Mu !== 0 && Mu !== 3 && Mu !== 2 || (Mu = 4), Pu === null || !(268435455 & Du) && !(268435455 & Au) || is(Pu, Tu)
                }

                function gs(e3, n3) {
                    var t3 = zu;
                    zu |= 2;
                    var r3 = hs();
                    for (Pu === e3 && Tu === n3 || (Vu = null, fs(e3, n3));;) try {
                        vs();
                        break
                    } catch (l3) {
                        ps(e3, l3)
                    }
                    if (Ca(), zu = t3, Nu.current = r3, Lu !== null) throw Error(a2(261));
                    return Pu = null, Tu = 0, Mu
                }

                function vs() {
                    for (; Lu !== null;) bs(Lu)
                }

                function ys() {
                    for (; Lu !== null && !Xe();) bs(Lu)
                }

                function bs(e3) {
                    var n3 = xu(e3.alternate, e3, ju);
                    e3.memoizedProps = e3.pendingProps, n3 === null ? ws(e3) : Lu = n3, Cu.current = null
                }

                function ws(e3) {
                    var n3 = e3;
                    do {
                        var t3 = n3.alternate;
                        if (e3 = n3.return, (32768 & n3.flags) === 0) {
                            if ((t3 = Gi(t3, n3, ju)) !== null) return void(Lu = t3)
                        } else {
                            if ((t3 = $i(t3, n3)) !== null) return t3.flags &= 32767, void(Lu = t3);
                            if (e3 === null) return Mu = 6, void(Lu = null);
                            e3.flags |= 32768, e3.subtreeFlags = 0, e3.deletions = null
                        }
                        if ((n3 = n3.sibling) !== null) return void(Lu = n3);
                        Lu = n3 = e3
                    } while (n3 !== null);
                    Mu === 0 && (Mu = 5)
                }

                function ks(e3, n3, t3) {
                    var r3 = wn,
                        l3 = _u.transition;
                    try {
                        _u.transition = null, wn = 1,
                            function(e4, n4, t4, r4) {
                                do Ss(); while ($u !== null);
                                if (6 & zu) throw Error(a2(327));
                                t4 = e4.finishedWork;
                                var l4 = e4.finishedLanes;
                                if (t4 === null) return null;
                                if (e4.finishedWork = null, e4.finishedLanes = 0, t4 === e4.current) throw Error(a2(177));
                                e4.callbackNode = null, e4.callbackPriority = 0;
                                var o3 = t4.lanes | t4.childLanes;
                                if (function(e5, n5) {
                                        var t5 = e5.pendingLanes & ~n5;
                                        e5.pendingLanes = n5, e5.suspendedLanes = 0, e5.pingedLanes = 0, e5.expiredLanes &= n5, e5.mutableReadLanes &= n5, e5.entangledLanes &= n5, n5 = e5.entanglements;
                                        var r5 = e5.eventTimes;
                                        for (e5 = e5.expirationTimes; 0 < t5;) {
                                            var l5 = 31 - on(t5),
                                                a3 = 1 << l5;
                                            n5[l5] = 0, r5[l5] = -1, e5[l5] = -1, t5 &= ~a3
                                        }
                                    }(e4, o3), e4 === Pu && (Lu = Pu = null, Tu = 0), !(2064 & t4.subtreeFlags) && !(2064 & t4.flags) || Gu || (Gu = !0, Ps(nn, function() {
                                        return Ss(), null
                                    })), o3 = (15990 & t4.flags) !== 0, (15990 & t4.subtreeFlags) !== 0 || o3) {
                                    o3 = _u.transition, _u.transition = null;
                                    var i3 = wn;
                                    wn = 1;
                                    var u3 = zu;
                                    zu |= 4, Cu.current = null,
                                        function(e5, n5) {
                                            if (el = Qn, pr(e5 = fr())) {
                                                if ("selectionStart" in e5) var t5 = {
                                                    start: e5.selectionStart,
                                                    end: e5.selectionEnd
                                                };
                                                else e: {
                                                    var r5 = (t5 = (t5 = e5.ownerDocument) && t5.defaultView || window).getSelection && t5.getSelection();
                                                    if (r5 && r5.rangeCount !== 0) {
                                                        t5 = r5.anchorNode;
                                                        var l5 = r5.anchorOffset,
                                                            o4 = r5.focusNode;
                                                        r5 = r5.focusOffset;
                                                        try {
                                                            t5.nodeType, o4.nodeType
                                                        } catch {
                                                            t5 = null;
                                                            break e
                                                        }
                                                        var i4 = 0,
                                                            u4 = -1,
                                                            s3 = -1,
                                                            c3 = 0,
                                                            d3 = 0,
                                                            f2 = e5,
                                                            p2 = null;
                                                        n: for (;;) {
                                                            for (var h2; f2 !== t5 || l5 !== 0 && f2.nodeType !== 3 || (u4 = i4 + l5), f2 !== o4 || r5 !== 0 && f2.nodeType !== 3 || (s3 = i4 + r5), f2.nodeType === 3 && (i4 += f2.nodeValue.length), (h2 = f2.firstChild) !== null;) p2 = f2, f2 = h2;
                                                            for (;;) {
                                                                if (f2 === e5) break n;
                                                                if (p2 === t5 && ++c3 === l5 && (u4 = i4), p2 === o4 && ++d3 === r5 && (s3 = i4), (h2 = f2.nextSibling) !== null) break;
                                                                p2 = (f2 = p2).parentNode
                                                            }
                                                            f2 = h2
                                                        }
                                                        t5 = u4 === -1 || s3 === -1 ? null : {
                                                            start: u4,
                                                            end: s3
                                                        }
                                                    } else t5 = null
                                                }
                                                t5 = t5 || {
                                                    start: 0,
                                                    end: 0
                                                }
                                            } else t5 = null;
                                            for (nl = {
                                                    focusedElem: e5,
                                                    selectionRange: t5
                                                }, Qn = !1, qi = n5; qi !== null;)
                                                if (e5 = (n5 = qi).child, (1028 & n5.subtreeFlags) !== 0 && e5 !== null) e5.return = n5, qi = e5;
                                                else
                                                    for (; qi !== null;) {
                                                        n5 = qi;
                                                        try {
                                                            var m2 = n5.alternate;
                                                            if (1024 & n5.flags) switch (n5.tag) {
                                                                case 0:
                                                                case 11:
                                                                case 15:
                                                                case 5:
                                                                case 6:
                                                                case 4:
                                                                case 17:
                                                                    break;
                                                                case 1:
                                                                    if (m2 !== null) {
                                                                        var g2 = m2.memoizedProps,
                                                                            v2 = m2.memoizedState,
                                                                            y2 = n5.stateNode,
                                                                            b2 = y2.getSnapshotBeforeUpdate(n5.elementType === n5.type ? g2 : ti(n5.type, g2), v2);
                                                                        y2.__reactInternalSnapshotBeforeUpdate = b2
                                                                    }
                                                                    break;
                                                                case 3:
                                                                    var w2 = n5.stateNode.containerInfo;
                                                                    w2.nodeType === 1 ? w2.textContent = "" : w2.nodeType === 9 && w2.documentElement && w2.removeChild(w2.documentElement);
                                                                    break;
                                                                default:
                                                                    throw Error(a2(163))
                                                            }
                                                        } catch (k2) {
                                                            Es(n5, n5.return, k2)
                                                        }
                                                        if ((e5 = n5.sibling) !== null) {
                                                            e5.return = n5.return, qi = e5;
                                                            break
                                                        }
                                                        qi = n5.return
                                                    }
                                            m2 = nu, nu = !1
                                        }(e4, t4), gu(t4, e4), hr(nl), Qn = !!el, nl = el = null, e4.current = t4, yu(t4, e4, l4), Ze(), zu = u3, wn = i3, _u.transition = o3
                                } else e4.current = t4;
                                if (Gu && (Gu = !1, $u = e4, Xu = l4), o3 = e4.pendingLanes, o3 === 0 && (Yu = null), function(e5) {
                                        if (an && typeof an.onCommitFiberRoot == "function") try {
                                            an.onCommitFiberRoot(ln, e5, void 0, (128 & e5.current.flags) === 128)
                                        } catch {}
                                    }(t4.stateNode), rs(e4, Je()), n4 !== null)
                                    for (r4 = e4.onRecoverableError, t4 = 0; t4 < n4.length; t4++) l4 = n4[t4], r4(l4.value, {
                                        componentStack: l4.stack,
                                        digest: l4.digest
                                    });
                                if (Hu) throw Hu = !1, e4 = Qu, Qu = null, e4;
                                1 & Xu && e4.tag !== 0 && Ss(), o3 = e4.pendingLanes, 1 & o3 ? e4 === Ju ? Zu++ : (Zu = 0, Ju = e4) : Zu = 0, Wl()
                            }(e3, n3, t3, r3)
                    } finally {
                        _u.transition = l3, wn = r3
                    }
                    return null
                }

                function Ss() {
                    if ($u !== null) {
                        var e3 = kn(Xu),
                            n3 = _u.transition,
                            t3 = wn;
                        try {
                            if (_u.transition = null, wn = 16 > e3 ? 16 : e3, $u === null) var r3 = !1;
                            else {
                                if (e3 = $u, $u = null, Xu = 0, (6 & zu) !== 0) throw Error(a2(331));
                                var l3 = zu;
                                for (zu |= 4, qi = e3.current; qi !== null;) {
                                    var o3 = qi,
                                        i3 = o3.child;
                                    if (16 & qi.flags) {
                                        var u3 = o3.deletions;
                                        if (u3 !== null) {
                                            for (var s3 = 0; s3 < u3.length; s3++) {
                                                var c3 = u3[s3];
                                                for (qi = c3; qi !== null;) {
                                                    var d3 = qi;
                                                    switch (d3.tag) {
                                                        case 0:
                                                        case 11:
                                                        case 15:
                                                            tu(8, d3, o3)
                                                    }
                                                    var f2 = d3.child;
                                                    if (f2 !== null) f2.return = d3, qi = f2;
                                                    else
                                                        for (; qi !== null;) {
                                                            var p2 = (d3 = qi).sibling,
                                                                h2 = d3.return;
                                                            if (au(d3), d3 === c3) {
                                                                qi = null;
                                                                break
                                                            }
                                                            if (p2 !== null) {
                                                                p2.return = h2, qi = p2;
                                                                break
                                                            }
                                                            qi = h2
                                                        }
                                                }
                                            }
                                            var m2 = o3.alternate;
                                            if (m2 !== null) {
                                                var g2 = m2.child;
                                                if (g2 !== null) {
                                                    m2.child = null;
                                                    do {
                                                        var v2 = g2.sibling;
                                                        g2.sibling = null, g2 = v2
                                                    } while (g2 !== null)
                                                }
                                            }
                                            qi = o3
                                        }
                                    }
                                    if (2064 & o3.subtreeFlags && i3 !== null) i3.return = o3, qi = i3;
                                    else e: for (; qi !== null;) {
                                        if (2048 & (o3 = qi).flags) switch (o3.tag) {
                                            case 0:
                                            case 11:
                                            case 15:
                                                tu(9, o3, o3.return)
                                        }
                                        var y2 = o3.sibling;
                                        if (y2 !== null) {
                                            y2.return = o3.return, qi = y2;
                                            break e
                                        }
                                        qi = o3.return
                                    }
                                }
                                var b2 = e3.current;
                                for (qi = b2; qi !== null;) {
                                    var w2 = (i3 = qi).child;
                                    if (2064 & i3.subtreeFlags && w2 !== null) w2.return = i3, qi = w2;
                                    else e: for (i3 = b2; qi !== null;) {
                                        if (2048 & (u3 = qi).flags) try {
                                            switch (u3.tag) {
                                                case 0:
                                                case 11:
                                                case 15:
                                                    ru(9, u3)
                                            }
                                        } catch (S2) {
                                            Es(u3, u3.return, S2)
                                        }
                                        if (u3 === i3) {
                                            qi = null;
                                            break e
                                        }
                                        var k2 = u3.sibling;
                                        if (k2 !== null) {
                                            k2.return = u3.return, qi = k2;
                                            break e
                                        }
                                        qi = u3.return
                                    }
                                }
                                if (zu = l3, Wl(), an && typeof an.onPostCommitFiberRoot == "function") try {
                                    an.onPostCommitFiberRoot(ln, e3)
                                } catch {}
                                r3 = !0
                            }
                            return r3
                        } finally {
                            wn = t3, _u.transition = n3
                        }
                    }
                    return !1
                }

                function xs(e3, n3, t3) {
                    e3 = Oa(e3, n3 = pi(0, n3 = si(t3, n3), 1), 1), n3 = es(), e3 !== null && (yn(e3, 1, n3), rs(e3, n3))
                }

                function Es(e3, n3, t3) {
                    if (e3.tag === 3) xs(e3, e3, t3);
                    else
                        for (; n3 !== null;) {
                            if (n3.tag === 3) {
                                xs(n3, e3, t3);
                                break
                            }
                            if (n3.tag === 1) {
                                var r3 = n3.stateNode;
                                if (typeof n3.type.getDerivedStateFromError == "function" || typeof r3.componentDidCatch == "function" && (Yu === null || !Yu.has(r3))) {
                                    n3 = Oa(n3, e3 = hi(n3, e3 = si(t3, e3), 1), 1), e3 = es(), n3 !== null && (yn(n3, 1, e3), rs(n3, e3));
                                    break
                                }
                            }
                            n3 = n3.return
                        }
                }

                function Ns(e3, n3, t3) {
                    var r3 = e3.pingCache;
                    r3 !== null && r3.delete(n3), n3 = es(), e3.pingedLanes |= e3.suspendedLanes & t3, Pu === e3 && (Tu & t3) === t3 && (Mu === 4 || Mu === 3 && (130023424 & Tu) === Tu && 500 > Je() - Bu ? fs(e3, 0) : Fu |= t3), rs(e3, n3)
                }

                function Cs(e3, n3) {
                    n3 === 0 && (1 & e3.mode ? (n3 = dn, !(130023424 & (dn <<= 1)) && (dn = 4194304)) : n3 = 1);
                    var t3 = es();
                    (e3 = Ma(e3, n3)) !== null && (yn(e3, n3, t3), rs(e3, t3))
                }

                function _s(e3) {
                    var n3 = e3.memoizedState,
                        t3 = 0;
                    n3 !== null && (t3 = n3.retryLane), Cs(e3, t3)
                }

                function zs(e3, n3) {
                    var t3 = 0;
                    switch (e3.tag) {
                        case 13:
                            var r3 = e3.stateNode,
                                l3 = e3.memoizedState;
                            l3 !== null && (t3 = l3.retryLane);
                            break;
                        case 19:
                            r3 = e3.stateNode;
                            break;
                        default:
                            throw Error(a2(314))
                    }
                    r3 !== null && r3.delete(n3), Cs(e3, t3)
                }

                function Ps(e3, n3) {
                    return Ge(e3, n3)
                }

                function Ls(e3, n3, t3, r3) {
                    this.tag = e3, this.key = t3, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = n3, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r3, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null
                }

                function Ts(e3, n3, t3, r3) {
                    return new Ls(e3, n3, t3, r3)
                }

                function js(e3) {
                    return !(!(e3 = e3.prototype) || !e3.isReactComponent)
                }

                function Rs(e3, n3) {
                    var t3 = e3.alternate;
                    return t3 === null ? ((t3 = Ts(e3.tag, n3, e3.key, e3.mode)).elementType = e3.elementType, t3.type = e3.type, t3.stateNode = e3.stateNode, t3.alternate = e3, e3.alternate = t3) : (t3.pendingProps = n3, t3.type = e3.type, t3.flags = 0, t3.subtreeFlags = 0, t3.deletions = null), t3.flags = 14680064 & e3.flags, t3.childLanes = e3.childLanes, t3.lanes = e3.lanes, t3.child = e3.child, t3.memoizedProps = e3.memoizedProps, t3.memoizedState = e3.memoizedState, t3.updateQueue = e3.updateQueue, n3 = e3.dependencies, t3.dependencies = n3 === null ? null : {
                        lanes: n3.lanes,
                        firstContext: n3.firstContext
                    }, t3.sibling = e3.sibling, t3.index = e3.index, t3.ref = e3.ref, t3
                }

                function Ms(e3, n3, t3, r3, l3, o3) {
                    var i3 = 2;
                    if (r3 = e3, typeof e3 == "function") js(e3) && (i3 = 1);
                    else if (typeof e3 == "string") i3 = 5;
                    else e: switch (e3) {
                        case x:
                            return Is(t3.children, l3, o3, n3);
                        case E:
                            i3 = 8, l3 |= 8;
                            break;
                        case N:
                            return (e3 = Ts(12, t3, n3, 2 | l3)).elementType = N, e3.lanes = o3, e3;
                        case P:
                            return (e3 = Ts(13, t3, n3, l3)).elementType = P, e3.lanes = o3, e3;
                        case L:
                            return (e3 = Ts(19, t3, n3, l3)).elementType = L, e3.lanes = o3, e3;
                        case R:
                            return Ds(t3, l3, o3, n3);
                        default:
                            if (typeof e3 == "object" && e3 !== null) switch (e3.$$typeof) {
                                case C:
                                    i3 = 10;
                                    break e;
                                case _:
                                    i3 = 9;
                                    break e;
                                case z:
                                    i3 = 11;
                                    break e;
                                case T:
                                    i3 = 14;
                                    break e;
                                case j:
                                    i3 = 16, r3 = null;
                                    break e
                            }
                            throw Error(a2(130, e3 == null ? e3 : typeof e3, ""))
                    }
                    return (n3 = Ts(i3, t3, n3, l3)).elementType = e3, n3.type = r3, n3.lanes = o3, n3
                }

                function Is(e3, n3, t3, r3) {
                    return (e3 = Ts(7, e3, r3, n3)).lanes = t3, e3
                }

                function Ds(e3, n3, t3, r3) {
                    return (e3 = Ts(22, e3, r3, n3)).elementType = R, e3.lanes = t3, e3.stateNode = {
                        isHidden: !1
                    }, e3
                }

                function As(e3, n3, t3) {
                    return (e3 = Ts(6, e3, null, n3)).lanes = t3, e3
                }

                function Fs(e3, n3, t3) {
                    return (n3 = Ts(4, e3.children !== null ? e3.children : [], e3.key, n3)).lanes = t3, n3.stateNode = {
                        containerInfo: e3.containerInfo,
                        pendingChildren: null,
                        implementation: e3.implementation
                    }, n3
                }

                function Os(e3, n3, t3, r3, l3) {
                    this.tag = n3, this.containerInfo = e3, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = vn(0), this.expirationTimes = vn(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = vn(0), this.identifierPrefix = r3, this.onRecoverableError = l3, this.mutableSourceEagerHydrationData = null
                }

                function Us(e3, n3, t3, r3, l3, a3, o3, i3, u3) {
                    return e3 = new Os(e3, n3, t3, i3, u3), n3 === 1 ? (n3 = 1, a3 === !0 && (n3 |= 8)) : n3 = 0, a3 = Ts(3, null, null, n3), e3.current = a3, a3.stateNode = e3, a3.memoizedState = {
                        element: r3,
                        isDehydrated: t3,
                        cache: null,
                        transitions: null,
                        pendingSuspenseBoundaries: null
                    }, Da(a3), e3
                }

                function Bs(e3) {
                    if (!e3) return _l;
                    e: {
                        if (We(e3 = e3._reactInternals) !== e3 || e3.tag !== 1) throw Error(a2(170));
                        var n3 = e3;do {
                            switch (n3.tag) {
                                case 3:
                                    n3 = n3.stateNode.context;
                                    break e;
                                case 1:
                                    if (jl(n3.type)) {
                                        n3 = n3.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break e
                                    }
                            }
                            n3 = n3.return
                        } while (n3 !== null);
                        throw Error(a2(171))
                    }
                    if (e3.tag === 1) {
                        var t3 = e3.type;
                        if (jl(t3)) return Il(e3, t3, n3)
                    }
                    return n3
                }

                function Ws(e3, n3, t3, r3, l3, a3, o3, i3, u3) {
                    return (e3 = Us(t3, r3, !0, e3, 0, a3, 0, i3, u3)).context = Bs(null), t3 = e3.current, (a3 = Fa(r3 = es(), l3 = ns(t3))).callback = n3 ?? null, Oa(t3, a3, l3), e3.current.lanes = l3, yn(e3, l3, r3), rs(e3, r3), e3
                }

                function Vs(e3, n3, t3, r3) {
                    var l3 = n3.current,
                        a3 = es(),
                        o3 = ns(l3);
                    return t3 = Bs(t3), n3.context === null ? n3.context = t3 : n3.pendingContext = t3, (n3 = Fa(a3, o3)).payload = {
                        element: e3
                    }, (r3 = r3 === void 0 ? null : r3) !== null && (n3.callback = r3), (e3 = Oa(l3, n3, o3)) !== null && (ts(e3, l3, o3, a3), Ua(e3, l3, o3)), o3
                }

                function Hs(e3) {
                    return (e3 = e3.current).child ? (e3.child.tag, e3.child.stateNode) : null
                }

                function Qs(e3, n3) {
                    if ((e3 = e3.memoizedState) !== null && e3.dehydrated !== null) {
                        var t3 = e3.retryLane;
                        e3.retryLane = t3 !== 0 && t3 < n3 ? t3 : n3
                    }
                }

                function Ys(e3, n3) {
                    Qs(e3, n3), (e3 = e3.alternate) && Qs(e3, n3)
                }
                xu = function(e3, n3, t3) {
                    if (e3 !== null)
                        if (e3.memoizedProps !== n3.pendingProps || Pl.current) bi = !0;
                        else {
                            if (!(e3.lanes & t3) && !(128 & n3.flags)) return bi = !1,
                                function(e4, n4, t4) {
                                    switch (n4.tag) {
                                        case 3:
                                            Pi(n4), pa();
                                            break;
                                        case 5:
                                            Ja(n4);
                                            break;
                                        case 1:
                                            jl(n4.type) && Dl(n4);
                                            break;
                                        case 4:
                                            Xa(n4, n4.stateNode.containerInfo);
                                            break;
                                        case 10:
                                            var r4 = n4.type._context,
                                                l4 = n4.memoizedProps.value;
                                            Cl(Sa, r4._currentValue), r4._currentValue = l4;
                                            break;
                                        case 13:
                                            if ((r4 = n4.memoizedState) !== null) return r4.dehydrated !== null ? (Cl(Ka, 1 & Ka.current), n4.flags |= 128, null) : t4 & n4.child.childLanes ? Ai(e4, n4, t4) : (Cl(Ka, 1 & Ka.current), (e4 = Hi(e4, n4, t4)) !== null ? e4.sibling : null);
                                            Cl(Ka, 1 & Ka.current);
                                            break;
                                        case 19:
                                            if (r4 = (t4 & n4.childLanes) !== 0, (128 & e4.flags) !== 0) {
                                                if (r4) return Wi(e4, n4, t4);
                                                n4.flags |= 128
                                            }
                                            if ((l4 = n4.memoizedState) !== null && (l4.rendering = null, l4.tail = null, l4.lastEffect = null), Cl(Ka, Ka.current), r4) break;
                                            return null;
                                        case 22:
                                        case 23:
                                            return n4.lanes = 0, Ei(e4, n4, t4)
                                    }
                                    return Hi(e4, n4, t4)
                                }(e3, n3, t3);
                            bi = (131072 & e3.flags) !== 0
                        }
                    else bi = !1, la && 1048576 & n3.flags && Kl(n3, Yl, n3.index);
                    switch (n3.lanes = 0, n3.tag) {
                        case 2:
                            var r3 = n3.type;
                            Vi(e3, n3), e3 = n3.pendingProps;
                            var l3 = Tl(n3, zl.current);
                            Pa(n3, t3), l3 = go(null, n3, r3, e3, l3, t3);
                            var o3 = vo();
                            return n3.flags |= 1, typeof l3 == "object" && l3 !== null && typeof l3.render == "function" && l3.$$typeof === void 0 ? (n3.tag = 1, n3.memoizedState = null, n3.updateQueue = null, jl(r3) ? (o3 = !0, Dl(n3)) : o3 = !1, n3.memoizedState = l3.state !== null && l3.state !== void 0 ? l3.state : null, Da(n3), l3.updater = li, n3.stateNode = l3, l3._reactInternals = n3, ui(n3, r3, e3, t3), n3 = zi(null, n3, r3, !0, o3, t3)) : (n3.tag = 0, la && o3 && ea(n3), wi(null, n3, l3, t3), n3 = n3.child), n3;
                        case 16:
                            r3 = n3.elementType;
                            e: {
                                switch (Vi(e3, n3), e3 = n3.pendingProps, r3 = (l3 = r3._init)(r3._payload), n3.type = r3, l3 = n3.tag = function(e4) {
                                        if (typeof e4 == "function") return js(e4) ? 1 : 0;
                                        if (e4 != null) {
                                            if ((e4 = e4.$$typeof) === z) return 11;
                                            if (e4 === T) return 14
                                        }
                                        return 2
                                    }(r3), e3 = ti(r3, e3), l3) {
                                    case 0:
                                        n3 = Ci(null, n3, r3, e3, t3);
                                        break e;
                                    case 1:
                                        n3 = _i(null, n3, r3, e3, t3);
                                        break e;
                                    case 11:
                                        n3 = ki(null, n3, r3, e3, t3);
                                        break e;
                                    case 14:
                                        n3 = Si(null, n3, r3, ti(r3.type, e3), t3);
                                        break e
                                }
                                throw Error(a2(306, r3, ""))
                            }
                            return n3;
                        case 0:
                            return r3 = n3.type, l3 = n3.pendingProps, Ci(e3, n3, r3, l3 = n3.elementType === r3 ? l3 : ti(r3, l3), t3);
                        case 1:
                            return r3 = n3.type, l3 = n3.pendingProps, _i(e3, n3, r3, l3 = n3.elementType === r3 ? l3 : ti(r3, l3), t3);
                        case 3:
                            e: {
                                if (Pi(n3), e3 === null) throw Error(a2(387));r3 = n3.pendingProps,
                                l3 = (o3 = n3.memoizedState).element,
                                Aa(e3, n3),
                                Wa(n3, r3, null, t3);
                                var i3 = n3.memoizedState;
                                if (r3 = i3.element, o3.isDehydrated) {
                                    if (o3 = {
                                            element: r3,
                                            isDehydrated: !1,
                                            cache: i3.cache,
                                            pendingSuspenseBoundaries: i3.pendingSuspenseBoundaries,
                                            transitions: i3.transitions
                                        }, n3.updateQueue.baseState = o3, n3.memoizedState = o3, 256 & n3.flags) {
                                        n3 = Li(e3, n3, r3, t3, l3 = si(Error(a2(423)), n3));
                                        break e
                                    }
                                    if (r3 !== l3) {
                                        n3 = Li(e3, n3, r3, t3, l3 = si(Error(a2(424)), n3));
                                        break e
                                    }
                                    for (ra = sl(n3.stateNode.containerInfo.firstChild), ta = n3, la = !0, aa = null, t3 = ka(n3, null, r3, t3), n3.child = t3; t3;) t3.flags = -3 & t3.flags | 4096, t3 = t3.sibling
                                } else {
                                    if (pa(), r3 === l3) {
                                        n3 = Hi(e3, n3, t3);
                                        break e
                                    }
                                    wi(e3, n3, r3, t3)
                                }
                                n3 = n3.child
                            }
                            return n3;
                        case 5:
                            return Ja(n3), e3 === null && sa(n3), r3 = n3.type, l3 = n3.pendingProps, o3 = e3 !== null ? e3.memoizedProps : null, i3 = l3.children, tl(r3, l3) ? i3 = null : o3 !== null && tl(r3, o3) && (n3.flags |= 32), Ni(e3, n3), wi(e3, n3, i3, t3), n3.child;
                        case 6:
                            return e3 === null && sa(n3), null;
                        case 13:
                            return Ai(e3, n3, t3);
                        case 4:
                            return Xa(n3, n3.stateNode.containerInfo), r3 = n3.pendingProps, e3 === null ? n3.child = wa(n3, null, r3, t3) : wi(e3, n3, r3, t3), n3.child;
                        case 11:
                            return r3 = n3.type, l3 = n3.pendingProps, ki(e3, n3, r3, l3 = n3.elementType === r3 ? l3 : ti(r3, l3), t3);
                        case 7:
                            return wi(e3, n3, n3.pendingProps, t3), n3.child;
                        case 8:
                        case 12:
                            return wi(e3, n3, n3.pendingProps.children, t3), n3.child;
                        case 10:
                            e: {
                                if (r3 = n3.type._context, l3 = n3.pendingProps, o3 = n3.memoizedProps, i3 = l3.value, Cl(Sa, r3._currentValue), r3._currentValue = i3, o3 !== null)
                                    if (ir(o3.value, i3)) {
                                        if (o3.children === l3.children && !Pl.current) {
                                            n3 = Hi(e3, n3, t3);
                                            break e
                                        }
                                    } else
                                        for ((o3 = n3.child) !== null && (o3.return = n3); o3 !== null;) {
                                            var u3 = o3.dependencies;
                                            if (u3 !== null) {
                                                i3 = o3.child;
                                                for (var s3 = u3.firstContext; s3 !== null;) {
                                                    if (s3.context === r3) {
                                                        if (o3.tag === 1) {
                                                            (s3 = Fa(-1, t3 & -t3)).tag = 2;
                                                            var c3 = o3.updateQueue;
                                                            if (c3 !== null) {
                                                                var d3 = (c3 = c3.shared).pending;
                                                                d3 === null ? s3.next = s3 : (s3.next = d3.next, d3.next = s3), c3.pending = s3
                                                            }
                                                        }
                                                        o3.lanes |= t3, (s3 = o3.alternate) !== null && (s3.lanes |= t3), za(o3.return, t3, n3), u3.lanes |= t3;
                                                        break
                                                    }
                                                    s3 = s3.next
                                                }
                                            } else if (o3.tag === 10) i3 = o3.type === n3.type ? null : o3.child;
                                            else if (o3.tag === 18) {
                                                if ((i3 = o3.return) === null) throw Error(a2(341));
                                                i3.lanes |= t3, (u3 = i3.alternate) !== null && (u3.lanes |= t3), za(i3, t3, n3), i3 = o3.sibling
                                            } else i3 = o3.child;
                                            if (i3 !== null) i3.return = o3;
                                            else
                                                for (i3 = o3; i3 !== null;) {
                                                    if (i3 === n3) {
                                                        i3 = null;
                                                        break
                                                    }
                                                    if ((o3 = i3.sibling) !== null) {
                                                        o3.return = i3.return, i3 = o3;
                                                        break
                                                    }
                                                    i3 = i3.return
                                                }
                                            o3 = i3
                                        }
                                wi(e3, n3, l3.children, t3),
                                n3 = n3.child
                            }
                            return n3;
                        case 9:
                            return l3 = n3.type, r3 = n3.pendingProps.children, Pa(n3, t3), r3 = r3(l3 = La(l3)), n3.flags |= 1, wi(e3, n3, r3, t3), n3.child;
                        case 14:
                            return l3 = ti(r3 = n3.type, n3.pendingProps), Si(e3, n3, r3, l3 = ti(r3.type, l3), t3);
                        case 15:
                            return xi(e3, n3, n3.type, n3.pendingProps, t3);
                        case 17:
                            return r3 = n3.type, l3 = n3.pendingProps, l3 = n3.elementType === r3 ? l3 : ti(r3, l3), Vi(e3, n3), n3.tag = 1, jl(r3) ? (e3 = !0, Dl(n3)) : e3 = !1, Pa(n3, t3), oi(n3, r3, l3), ui(n3, r3, l3, t3), zi(null, n3, r3, !0, e3, t3);
                        case 19:
                            return Wi(e3, n3, t3);
                        case 22:
                            return Ei(e3, n3, t3)
                    }
                    throw Error(a2(156, n3.tag))
                };
                var Gs = typeof reportError == "function" ? reportError : function(e3) {
                    console.error(e3)
                };

                function $s(e3) {
                    this._internalRoot = e3
                }

                function Xs(e3) {
                    this._internalRoot = e3
                }

                function Zs(e3) {
                    return !(!e3 || e3.nodeType !== 1 && e3.nodeType !== 9 && e3.nodeType !== 11)
                }

                function Js(e3) {
                    return !(!e3 || e3.nodeType !== 1 && e3.nodeType !== 9 && e3.nodeType !== 11 && (e3.nodeType !== 8 || e3.nodeValue !== " react-mount-point-unstable "))
                }

                function qs() {}

                function Ks(e3, n3, t3, r3, l3) {
                    var a3 = t3._reactRootContainer;
                    if (a3) {
                        var o3 = a3;
                        if (typeof l3 == "function") {
                            var i3 = l3;
                            l3 = function() {
                                var e4 = Hs(o3);
                                i3.call(e4)
                            }
                        }
                        Vs(n3, o3, e3, l3)
                    } else o3 = function(e4, n4, t4, r4, l4) {
                        if (l4) {
                            if (typeof r4 == "function") {
                                var a4 = r4;
                                r4 = function() {
                                    var e5 = Hs(o4);
                                    a4.call(e5)
                                }
                            }
                            var o4 = Ws(n4, r4, e4, 0, null, !1, 0, "", qs);
                            return e4._reactRootContainer = o4, e4[hl] = o4.current, Wr(e4.nodeType === 8 ? e4.parentNode : e4), cs(), o4
                        }
                        for (; l4 = e4.lastChild;) e4.removeChild(l4);
                        if (typeof r4 == "function") {
                            var i4 = r4;
                            r4 = function() {
                                var e5 = Hs(u3);
                                i4.call(e5)
                            }
                        }
                        var u3 = Us(e4, 0, !1, null, 0, !1, 0, "", qs);
                        return e4._reactRootContainer = u3, e4[hl] = u3.current, Wr(e4.nodeType === 8 ? e4.parentNode : e4), cs(function() {
                            Vs(n4, u3, t4, r4)
                        }), u3
                    }(t3, n3, e3, l3, r3);
                    return Hs(o3)
                }
                Xs.prototype.render = $s.prototype.render = function(e3) {
                    var n3 = this._internalRoot;
                    if (n3 === null) throw Error(a2(409));
                    Vs(e3, n3, null, null)
                }, Xs.prototype.unmount = $s.prototype.unmount = function() {
                    var e3 = this._internalRoot;
                    if (e3 !== null) {
                        this._internalRoot = null;
                        var n3 = e3.containerInfo;
                        cs(function() {
                            Vs(null, e3, null, null)
                        }), n3[hl] = null
                    }
                }, Xs.prototype.unstable_scheduleHydration = function(e3) {
                    if (e3) {
                        var n3 = Nn();
                        e3 = {
                            blockedOn: null,
                            target: e3,
                            priority: n3
                        };
                        for (var t3 = 0; t3 < Mn.length && n3 !== 0 && n3 < Mn[t3].priority; t3++);
                        Mn.splice(t3, 0, e3), t3 === 0 && Fn(e3)
                    }
                }, Sn = function(e3) {
                    switch (e3.tag) {
                        case 3:
                            var n3 = e3.stateNode;
                            if (n3.current.memoizedState.isDehydrated) {
                                var t3 = fn(n3.pendingLanes);
                                t3 !== 0 && (bn(n3, 1 | t3), rs(n3, Je()), !(6 & zu) && (Wu = Je() + 500, Wl()))
                            }
                            break;
                        case 13:
                            cs(function() {
                                var n4 = Ma(e3, 1);
                                if (n4 !== null) {
                                    var t4 = es();
                                    ts(n4, e3, 1, t4)
                                }
                            }), Ys(e3, 1)
                    }
                }, xn = function(e3) {
                    if (e3.tag === 13) {
                        var n3 = Ma(e3, 134217728);
                        n3 !== null && ts(n3, e3, 134217728, es()), Ys(e3, 134217728)
                    }
                }, En = function(e3) {
                    if (e3.tag === 13) {
                        var n3 = ns(e3),
                            t3 = Ma(e3, n3);
                        t3 !== null && ts(t3, e3, n3, es()), Ys(e3, n3)
                    }
                }, Nn = function() {
                    return wn
                }, Cn = function(e3, n3) {
                    var t3 = wn;
                    try {
                        return wn = e3, n3()
                    } finally {
                        wn = t3
                    }
                }, Se = function(e3, n3, t3) {
                    switch (n3) {
                        case "input":
                            if (q(e3, t3), n3 = t3.name, t3.type === "radio" && n3 != null) {
                                for (t3 = e3; t3.parentNode;) t3 = t3.parentNode;
                                for (t3 = t3.querySelectorAll("input[name=" + JSON.stringify("" + n3) + '][type="radio"]'), n3 = 0; n3 < t3.length; n3++) {
                                    var r3 = t3[n3];
                                    if (r3 !== e3 && r3.form === e3.form) {
                                        var l3 = kl(r3);
                                        if (!l3) throw Error(a2(90));
                                        G(r3), q(r3, l3)
                                    }
                                }
                            }
                            break;
                        case "textarea":
                            ae(e3, t3);
                            break;
                        case "select":
                            (n3 = t3.value) != null && te(e3, !!t3.multiple, n3, !1)
                    }
                }, ze = ss, Pe = cs;
                var ec = {
                        usingClientEntryPoint: !1,
                        Events: [bl, wl, kl, Ce, _e, ss]
                    },
                    nc = {
                        findFiberByHostInstance: yl,
                        bundleType: 0,
                        version: "18.3.1",
                        rendererPackageName: "react-dom"
                    },
                    tc = {
                        bundleType: nc.bundleType,
                        version: nc.version,
                        rendererPackageName: nc.rendererPackageName,
                        rendererConfig: nc.rendererConfig,
                        overrideHookState: null,
                        overrideHookStateDeletePath: null,
                        overrideHookStateRenamePath: null,
                        overrideProps: null,
                        overridePropsDeletePath: null,
                        overridePropsRenamePath: null,
                        setErrorHandler: null,
                        setSuspenseHandler: null,
                        scheduleUpdate: null,
                        currentDispatcherRef: w.ReactCurrentDispatcher,
                        findHostInstanceByFiber: function(e3) {
                            return (e3 = Qe(e3)) === null ? null : e3.stateNode
                        },
                        findFiberByHostInstance: nc.findFiberByHostInstance || function() {
                            return null
                        },
                        findHostInstancesForRefresh: null,
                        scheduleRefresh: null,
                        scheduleRoot: null,
                        setRefreshHandler: null,
                        getCurrentFiber: null,
                        reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
                    };
                if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
                    var rc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                    if (!rc.isDisabled && rc.supportsFiber) try {
                        ln = rc.inject(tc), an = rc
                    } catch {}
                }
                n2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ec, n2.createPortal = function(e3, n3) {
                    var t3 = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
                    if (!Zs(n3)) throw Error(a2(200));
                    return function(e4, n4, t4) {
                        var r3 = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
                        return {
                            $$typeof: S,
                            key: r3 == null ? null : "" + r3,
                            children: e4,
                            containerInfo: n4,
                            implementation: t4
                        }
                    }(e3, n3, null, t3)
                }, n2.createRoot = function(e3, n3) {
                    if (!Zs(e3)) throw Error(a2(299));
                    var t3 = !1,
                        r3 = "",
                        l3 = Gs;
                    return n3 != null && (n3.unstable_strictMode === !0 && (t3 = !0), n3.identifierPrefix !== void 0 && (r3 = n3.identifierPrefix), n3.onRecoverableError !== void 0 && (l3 = n3.onRecoverableError)), n3 = Us(e3, 1, !1, null, 0, t3, 0, r3, l3), e3[hl] = n3.current, Wr(e3.nodeType === 8 ? e3.parentNode : e3), new $s(n3)
                }, n2.findDOMNode = function(e3) {
                    if (e3 == null) return null;
                    if (e3.nodeType === 1) return e3;
                    var n3 = e3._reactInternals;
                    if (n3 === void 0) throw typeof e3.render == "function" ? Error(a2(188)) : (e3 = Object.keys(e3).join(","), Error(a2(268, e3)));
                    return e3 = (e3 = Qe(n3)) === null ? null : e3.stateNode
                }, n2.flushSync = function(e3) {
                    return cs(e3)
                }, n2.hydrate = function(e3, n3, t3) {
                    if (!Js(n3)) throw Error(a2(200));
                    return Ks(null, e3, n3, !0, t3)
                }, n2.hydrateRoot = function(e3, n3, t3) {
                    if (!Zs(e3)) throw Error(a2(405));
                    var r3 = t3 != null && t3.hydratedSources || null,
                        l3 = !1,
                        o3 = "",
                        i3 = Gs;
                    if (t3 != null && (t3.unstable_strictMode === !0 && (l3 = !0), t3.identifierPrefix !== void 0 && (o3 = t3.identifierPrefix), t3.onRecoverableError !== void 0 && (i3 = t3.onRecoverableError)), n3 = Ws(n3, null, e3, 1, t3 ?? null, l3, 0, o3, i3), e3[hl] = n3.current, Wr(e3), r3)
                        for (e3 = 0; e3 < r3.length; e3++) l3 = (l3 = (t3 = r3[e3])._getVersion)(t3._source), n3.mutableSourceEagerHydrationData == null ? n3.mutableSourceEagerHydrationData = [t3, l3] : n3.mutableSourceEagerHydrationData.push(t3, l3);
                    return new Xs(n3)
                }, n2.render = function(e3, n3, t3) {
                    if (!Js(n3)) throw Error(a2(200));
                    return Ks(null, e3, n3, !1, t3)
                }, n2.unmountComponentAtNode = function(e3) {
                    if (!Js(e3)) throw Error(a2(40));
                    return !!e3._reactRootContainer && (cs(function() {
                        Ks(null, null, e3, !1, function() {
                            e3._reactRootContainer = null, e3[hl] = null
                        })
                    }), !0)
                }, n2.unstable_batchedUpdates = ss, n2.unstable_renderSubtreeIntoContainer = function(e3, n3, t3, r3) {
                    if (!Js(t3)) throw Error(a2(200));
                    if (e3 == null || e3._reactInternals === void 0) throw Error(a2(38));
                    return Ks(e3, n3, t3, !1, r3)
                }, n2.version = "18.3.1-next-f1338f8080-20240426"
            },
            391: (e2, n2, t2) => {
                var r2 = t2(950);
                n2.createRoot = r2.createRoot, n2.hydrateRoot = r2.hydrateRoot
            },
            950: (e2, n2, t2) => {
                (function e3() {
                    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE == "function") try {
                        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e3)
                    } catch (n3) {
                        console.error(n3)
                    }
                })(), e2.exports = t2(730)
            },
            153: (e2, n2, t2) => {
                var r2 = t2(43),
                    l2 = Symbol.for("react.element"),
                    a2 = Symbol.for("react.fragment"),
                    o2 = Object.prototype.hasOwnProperty,
                    i2 = r2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
                    u2 = {
                        key: !0,
                        ref: !0,
                        __self: !0,
                        __source: !0
                    };

                function s2(e3, n3, t3) {
                    var r3, a3 = {},
                        s3 = null,
                        c2 = null;
                    for (r3 in t3 !== void 0 && (s3 = "" + t3), n3.key !== void 0 && (s3 = "" + n3.key), n3.ref !== void 0 && (c2 = n3.ref), n3) o2.call(n3, r3) && !u2.hasOwnProperty(r3) && (a3[r3] = n3[r3]);
                    if (e3 && e3.defaultProps)
                        for (r3 in n3 = e3.defaultProps) a3[r3] === void 0 && (a3[r3] = n3[r3]);
                    return {
                        $$typeof: l2,
                        type: e3,
                        key: s3,
                        ref: c2,
                        props: a3,
                        _owner: i2.current
                    }
                }
                n2.Fragment = a2, n2.jsx = s2, n2.jsxs = s2
            },
            202: (e2, n2) => {
                var t2 = Symbol.for("react.element"),
                    r2 = Symbol.for("react.portal"),
                    l2 = Symbol.for("react.fragment"),
                    a2 = Symbol.for("react.strict_mode"),
                    o2 = Symbol.for("react.profiler"),
                    i2 = Symbol.for("react.provider"),
                    u2 = Symbol.for("react.context"),
                    s2 = Symbol.for("react.forward_ref"),
                    c2 = Symbol.for("react.suspense"),
                    d2 = Symbol.for("react.memo"),
                    f = Symbol.for("react.lazy"),
                    p = Symbol.iterator,
                    h = {
                        isMounted: function() {
                            return !1
                        },
                        enqueueForceUpdate: function() {},
                        enqueueReplaceState: function() {},
                        enqueueSetState: function() {}
                    },
                    m = Object.assign,
                    g = {};

                function v(e3, n3, t3) {
                    this.props = e3, this.context = n3, this.refs = g, this.updater = t3 || h
                }

                function y() {}

                function b(e3, n3, t3) {
                    this.props = e3, this.context = n3, this.refs = g, this.updater = t3 || h
                }
                v.prototype.isReactComponent = {}, v.prototype.setState = function(e3, n3) {
                    if (typeof e3 != "object" && typeof e3 != "function" && e3 != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
                    this.updater.enqueueSetState(this, e3, n3, "setState")
                }, v.prototype.forceUpdate = function(e3) {
                    this.updater.enqueueForceUpdate(this, e3, "forceUpdate")
                }, y.prototype = v.prototype;
                var w = b.prototype = new y;
                w.constructor = b, m(w, v.prototype), w.isPureReactComponent = !0;
                var k = Array.isArray,
                    S = Object.prototype.hasOwnProperty,
                    x = {
                        current: null
                    },
                    E = {
                        key: !0,
                        ref: !0,
                        __self: !0,
                        __source: !0
                    };

                function N(e3, n3, r3) {
                    var l3, a3 = {},
                        o3 = null,
                        i3 = null;
                    if (n3 != null)
                        for (l3 in n3.ref !== void 0 && (i3 = n3.ref), n3.key !== void 0 && (o3 = "" + n3.key), n3) S.call(n3, l3) && !E.hasOwnProperty(l3) && (a3[l3] = n3[l3]);
                    var u3 = arguments.length - 2;
                    if (u3 === 1) a3.children = r3;
                    else if (1 < u3) {
                        for (var s3 = Array(u3), c3 = 0; c3 < u3; c3++) s3[c3] = arguments[c3 + 2];
                        a3.children = s3
                    }
                    if (e3 && e3.defaultProps)
                        for (l3 in u3 = e3.defaultProps) a3[l3] === void 0 && (a3[l3] = u3[l3]);
                    return {
                        $$typeof: t2,
                        type: e3,
                        key: o3,
                        ref: i3,
                        props: a3,
                        _owner: x.current
                    }
                }

                function C(e3) {
                    return typeof e3 == "object" && e3 !== null && e3.$$typeof === t2
                }
                var _ = /\/+/g;

                function z(e3, n3) {
                    return typeof e3 == "object" && e3 !== null && e3.key != null ? function(e4) {
                        var n4 = {
                            "=": "=0",
                            ":": "=2"
                        };
                        return "$" + e4.replace(/[=:]/g, function(e5) {
                            return n4[e5]
                        })
                    }("" + e3.key) : n3.toString(36)
                }

                function P(e3, n3, l3, a3, o3) {
                    var i3 = typeof e3;
                    i3 !== "undefined" && i3 !== "boolean" || (e3 = null);
                    var u3 = !1;
                    if (e3 === null) u3 = !0;
                    else switch (i3) {
                        case "string":
                        case "number":
                            u3 = !0;
                            break;
                        case "object":
                            switch (e3.$$typeof) {
                                case t2:
                                case r2:
                                    u3 = !0
                            }
                    }
                    if (u3) return o3 = o3(u3 = e3), e3 = a3 === "" ? "." + z(u3, 0) : a3, k(o3) ? (l3 = "", e3 != null && (l3 = e3.replace(_, "$&/") + "/"), P(o3, n3, l3, "", function(e4) {
                        return e4
                    })) : o3 != null && (C(o3) && (o3 = function(e4, n4) {
                        return {
                            $$typeof: t2,
                            type: e4.type,
                            key: n4,
                            ref: e4.ref,
                            props: e4.props,
                            _owner: e4._owner
                        }
                    }(o3, l3 + (!o3.key || u3 && u3.key === o3.key ? "" : ("" + o3.key).replace(_, "$&/") + "/") + e3)), n3.push(o3)), 1;
                    if (u3 = 0, a3 = a3 === "" ? "." : a3 + ":", k(e3))
                        for (var s3 = 0; s3 < e3.length; s3++) {
                            var c3 = a3 + z(i3 = e3[s3], s3);
                            u3 += P(i3, n3, l3, c3, o3)
                        } else if (c3 = function(e4) {
                                return e4 === null || typeof e4 != "object" ? null : typeof(e4 = p && e4[p] || e4["@@iterator"]) == "function" ? e4 : null
                            }(e3), typeof c3 == "function")
                            for (e3 = c3.call(e3), s3 = 0; !(i3 = e3.next()).done;) u3 += P(i3 = i3.value, n3, l3, c3 = a3 + z(i3, s3++), o3);
                        else if (i3 === "object") throw n3 = String(e3), Error("Objects are not valid as a React child (found: " + (n3 === "[object Object]" ? "object with keys {" + Object.keys(e3).join(", ") + "}" : n3) + "). If you meant to render a collection of children, use an array instead.");
                    return u3
                }

                function L(e3, n3, t3) {
                    if (e3 == null) return e3;
                    var r3 = [],
                        l3 = 0;
                    return P(e3, r3, "", "", function(e4) {
                        return n3.call(t3, e4, l3++)
                    }), r3
                }

                function T(e3) {
                    if (e3._status === -1) {
                        var n3 = e3._result;
                        (n3 = n3()).then(function(n4) {
                            e3._status !== 0 && e3._status !== -1 || (e3._status = 1, e3._result = n4)
                        }, function(n4) {
                            e3._status !== 0 && e3._status !== -1 || (e3._status = 2, e3._result = n4)
                        }), e3._status === -1 && (e3._status = 0, e3._result = n3)
                    }
                    if (e3._status === 1) return e3._result.default;
                    throw e3._result
                }
                var j = {
                        current: null
                    },
                    R = {
                        transition: null
                    },
                    M = {
                        ReactCurrentDispatcher: j,
                        ReactCurrentBatchConfig: R,
                        ReactCurrentOwner: x
                    };

                function I() {
                    throw Error("act(...) is not supported in production builds of React.")
                }
                n2.Children = {
                    map: L,
                    forEach: function(e3, n3, t3) {
                        L(e3, function() {
                            n3.apply(this, arguments)
                        }, t3)
                    },
                    count: function(e3) {
                        var n3 = 0;
                        return L(e3, function() {
                            n3++
                        }), n3
                    },
                    toArray: function(e3) {
                        return L(e3, function(e4) {
                            return e4
                        }) || []
                    },
                    only: function(e3) {
                        if (!C(e3)) throw Error("React.Children.only expected to receive a single React element child.");
                        return e3
                    }
                }, n2.Component = v, n2.Fragment = l2, n2.Profiler = o2, n2.PureComponent = b, n2.StrictMode = a2, n2.Suspense = c2, n2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = M, n2.act = I, n2.cloneElement = function(e3, n3, r3) {
                    if (e3 == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e3 + ".");
                    var l3 = m({}, e3.props),
                        a3 = e3.key,
                        o3 = e3.ref,
                        i3 = e3._owner;
                    if (n3 != null) {
                        if (n3.ref !== void 0 && (o3 = n3.ref, i3 = x.current), n3.key !== void 0 && (a3 = "" + n3.key), e3.type && e3.type.defaultProps) var u3 = e3.type.defaultProps;
                        for (s3 in n3) S.call(n3, s3) && !E.hasOwnProperty(s3) && (l3[s3] = n3[s3] === void 0 && u3 !== void 0 ? u3[s3] : n3[s3])
                    }
                    var s3 = arguments.length - 2;
                    if (s3 === 1) l3.children = r3;
                    else if (1 < s3) {
                        u3 = Array(s3);
                        for (var c3 = 0; c3 < s3; c3++) u3[c3] = arguments[c3 + 2];
                        l3.children = u3
                    }
                    return {
                        $$typeof: t2,
                        type: e3.type,
                        key: a3,
                        ref: o3,
                        props: l3,
                        _owner: i3
                    }
                }, n2.createContext = function(e3) {
                    return (e3 = {
                        $$typeof: u2,
                        _currentValue: e3,
                        _currentValue2: e3,
                        _threadCount: 0,
                        Provider: null,
                        Consumer: null,
                        _defaultValue: null,
                        _globalName: null
                    }).Provider = {
                        $$typeof: i2,
                        _context: e3
                    }, e3.Consumer = e3
                }, n2.createElement = N, n2.createFactory = function(e3) {
                    var n3 = N.bind(null, e3);
                    return n3.type = e3, n3
                }, n2.createRef = function() {
                    return {
                        current: null
                    }
                }, n2.forwardRef = function(e3) {
                    return {
                        $$typeof: s2,
                        render: e3
                    }
                }, n2.isValidElement = C, n2.lazy = function(e3) {
                    return {
                        $$typeof: f,
                        _payload: {
                            _status: -1,
                            _result: e3
                        },
                        _init: T
                    }
                }, n2.memo = function(e3, n3) {
                    return {
                        $$typeof: d2,
                        type: e3,
                        compare: n3 === void 0 ? null : n3
                    }
                }, n2.startTransition = function(e3) {
                    var n3 = R.transition;
                    R.transition = {};
                    try {
                        e3()
                    } finally {
                        R.transition = n3
                    }
                }, n2.unstable_act = I, n2.useCallback = function(e3, n3) {
                    return j.current.useCallback(e3, n3)
                }, n2.useContext = function(e3) {
                    return j.current.useContext(e3)
                }, n2.useDebugValue = function() {}, n2.useDeferredValue = function(e3) {
                    return j.current.useDeferredValue(e3)
                }, n2.useEffect = function(e3, n3) {
                    return j.current.useEffect(e3, n3)
                }, n2.useId = function() {
                    return j.current.useId()
                }, n2.useImperativeHandle = function(e3, n3, t3) {
                    return j.current.useImperativeHandle(e3, n3, t3)
                }, n2.useInsertionEffect = function(e3, n3) {
                    return j.current.useInsertionEffect(e3, n3)
                }, n2.useLayoutEffect = function(e3, n3) {
                    return j.current.useLayoutEffect(e3, n3)
                }, n2.useMemo = function(e3, n3) {
                    return j.current.useMemo(e3, n3)
                }, n2.useReducer = function(e3, n3, t3) {
                    return j.current.useReducer(e3, n3, t3)
                }, n2.useRef = function(e3) {
                    return j.current.useRef(e3)
                }, n2.useState = function(e3) {
                    return j.current.useState(e3)
                }, n2.useSyncExternalStore = function(e3, n3, t3) {
                    return j.current.useSyncExternalStore(e3, n3, t3)
                }, n2.useTransition = function() {
                    return j.current.useTransition()
                }, n2.version = "18.3.1"
            },
            43: (e2, n2, t2) => {
                e2.exports = t2(202)
            },
            579: (e2, n2, t2) => {
                e2.exports = t2(153)
            },
            234: (e2, n2) => {
                function t2(e3, n3) {
                    var t3 = e3.length;
                    e3.push(n3);
                    e: for (; 0 < t3;) {
                        var r3 = t3 - 1 >>> 1,
                            l3 = e3[r3];
                        if (!(0 < a2(l3, n3))) break e;
                        e3[r3] = n3, e3[t3] = l3, t3 = r3
                    }
                }

                function r2(e3) {
                    return e3.length === 0 ? null : e3[0]
                }

                function l2(e3) {
                    if (e3.length === 0) return null;
                    var n3 = e3[0],
                        t3 = e3.pop();
                    if (t3 !== n3) {
                        e3[0] = t3;
                        e: for (var r3 = 0, l3 = e3.length, o3 = l3 >>> 1; r3 < o3;) {
                            var i3 = 2 * (r3 + 1) - 1,
                                u3 = e3[i3],
                                s3 = i3 + 1,
                                c3 = e3[s3];
                            if (0 > a2(u3, t3)) s3 < l3 && 0 > a2(c3, u3) ? (e3[r3] = c3, e3[s3] = t3, r3 = s3) : (e3[r3] = u3, e3[i3] = t3, r3 = i3);
                            else {
                                if (!(s3 < l3 && 0 > a2(c3, t3))) break e;
                                e3[r3] = c3, e3[s3] = t3, r3 = s3
                            }
                        }
                    }
                    return n3
                }

                function a2(e3, n3) {
                    var t3 = e3.sortIndex - n3.sortIndex;
                    return t3 !== 0 ? t3 : e3.id - n3.id
                }
                if (typeof performance == "object" && typeof performance.now == "function") {
                    var o2 = performance;
                    n2.unstable_now = function() {
                        return o2.now()
                    }
                } else {
                    var i2 = Date,
                        u2 = i2.now();
                    n2.unstable_now = function() {
                        return i2.now() - u2
                    }
                }
                var s2 = [],
                    c2 = [],
                    d2 = 1,
                    f = null,
                    p = 3,
                    h = !1,
                    m = !1,
                    g = !1,
                    v = typeof setTimeout == "function" ? setTimeout : null,
                    y = typeof clearTimeout == "function" ? clearTimeout : null,
                    b = typeof setImmediate < "u" ? setImmediate : null;

                function w(e3) {
                    for (var n3 = r2(c2); n3 !== null;) {
                        if (n3.callback === null) l2(c2);
                        else {
                            if (!(n3.startTime <= e3)) break;
                            l2(c2), n3.sortIndex = n3.expirationTime, t2(s2, n3)
                        }
                        n3 = r2(c2)
                    }
                }

                function k(e3) {
                    if (g = !1, w(e3), !m)
                        if (r2(s2) !== null) m = !0, R(S);
                        else {
                            var n3 = r2(c2);
                            n3 !== null && M(k, n3.startTime - e3)
                        }
                }

                function S(e3, t3) {
                    m = !1, g && (g = !1, y(C), C = -1), h = !0;
                    var a3 = p;
                    try {
                        for (w(t3), f = r2(s2); f !== null && (!(f.expirationTime > t3) || e3 && !P());) {
                            var o3 = f.callback;
                            if (typeof o3 == "function") {
                                f.callback = null, p = f.priorityLevel;
                                var i3 = o3(f.expirationTime <= t3);
                                t3 = n2.unstable_now(), typeof i3 == "function" ? f.callback = i3 : f === r2(s2) && l2(s2), w(t3)
                            } else l2(s2);
                            f = r2(s2)
                        }
                        if (f !== null) var u3 = !0;
                        else {
                            var d3 = r2(c2);
                            d3 !== null && M(k, d3.startTime - t3), u3 = !1
                        }
                        return u3
                    } finally {
                        f = null, p = a3, h = !1
                    }
                }
                typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
                var x, E = !1,
                    N = null,
                    C = -1,
                    _ = 5,
                    z = -1;

                function P() {
                    return !(n2.unstable_now() - z < _)
                }

                function L() {
                    if (N !== null) {
                        var e3 = n2.unstable_now();
                        z = e3;
                        var t3 = !0;
                        try {
                            t3 = N(!0, e3)
                        } finally {
                            t3 ? x() : (E = !1, N = null)
                        }
                    } else E = !1
                }
                if (typeof b == "function") x = function() {
                    b(L)
                };
                else if (typeof MessageChannel < "u") {
                    var T = new MessageChannel,
                        j = T.port2;
                    T.port1.onmessage = L, x = function() {
                        j.postMessage(null)
                    }
                } else x = function() {
                    v(L, 0)
                };

                function R(e3) {
                    N = e3, E || (E = !0, x())
                }

                function M(e3, t3) {
                    C = v(function() {
                        e3(n2.unstable_now())
                    }, t3)
                }
                n2.unstable_IdlePriority = 5, n2.unstable_ImmediatePriority = 1, n2.unstable_LowPriority = 4, n2.unstable_NormalPriority = 3, n2.unstable_Profiling = null, n2.unstable_UserBlockingPriority = 2, n2.unstable_cancelCallback = function(e3) {
                    e3.callback = null
                }, n2.unstable_continueExecution = function() {
                    m || h || (m = !0, R(S))
                }, n2.unstable_forceFrameRate = function(e3) {
                    0 > e3 || 125 < e3 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : _ = 0 < e3 ? Math.floor(1e3 / e3) : 5
                }, n2.unstable_getCurrentPriorityLevel = function() {
                    return p
                }, n2.unstable_getFirstCallbackNode = function() {
                    return r2(s2)
                }, n2.unstable_next = function(e3) {
                    switch (p) {
                        case 1:
                        case 2:
                        case 3:
                            var n3 = 3;
                            break;
                        default:
                            n3 = p
                    }
                    var t3 = p;
                    p = n3;
                    try {
                        return e3()
                    } finally {
                        p = t3
                    }
                }, n2.unstable_pauseExecution = function() {}, n2.unstable_requestPaint = function() {}, n2.unstable_runWithPriority = function(e3, n3) {
                    switch (e3) {
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        default:
                            e3 = 3
                    }
                    var t3 = p;
                    p = e3;
                    try {
                        return n3()
                    } finally {
                        p = t3
                    }
                }, n2.unstable_scheduleCallback = function(e3, l3, a3) {
                    var o3 = n2.unstable_now();
                    switch (typeof a3 == "object" && a3 !== null ? a3 = typeof(a3 = a3.delay) == "number" && 0 < a3 ? o3 + a3 : o3 : a3 = o3, e3) {
                        case 1:
                            var i3 = -1;
                            break;
                        case 2:
                            i3 = 250;
                            break;
                        case 5:
                            i3 = 1073741823;
                            break;
                        case 4:
                            i3 = 1e4;
                            break;
                        default:
                            i3 = 5e3
                    }
                    return e3 = {
                        id: d2++,
                        callback: l3,
                        priorityLevel: e3,
                        startTime: a3,
                        expirationTime: i3 = a3 + i3,
                        sortIndex: -1
                    }, a3 > o3 ? (e3.sortIndex = a3, t2(c2, e3), r2(s2) === null && e3 === r2(c2) && (g ? (y(C), C = -1) : g = !0, M(k, a3 - o3))) : (e3.sortIndex = i3, t2(s2, e3), m || h || (m = !0, R(S))), e3
                }, n2.unstable_shouldYield = P, n2.unstable_wrapCallback = function(e3) {
                    var n3 = p;
                    return function() {
                        var t3 = p;
                        p = n3;
                        try {
                            return e3.apply(this, arguments)
                        } finally {
                            p = t3
                        }
                    }
                }
            },
            853: (e2, n2, t2) => {
                e2.exports = t2(234)
            }
        },
        n = {};

    let selectedProductId = null;
    let selectedProductIndex = 0;
    const descriptions = {
        0: "Nécessite de la colle pour papier peint épais. Facile à poser, indéchirable, facile à décoller, résistant à l'humidité. Se pose sur mur lisse, propre et blanc uni.",
        1: "Rapide et facile à installer, sans matériel supplémentaire. Pose sans colle grâce à un adhésif intégré. Lavable, résistant à l’humidité. Facile à retirer et à repositionner. Idéal pour les locataires ou les changements fréquents.",
        2: "La qualité supérieure pour un rendu haut de gamme. Texture épaisse et finition mate ou satinée. Très résistant : anti-déchirure, anti-rayures, et lavable. Convient aux pièces humides (cuisines, salles de bain). Pose facile avec colle pour papier peint (non incluse)."
      };
  
    function t(r2) {
        var l2 = n[r2];
        if (l2 !== void 0) return l2.exports;
        var a2 = n[r2] = {
            exports: {}
        };
        return e[r2](a2, a2.exports, t), a2.exports
    }
    t.m = e, t.d = (e2, n2) => {
        for (var r2 in n2) t.o(n2, r2) && !t.o(e2, r2) && Object.defineProperty(e2, r2, {
            enumerable: !0,
            get: n2[r2]
        })
    }, t.f = {}, t.e = e2 => Promise.all(Object.keys(t.f).reduce((n2, r2) => (t.f[r2](e2, n2), n2), [])), t.u = e2 => "static/js/" + e2 + ".90b67e2c.chunk.js", t.miniCssF = e2 => {}, t.o = (e2, n2) => Object.prototype.hasOwnProperty.call(e2, n2), (() => {
        var e2 = {},
            n2 = "wallpaper-review:";
        t.l = (r2, l2, a2, o2) => {
            if (e2[r2]) e2[r2].push(l2);
            else {
                var i2, u2;
                if (a2 !== void 0)
                    for (var s2 = document.getElementsByTagName("script"), c2 = 0; c2 < s2.length; c2++) {
                        var d2 = s2[c2];
                        if (d2.getAttribute("src") == r2 || d2.getAttribute("data-webpack") == n2 + a2) {
                            i2 = d2;
                            break
                        }
                    }
                i2 || (u2 = !0, (i2 = document.createElement("script")).charset = "utf-8", i2.timeout = 120, t.nc && i2.setAttribute("nonce", t.nc), i2.setAttribute("data-webpack", n2 + a2), i2.src = r2), e2[r2] = [l2];
                var f = (n3, t2) => {
                        i2.onerror = i2.onload = null, clearTimeout(p);
                        var l3 = e2[r2];
                        if (delete e2[r2], i2.parentNode && i2.parentNode.removeChild(i2), l3 && l3.forEach(e3 => e3(t2)), n3) return n3(t2)
                    },
                    p = setTimeout(f.bind(null, void 0, {
                        type: "timeout",
                        target: i2
                    }), 12e4);
                i2.onerror = f.bind(null, i2.onerror), i2.onload = f.bind(null, i2.onload), u2 && document.head.appendChild(i2)
            }
        }
    })(), t.r = e2 => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e2, "__esModule", {
            value: !0
        })
    }, t.p = "/", (() => {
        var e2 = {
            792: 0
        };
        t.f.j = (n3, r3) => {
            var l2 = t.o(e2, n3) ? e2[n3] : void 0;
            if (l2 !== 0)
                if (l2) r3.push(l2[2]);
                else {
                    var a2 = new Promise((t2, r4) => l2 = e2[n3] = [t2, r4]);
                    r3.push(l2[2] = a2);
                    var o2 = t.p + t.u(n3),
                        i2 = new Error;
                    t.l(o2, r4 => {
                        if (t.o(e2, n3) && ((l2 = e2[n3]) !== 0 && (e2[n3] = void 0), l2)) {
                            var a3 = r4 && (r4.type === "load" ? "missing" : r4.type),
                                o3 = r4 && r4.target && r4.target.src;
                            i2.message = "Loading chunk " + n3 + ` failed.
(` + a3 + ": " + o3 + ")", i2.name = "ChunkLoadError", i2.type = a3, i2.request = o3, l2[1](i2)
                        }
                    }, "chunk-" + n3, n3)
                }
        };
        var n2 = (n3, r3) => {
                var l2, a2, o2 = r3[0],
                    i2 = r3[1],
                    u2 = r3[2],
                    s2 = 0;
                if (o2.some(n4 => e2[n4] !== 0)) {
                    for (l2 in i2) t.o(i2, l2) && (t.m[l2] = i2[l2]);
                    u2 && u2(t)
                }
                for (n3 && n3(r3); s2 < o2.length; s2++) a2 = o2[s2], t.o(e2, a2) && e2[a2] && e2[a2][0](), e2[a2] = 0
            },
            r2 = self.webpackChunkwallpaper_review = self.webpackChunkwallpaper_review || [];
        r2.forEach(n2.bind(null, 0)), r2.push = n2.bind(null, r2.push.bind(r2))
    })(), t.d({}, {
        B: () => d
    });
    var r = t(43),
        l = t(391),
        a = t(579);
    const o = e2 => {
            let {
                length: n2,
                productImage: t2,
                height: l2,
                screenWidth: o2,
                setDrag: i2,
                isDrag: u2,
                onSaveCroppedImage: s2,
                showWallpaper: c2
            } = e2;
            const d2 = (0, r.useRef)(null),
                f = (0, r.useRef)(null);
            let p, h, m = [0, 400, 400, 0],
                g = !1;
            const [v, y] = (0, r.useState)(!1), [b, w] = (0, r.useState)(100), [k, S] = (0, r.useState)(100), x = () => {
                m = o2 > 120 ? Number(n2) === Number(l2) ? [0, 400, 420, 0] : Number(n2) > Number(l2) ? Number(l2) > 300 ? [0, 1e3, 300, 0] : [0, 1e3, Number(l2), 0] : Number(n2) > 400 ? [0, 400, 533, 0] : [0, Number(n2), 533, 0] : Number(n2) === Number(l2) ? [0, 300, 440, 0] : Number(n2) > Number(l2) ? Number(l2) > 300 ? [0, 1e3, 300, 0] : [0, 1e3, Number(l2), 0] : Number(n2) > 300 ? [0, 300, 440, 0] : [0, Number(n2), 440, 0]
            };

            function E(e3, n3) {
                let t3 = n3.map(function(e4) {
                    return e4 + "px "
                });
                e3.style.clip = "rect(" + t3 + ")"
            }

            function N(e3, n3, t3, r2, l3) {
                const a2 = d2.current;
                a2 && (m[1] = Math.max(Math.min(m[1] + n3, a2.offsetWidth), r2), m[3] = Math.max(Math.min(m[3] + n3, a2.offsetWidth - r2), 0), E(e3, m), s2(a2, l3, m, 0, 3, 1, 2, !0))
            }

            function C(e3, n3, t3, r2, l3) {
                const a2 = d2.current;
                a2 && (m[0] = Math.max(Math.min(m[0] + n3, a2.offsetHeight - r2), 0), m[2] = Math.max(Math.min(m[2] + n3, a2.offsetHeight), r2), E(e3, m), s2(a2, l3, m, 0, 3, 1, 2, !1))
            }
            return (0, r.useEffect)(() => {
                const e3 = document.getElementById("crop"),
                    t3 = () => {
                        w(e3.naturalWidth), S(e3.naturalHeight)
                    };
                if (e3.onload = t3, e3.complete) {
                    t3(), x();
                    const e4 = d2.current,
                        r2 = f.current;
                    if (!e4 || !r2) return;
                    E(e4, m), s2(e4, r2, m, 0, 3, 1, 2, n2 < l2 || !(n2 > l2)), console.log("intrinsic Length:", b), console.log("intrinsic Height:", k)
                }
                return () => {
                    e3.onload = null
                }
            }, [k, b]), (0, r.useEffect)(() => {
                x();
                const e3 = d2.current,
                    t3 = f.current;
                if (console.log("current crop area: ", e3), console.log("current post card", t3), !e3 || !t3) return;
                E(e3, m), n2 > 0 && l2 > 0 && s2(e3, t3, m, 0, 3, 1, 2, n2 === l2 || n2 < l2);
                const r2 = r3 => {
                        if (r3.preventDefault(), g) {
                            let a3 = r3.pageX - p,
                                o3 = r3.pageY - h;
                            console.log("Touch moved by: ", a3, o3);
                            const i3 = Number(n2) / Number(l2);
                            Number(n2) < Number(l2) ? (Number(n2) > 400 ? (y(!0), N(e3, a3, i3, 400, t3), console.log("length < height: ", Number(n2))) : (y(!0), N(e3, a3, i3, Number(n2), t3)), p = r3.pageX) : Number(n2) > Number(l2) ? (y(!1), C(e3, o3, i3, Math.min(300, Number(l2)), t3), h = r3.pageY) : (y(!0), N(e3, a3, i3, 400, t3), p = r3.pageX)
                        }
                    },
                    a2 = () => {
                        g = !1, i2(!1)
                    },
                    u3 = r3 => {
                        if (r3.preventDefault(), g) {
                            let a3 = r3.touches[0].pageX - p,
                                i3 = r3.touches[0].pageY - h;
                            const u4 = Number(n2) / Number(l2);
                            o2 > 120 ? Number(n2) < Number(l2) ? (y(!0), N(e3, a3, u4, Math.min(400, Number(n2)), t3), p = r3.touches[0].pageX) : Number(n2) > Number(l2) ? (C(e3, i3, u4, Math.min(300, Number(l2)), t3), h = r3.touches[0].pageY) : (y(!0), N(e3, a3, u4, 400, t3), p = r3.touches[0].pageX) : Number(n2) < Number(l2) ? (y(!0), N(e3, a3, u4, Math.min(300, Number(n2)), t3), p = r3.touches[0].pageX) : Number(n2) > Number(l2) ? (y(!1), C(e3, i3, u4, Math.min(300, l2), t3), h = r3.touches[0].pageY) : (y(!0), N(e3, a3, u4, 300, t3), p = r3.touches[0].pageX)
                        }
                    },
                    c3 = () => {
                        g = !1, i2(!1)
                    };
                return t3.onmousedown = function(e4) {
                    e4.preventDefault(), i2(!0), g = !0, p = e4.pageX, h = e4.pageY
                }, t3.ontouchstart = function(e4) {
                    e4.preventDefault(), i2(!0), g = !0, p = e4.touches[0].pageX, h = e4.touches[0].pageY
                }, document.addEventListener("mousemove", r2), document.addEventListener("mouseup", a2), document.addEventListener("touchmove", u3), document.addEventListener("touchend", c3), () => {
                    document.removeEventListener("mousemove", r2), document.removeEventListener("mouseup", a2), document.removeEventListener("touchmove", u3), document.removeEventListener("touchend", c3)
                }
            }, [n2, t2, l2, o2]), (0, r.useEffect)(() => {}, [c2]), (0, a.jsxs)("div", {
                // style: {
                //     boxSizing: "border-box",
                //     boxShadow: "1px 1px 12px #d7d7d7",
                //     padding: "20px",
                //     borderRadius: "20px",
                //     marginTop: "15px",
                //     marginBottom: "15px"
                // },
                children: [(0, a.jsxs)("div", {
                    className: "length-bar",
                    children: [(0, a.jsx)("span", {
                        className: "span-classes notranslate",
                        children: n2
                    }), (0, a.jsx)("span", {
                        children: "cm"
                    })]
                }), (0, a.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: [(0, a.jsx)("div", {
                        className: "image-drag-area",
                        children: (0, a.jsxs)("div", {
                            class: "image-container",
                            ref: f,
                            id: "image-drag",
                            children: [(0, a.jsx)("img", {
                                class: "image-background",
                                style: {
                                    opacity: 0,
                                },
                                src: t2
                            }), (0, a.jsx)("img", {
                                style: {
                                    borderTop: v ? "3px solid black" : "0",
                                    borderBottom: v ? "3px solid black" : "0",
                                    borderLeft: v ? "0" : "3px solid black",
                                    borderRight: v ? "0" : "3px solid black",
                                    boxSizing: "border-box",
                                    cursor: "move",
                                },
                                className: "image-crop",
                                ref: d2,
                                id: "crop",
                                src: t2
                            })]
                        })
                    }), (0, a.jsxs)("div", {
                        className: "height-bar",
                        children: [(0, a.jsx)("span", {
                            className: "span-classes",
                            children: l2
                        }), (0, a.jsx)("span", {
                            children: "cm"
                        })]
                    })]
                })]
            })
        },
        i = "data:image/png;base64,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",
        u = function() {
            const [e2, n2] = (0, r.useState)(!1), [t2, l2] = (0, r.useState)(100), [u2, s2] = (0, r.useState)(100), [c2, f] = (0, r.useState)(""), [p, h] = (0, r.useState)(!0), [m, g] = (0, r.useState)(""), [v, y] = (0, r.useState)(""), [b, w] = (0, r.useState)(window.innerWidth), [k, S] = (0, r.useState)(navigator.language), [x, E] = (0, r.useState)(0), [N, C] = (0, r.useState)(!1), [_, z] = (0, r.useState)("\u20AC"), [P, L] = (0, r.useState)(!1), [T, j] = (0, r.useState)(!1), [R, M] = (0, r.useState)(null), I = (0, r.useContext)(d);
            console.log("Context: ", I), (0, r.useEffect)(() => {
                const e3 = document.getElementById("wallpaper_preview"),
                    n3 = e3.getAttribute("data-product-image"),
                    t3 = e3.getAttribute("data-variant-id"),
                    r2 = e3.getAttribute("data-product-price"),
                    l3 = e3.getAttribute("data-discount-code");
              let variantIds = Array.from(document.querySelectorAll('input[name="variantIds"]'));
              var variantIdsArray = variantIds.map(input => input.value);

              /* Custom */
              const propertiesName = `
              <div class="wrap-properties-name input-container">
              <label>
                <div style="font-size: 16px; font-weight: bold;">Prénom:</div>
                <div class="dimsouter">
                  <input type="text" class="properties-name-input" name="properties[Prénom]" value="">
                </div>
              </label>
              </div>`;
              document.querySelector('.length-width-input').insertAdjacentHTML( 'beforebegin', propertiesName );

              console.log(">>>> discount code new: ", variantIdsArray);
              
                console.log(">>>> discount code: ", t3);
                const a2 = r2.match(/([^\d]+)?([\d,.]+)/),
                    o2 = a2 ? a2[1] : "";
                let i2 = a2 ? a2[2] : "";
                i2 = i2.replace(",", "."), g(l3), y(n3), h(t3), E(i2), z(o2)
            }, []), (0, r.useEffect)(() => {
                const e3 = () => {
                    w(window.innerWidth), n2(!1), C(!1), window.innerWidth > 120 && j(!1)
                };
                return window.addEventListener("resize", e3), () => {
                    console.log("COMPONENT_UNMOUNTED", b), window.removeEventListener("resize", e3)
                }
            }, [b]);
            const D = (e3, n3, t3, r2, l3, a2, o2, i2) => {
                console.log("clip coordinates", t3);
                const u3 = document.createElement("canvas"),
                    s3 = u3.getContext("2d"),
                    c3 = document.getElementById("crop");
                let d2 = c3.naturalWidth,
                    f2 = c3.naturalHeight;
                console.log("is Drag horizontal:", i2), console.log("intrinsic height:", f2), console.log("intrinsic length:", d2);
                let p2 = t3[a2] <= d2 ? t3[a2] === 300 ? 400 : t3[a2] : d2,
                    h2 = t3[o2] <= f2 ? t3[o2] : f2,
                    m2 = p2 - t3[l3],
                    g2 = h2 - t3[r2];
                m2 === 300 && (m2 = 400), (m2 <= 0 || g2 <= 0) && (console.error("Invalid canvas width or height! Adjusting to default values."), m2 = d2, g2 = f2), u3.width = m2, u3.height = g2, console.log("width: ", m2, "height: ", g2), console.log("post card:", n3.querySelector("img")), s3.drawImage(n3.querySelector("img"), t3[l3], t3[r2], m2, g2, 0, 0, m2, g2);
                const v2 = u3.toDataURL("image/png");
                M(v2)
            };
            (0, r.useEffect)(() => {
                const e3 = new MutationObserver(() => {
                    const e4 = document.documentElement.lang;
                    e4 !== k && (S(e4), C(!1))
                });
                return e3.observe(document.documentElement, {
                    attributes: !0,
                    attributeFilter: ["lang"]
                }), () => {
                    e3.disconnect()
                }
            }, [k]);
            const {
                rolls: A,
                price: F
            } = (() => {
                const e3 = Number(t2) + 0,
                    n3 = e3 / 100 * ((Number(u2) + 0) / 100);
                console.log("area: ", e3);
                const r2 = n3 * x;
                return console.log("price:", r2), {
                    rolls: Math.ceil(n3),
                    price: r2.toFixed(2)
                }
            })(), O = e3 => {
                e3.preventDefault(), t2 === 0 || u2 === 0 ? L(!0) : (L(!1), b < 120 && j(!0), C(!0))
            }, U = async (e3, n3) => {
                let {
                    variantId: t3,
                    quantity: r2,
                    length: l3,
                    height: a2,
                    rolls: o2
                } = n3;
                if (e3.preventDefault(), !R) return void console.error("No cropped image available");
                const i2 = R.split(",")[1],
                    u3 = await fetch(`data:image/png;base64,${i2}`).then(e4 => e4.blob()),
                    s3 = new File([u3], "croppedImage.png", {
                        type: "image/png"
                    }),
                    {
                        fileUrl: c3
                    } = await W({
                        file: s3
                    });
                c3 && (console.log("file Url", c3), B({
                    variantId: t3,
                    quantity: r2,
                    length: l3,
                    height: a2,
                    rolls: o2,
                    fileUrl: c3
                }))
            }, B = e3 => {
                let {
                    variantId: n3,
                    quantity: t3,
                    length: r2,
                    height: l3,
                    rolls: a2,
                    fileUrl: o2
                } = e3;
              let prenom_value = document.querySelector(".properties-name-input").value;
                try {
                    let e4 = {
                        items: [{
                            id: n3,
                            quantity: t3,
                            properties: {
                                Prénom: prenom_value,
                                Largeur: r2,
                                Hauteur: l3,
                                Rolls: a2,
                                ImageURL: o2
                            }
                        }]
                    };
                    fetch("https://" + window.location.host + "/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(e4)
                    }).then(e5 => e5.json()).then(e5 => {
                        console.log("Success:", e5), window.location.href = `https://${window.location.host}/cart`
                    }).catch(e5 => {
                        console.error("Error:", e5)
                    })
                } catch (i2) {
                    console.error("Caught Error:", i2)
                }
            }, W = async e3 => {
                let {
                    file: n3
                } = e3;
                try {
                    console.log("files", n3);
                    const e4 = new FormData;
                    e4.append("avatar", n3);
                    for (let n4 of e4.entries()) console.log(`${n4[0]}: ${n4[1]}`);
                    const t3 = await fetch(`https://${window.location.host}/apps/test/api/image_upload`, {
                            method: "POST",
                            body: e4
                        }),
                        r2 = await t3.json();
                    return console.log("Success:", r2), {
                        fileUrl: r2.fileUrl
                    }
                } catch (t3) {
                    throw console.error("Caught Error:", t3), new Error("Image upload failed")
                }
            };

            const inputElement = document.getElementById("variantIds");
            console.log(">>>>> Pankaj inputElement.value", inputElement.value);
            const variantIdsArray = JSON.parse(inputElement.value);
          console.log(">>>>> Pankaj variantIdsArray", variantIdsArray)
          
            return (0, a.jsxs)("div", {
                className: "configurator",
                children: [b < 120 ? (0, a.jsxs)("div", {
                    children: [(0, a.jsxs)("h2", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "4px"
                        },
                        children: ["Prix: ", _, x, "/m\xB2 "]
                    }), (0, a.jsx)("h2", {
                        style: {
                            fontSize: "16px",
                            fontWeight: "bold",
                            marginBottom: "4px"
                        },
                        children: "\u{1F4CF} ENTREZ LA TAILLE DE VOTRE MUR "
                    }), (0, a.jsx)("p", {
                        style: {
                            fontSize: "12px",
                            marginBottom: "0px"
                        },
                        children: "Mesurez la surface qui doit \xEAtre recouverte, ajoutez 5 \xE0 10cm de marge de s\xE9curit\xE9."
                    }), (0, a.jsxs)("div", {
                        className: "length-width-input",
                        children: [(0, a.jsx)("div", {
                            className: "input-container",
                            children: (0, a.jsxs)("label", {
                                children: [(0, a.jsx)("div", {
                                    style: {
                                        fontSize: 16,
                                        fontWeight: "bold"
                                    },
                                    children: "Hauteur:"
                                }), (0, a.jsxs)("div", {
                                    className: "dimsouter",
                                    children: [(0, a.jsx)("input", {
                                        type: "number",
                                        className: "dimention_input",
                                        value: u2,
                                        name: "height",
                                       onChange: e3 => {
                                            const n3 = e3.currentTarget.value;
                                            n3.length < 6 && n3 > -1 && s2(n3), L(n3.length === 0)
                                        }
                                    }), (0, a.jsx)("span", {
                                        children: "cm"
                                    })]
                                })]
                            })
                        }), (0, a.jsx)("div", {
                            className: "input-container",
                            children: (0, a.jsxs)("label", {
                                children: [(0, a.jsx)("div", {
                                    style: {
                                        fontSize: 16,
                                        fontWeight: "bold"
                                    },
                                    children: "Largeur:"
                                }), (0, a.jsxs)("div", {
                                    className: "dimsouter",
                                    children: [(0, a.jsx)("input", {
                                        type: "number",
                                        name: "length",
                                        className: "dimention_input",
                                        value: t2,
                                        onChange: e3 => {
                                            const n3 = e3.currentTarget.value;
                                            n3.length < 6 && n3 > -1 && l2(n3), L(n3.length === 0)
                                        }
                                    }), (0, a.jsx)("span", {
                                        children: "cm"
                                    })]
                                })]
                            })
                        })]
                    }), P && (0, a.jsx)("div", {
                        style: {
                            color: "red"
                        },
                        children: "Length and height should be greater than 0"
                    }), (0, a.jsxs)("h2", {
                        class: "dimension_rolls",
                        children: ["Vous recevrez ", A, " rouleaux"]
                    }), (0, a.jsx)("button", {
                        class: "show-wallpaper-button",
                        onClick: O,
                        children: "Afficher le papier peint et le prix"
                    })]
                }) : (0, a.jsx)("div", {
                    children: (0, a.jsxs)("div", {
                        className: N ? "product-preview-card" : "product-preview-card active",
                        children: [(0, a.jsxs)("div", {
                            className: "preview-card",
                            children: [!N && (0, a.jsxs)("div", {
                                className: "popup",
                                children: [(0, a.jsxs)("h3", {
                                    style: {
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        marginBottom: "4px"
                                    },
                                    children: ["1) Mesurez le mur à tapisser"]
                                }),(0, a.jsxs)("h3", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        marginBottom: "4px"
                                    },
                                }), (0, a.jsx)("h3", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        marginBottom: "0px"
                                    },
                                    children: "\u{1F4CF} ENTREZ LA TAILLE DE VOTRE MUR "
                                }), (0, a.jsx)("h3", {
                                    style: {
                                        fontSize: "12px",
                                      
                                    },
                                    children: (0, a.jsx)("span", {
                                        children: "Nous ajoutons une marge de s\xE9curit\xE9 de 5 \xE0 10 centim\xE8tres"
                                    })
                                }), (0, a.jsxs)("div", {
                                    className: "length-width-input",
                                    children: [(0, a.jsx)("div", {
                                        className: "input-container",
                                        children: (0, a.jsxs)("label", {
                                            children: [(0, a.jsx)("div", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                },
                                                children: "Hauteur:"
                                            }), (0, a.jsxs)("div", {
                                                className: "dimsouter",
                                                children: [(0, a.jsx)("input", {
                                                    type: "number",
                                                    className: "dimention_input",
                                                    value: u2,
                                                    name: "height",
                                                    maxLength: 5,
                                                    minLength: 1,
                                                    max: 5,
                                                    onChange: e3 => {
                                                        const n3 = e3.currentTarget.value;
                                                        n3.length < 6 && n3 > -1 && s2(n3), L(n3.length === 0)
                                                    }
                                                }), (0, a.jsx)("span", {
                                                    children: "cm"
                                                })]
                                            })]
                                        })
                                    }), (0, a.jsx)("div", {
                                        className: "input-container",
                                        children: (0, a.jsxs)("label", {
                                            children: [(0, a.jsx)("div", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: "bold"
                                                },
                                                children: "Largeur:"
                                            }), (0, a.jsxs)("div", {
                                                className: "dimsouter",
                                                children: [(0, a.jsx)("input", {
                                                    type: "number",
                                                    name: "length",
                                                    className: "dimention_input",
                                                    value: t2,
                                                    minLength: 1,
                                                    max: 5,
                                                    min: 1,
                                                    maxLength: 5,
                                                    onChange: e3 => {
                                                        const n3 = e3.currentTarget.value;
                                                        n3.length < 6 && n3 > -1 && l2(n3), L(n3.length === 0)
                                                      
                                                    }
                                                }), (0, a.jsx)("span", {
                                                    children: "cm"
                                                })]
                                            })]
                                        })
                                    })]
                                }), P && (0, a.jsx)("div", {
                                    style: {
                                        color: "red"
                                    },
                                    children: "Length and height should be greater than 0"
                                }), (0, a.jsx)("div", {
                                    class: "dimension_rolls",
                                    children: (0, a.jsx)("input", {
                                        class: "required",
                                        id: "rolls",
                                        name: "properties[Rolls]",
                                        value: `Vous recevrez ${A} rouleaux`
                                    })
                                }), (0, a.jsx)("button", {
                                    class: "show-wallpaper-button",
                                    onClick: O,
                                    children: "Voir mon Papier Peint"
                                })]
                            }),(0, a.jsxs)("div",  {
                              style: {
                                  boxSizing: "border-box",
                                  boxShadow: "1px 1px 12px #d7d7d7",
                                  padding: "20px",
                                  borderRadius: "20px",
                                  marginTop: "15px",
                                  marginBottom: "15px"
                              },
                                className: "imageOuter",
                                children: [(0, a.jsx)
                                ("h3", {
                                  style: {
                                        flex: 1
                                    },
                                  className: "product-meta__title heading h1",
                                  children: "2) Recadrez votre papier peint"
                                }),(0, a.jsx)(o, {
                                className: 'product-image',
                                productImage: v,
                                height: u2,
                                length: t2,
                                screenWidth: b,
                                isDrag: e2,
                                setDrag: n2,
                                onSaveCroppedImage: D,
                                showWallpaper: N
                              })
                              ]})
                              ]
                            })
                              ,
                                (0, a.jsxs)("div",  {
                                className: "buttons-area",
                                children: [(0, a.jsx)
                                ("h3", {
                                  style: {
                                        flex: 1
                                    },
                                  className: "product-meta__title heading h1",
                                  children: "3) Quel papier vous convient le mieux ?"
                                }),
                                //     ("div", {
                                //     style: {
                                //         flex: 1
                                //     },
                                //     children: (0, a.jsx)("button", {
                                //         className: "modify-button",
                                //         onClick: e3 => {
                                //             e3.preventDefault(), C(!1)
                                //         },
                                //         children: (0, a.jsxs)("div", {
                                //             className: "modify-button-text",
                                //             children: [(0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 children: "Modifier"
                                //             }), (0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 "data-translate": "false",
                                //                 children: t2
                                //             }), (0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 children: "X"
                                //             }), (0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 "data-translate": "false",
                                //                 children: u2
                                //             }), (0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 "data-translate": "false",
                                //                 children: (u2 * t2 / 1e4).toFixed(2)
                                //             }), (0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 children: "m\xB2"
                                //             })]
                                //         })
                                //     })
                                // })  
                               ,(0, a.jsx)("div", {
                                className: "paper-type-wrapper",
                                children: (0, a.jsx)("div", {
                                className: "inner-div-flex",
                                style: {
                                    display: 'flex', flexDirection: 'space-between'
                                },
                                children: variantIdsArray.map((product, index) => (
                                (0, a.jsxs)("label", {
                                className: `radio-option ${index == 0? "activeVariant": ""}`,
                                onClick: () => {
                                    const radioButtons = document.querySelectorAll(".radio-option");
                                    radioButtons.forEach(button => button.classList.remove("activeVariant"));
                                    document.getElementById(`premium-paper-${index}`).classList.add("activeVariant");

                                    selectedProductId = product.id;
                                    document.querySelector('.calculatedPrice').textContent = (A * (product.price / 100).toFixed(2)).toFixed(2) + "€"
                                },
                                children: [
                                  (0, a.jsx)("input", {
                                    className: `paper-type`,
                                    id: `premium-paper-${index}`,
                                    type: "radio",
                                    name: "papier",
                                    value: product.id,
                                  }),
                                  (0, a.jsx)("b", {
                                    children: product.title,
                                  }),
                                  (0, a.jsx)("span", {
                                    style: {
                                      fontSize: "14px",
                                      color: "#000",
                                      display: "block",
                                      marginTop: "7px",
                                    },
                                    children: descriptions[index],
                                  }),
                                ],
                                }),
                                //   (0, a.jsx)("button", {
                                //     className: "add-to-cart-button",
                                //     onClick: e3 => {
                                //         U(e3, {
                                //             variantId: product.id,
                                //             quantity: A,
                                //             length: t2,
                                //             height: u2,
                                //             rolls: `Vous recevrez ${A} rouleaux`
                                //         })
                                //     },
                                //     children: (0, a.jsxs)("div", {
                                //         className: "add-to-cart-area",
                                //         children: [(0, a.jsxs)("div", {
                                //             style: {
                                //                 marginRight: "10px"
                                //             },
                                //             children: [(0, a.jsx)("div", {
                                //                 style: {
                                //                     fontSize: "13px",
                                //                     fontWeight: "bold"
                                //                 },
                                //                 children: (0, a.jsx)("span", {
                                //                     children: product.title
                                //                 })
                                //             }), (0, a.jsx)("div", {
                                //                 style: {
                                //                     fontSize: "13px",
                                //                     fontWeight: "bold"
                                //                 },
                                //                 children: (0, a.jsx)("span", {
                                //                     children: "Produit et exp\xE9di\xE9 en 4 jours"
                                //                 })
                                //             })]
                                //         }), (0, a.jsxs)("div", {
                                //             className: "add-to-cart-price-text-style",
                                //             children: [(0, a.jsx)("span", {
                                //                 className: "span-classes notranslate",
                                //                 "data-translate": "false",
                                //                 children: (A * (product.price / 100).toFixed(2)).toFixed(2)
                                //             }), (0, a.jsx)("span", {
                                //                 children: _
                                //             })]
                                //         })]
                                //     })
                                // })
                              ))
                            })
                            })]
                        }),
                        (0, a.jsx)("button", {
                        id: "cropperButton",
                        className: "configurator_button",
                        onClick: e3 => {
                            U(e3, {
                                variantId: selectedProductId || variantIdsArray[0].id,
                                quantity: A,
                                length: t2,
                                height: u2,
                                rolls: `Vous recevrez ${A} rouleaux`
                            })
                        },
                        children: (0, a.jsxs)("span", {
                          className: "calculated_price_wrapper",
                          children: [
                            (0, a.jsx)("span", {
                              children: "Ajouter au panier"
                            }),
                            (0, a.jsx)("span", {
                              children: " • "
                            }),
                            (0, a.jsx)("span", {
                              className: "calculatedPrice",
                              style: {
                                fontSize: "20px",
                                color: "#2e2e2e",
                                marginLeft: "3px"
                              },
                              children: (A * (variantIdsArray[0]?.price / 100).toFixed(2)).toFixed(2) + "€"
                            }),
                            (0, a.jsx)("span", {
                              style: {
                                display: "inline-block",
                                marginLeft: "15px",
                                verticalAlign: "middle"
                              },
                              children: (0, a.jsx)("img", {
                                className: "arrow-image-btn",
                                src: "https://cdn.shopify.com/s/files/1/0657/3100/2634/files/right-arrow.png?v=1713547455",
                                width: "15",
                                marginTop: "15px",
                              })
                            })
                          ]
                        })
                      })]
                    })
                }), T && (0, a.jsxs)("div", {
                    className: "main-configurator-window-full-screen",
                    children: [(0, a.jsxs)("div", {
                        style: {
                            display: "block",
                            justifyContent: "space-between",
                            flexDirection: "row",
                            margin: "10px"
                        },
                        children: [(0, a.jsx)("div", {
                            onClick: () => {
                                j(!1)
                            },
                            style: {
                                fontSize: "16px",
                                fontWeight: "bold",
                                marginBottom: "4px"
                            },
                            children: "Modifier"
                        }), (0, a.jsx)("div", {
                            style: {
                                fontSize: "13px",
                                fontWeight: "bold",
                                marginBottom: "4px"
                            },
                            onClick: () => {
                                j(!1)
                            },
                            children: "Fermer"
                        })]
                    }), (0, a.jsx)("div", {
                        children: (0, a.jsx)(o, {
                            productImage: v,
                            height: u2,
                            length: t2,
                            screenWidth: b,
                            isDrag: e2,
                            setDrag: n2,
                            onSaveCroppedImage: D
                        })
                    }), (0, a.jsxs)("div", {
                        style: {
                            margin: "20px"
                        },
                        children: [(0, a.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                marginBottom: "10px",
                                marginLeft: "10px"
                            },
                            children: [(0, a.jsx)("div", {
                                style: {
                                    marginRight: "8px"
                                },
                                children: (0, a.jsx)("img", {
                                    src: i,
                                    height: 24,
                                    width: 24
                                })
                            }), (0, a.jsx)("div", {
                                style: {
                                    textAlign: "left",
                                    fontWeight: "bold"
                                },
                                children: "Livraison Suivie Offerte"
                            })]
                        }), (0, a.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                marginBottom: "10px",
                                marginLeft: "10px"
                            },
                            children: [(0, a.jsx)("div", {
                                style: {
                                    marginRight: "8px"
                                },
                                children: (0, a.jsx)("img", {
                                    src: i,
                                    height: 24,
                                    width: 24
                                })
                            }), (0, a.jsxs)("div", {
                                style: {
                                    textAlign: "left"
                                },
                                children: ["Produit & ", (0, a.jsx)("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: "exp\xE9di\xE9 en 48 heures"
                                })]
                            })]
                        }), (0, a.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                marginBottom: "10px",
                                marginLeft: "10px"
                            },
                            children: [(0, a.jsx)("div", {
                                style: {
                                    marginRight: "8px"
                                },
                                children: (0, a.jsx)("img", {
                                    src: i,
                                    height: 24,
                                    width: 24
                                })
                            }), (0, a.jsxs)("div", {
                                style: {
                                    textAlign: "left"
                                },
                                children: ["Finition anti reflet (", (0, a.jsx)("span", {
                                    style: {
                                        fontWeight: "bold"
                                    },
                                    children: "250gr/m2"
                                }), ")"]
                            })]
                        }), m && (0, a.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                marginBottom: "10px",
                                marginLeft: "10px"
                            },
                            children: [(0, a.jsx)("div", {
                                style: {
                                    marginRight: "8px"
                                },
                                children: (0, a.jsx)("img", {
                                    src: i,
                                    height: 24,
                                    width: 24
                                })
                            }), (0, a.jsx)("div", {
                                style: {
                                    fontWeight: "bold",
                                    textAlign: "left"
                                },
                                children: m
                            })]
                        }), (0, a.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: (0, a.jsx)("button", {
                                className: "add-to-cart-button",
                                onClick: e3 => {
                                    U(e3, {
                                        variantId: p,
                                        quantity: A,
                                        length: t2,
                                        height: u2,
                                        rolls: `Vous recevrez ${A} rouleaux`
                                    })
                                },
                                children: (0, a.jsxs)("div", {
                                    className: "add-to-cart-area",
                                    children: [(0, a.jsx)("div", {
                                        style: {
                                            fontSize: "18px",
                                            fontWeight: "bold",
                                            display: "flex",
                                            alignItems: "center",
                                            marginRight: "10px"
                                        },
                                        children: (0, a.jsx)("span", {
                                            children: "Finaliser la commande"
                                        })
                                    }), (0, a.jsxs)("div", {
                                        className: "add-to-cart-price-text-style",
                                        children: [(0, a.jsx)("span", {
                                            className: "span-classes notranslate",
                                            "data-translate": "false",
                                            children: (A * x).toFixed(2)
                                        }), (0, a.jsx)("span", {
                                            children: _
                                        })]
                                    })]
                                })
                            })
                        })]
                    })]
                })]
            }, k)
        },
        s = e2 => {
            e2 && e2 instanceof Function && t.e(453).then(t.bind(t, 453)).then(n2 => {
                let {
                    getCLS: t2,
                    getFID: r2,
                    getFCP: l2,
                    getLCP: a2,
                    getTTFB: o2
                } = n2;
                t2(e2), r2(e2), l2(e2), a2(e2), o2(e2)
            })
        },
        c = l.createRoot(document.getElementById("wallpaper_preview")),
        d = (0, r.createContext)(null);
    c.render((0, a.jsx)(r.StrictMode, {
        children: (0, a.jsx)(d.Provider, {
            value: {
                coordinates: [0, 400, 600, 0],
                helloWorld: () => (console.log("Hello world function called!"), (0, a.jsx)(a.Fragment, {
                    children: "Hello world"
                }))
            },
            children: (0, a.jsx)(u, {})
        })
    })), s()
})();
//# sourceMappingURL=/cdn/shop/t/31/assets/wallpaper_preview.js.map?v=181147495892281216891735275898